const messages = {
  pt: {
    translations: {
      courses: {
        close: "Fechar",
        commentsFeed: "Comentários dos usuários",
        feedEmpty: "Nenhum comentário ainda.",
        coverLabel: "Imagem de capa (opcional — sem ela, usamos a miniatura do vídeo)",
        firstVideo: "Link do vídeo do YouTube (opcional)",
        firstVideoHelp: "Cria a primeira aula já com este vídeo. Você adiciona mais aulas depois.",
        newPrefix: "Novo",
        editPrefix: "Editar",
        pageTitleLabel: "Nome da página",
        itemLabelLabel: "Nome do item (singular)",
        buttonPreview: "Botão ficará",
        uploadCover: "Enviar imagem",
        coverUploaded: "Imagem enviada.",
        emptyAdmin: "Nenhum item ainda. Clique em",
        emptyAdmin2: "para criar o primeiro.",
        noLessonsAdmin: "Este curso ainda não tem aulas. Clique em \"Nova aula\" para adicionar um vídeo do YouTube, um PDF ou um texto.",
        noLessonsUser: "Este curso ainda não tem aulas publicadas.",
        commentsHint: "Deixe sua dúvida aqui — a equipe responde por aqui mesmo.",
        editPage: "Editar nome e descrição da página",
        backTo: "Voltar para",
        title: "Cursos",
        newCourse: "Novo curso",
        editCourse: "Editar curso",
        courseTitle: "Título",
        description: "Descrição",
        coverUrl: "URL da imagem de capa",
        companies: "Empresas que veem",
        companiesSelected: "empresa(s)",
        status: "Status",
        active: "Ativo",
        inactive: "Inativo",
        save: "Salvar",
        cancel: "Cancelar",
        remove: "Remover",
        removed: "Curso removido.",
        saved: "Curso salvo.",
        removeConfirm: "Remover este curso e suas aulas?",
        titleRequired: "Informe o título.",
        empty: "Nenhum curso disponível ainda.",
        back: "Voltar aos cursos",
        lessons: "Aulas",
        lessonsShort: "aulas",
        noLessons: "Nenhuma aula ainda.",
        newLesson: "Nova aula",
        editLesson: "Editar aula",
        lessonTitle: "Título da aula",
        lessonKind: "Tipo",
        kindVideo: "Vídeo (YouTube)",
        kindPdf: "PDF",
        kindText: "Texto",
        videoUrl: "Link do YouTube",
        pdfUrl: "URL do PDF",
        lessonBody: "Texto de apoio / conteúdo",
        lessonSaved: "Aula salva.",
        lessonRemoved: "Aula removida.",
        lessonTitleRequired: "Informe o título da aula.",
        removeLessonConfirm: "Remover esta aula?",
        openPdf: "Abrir PDF",
        badVideo: "Link de vídeo inválido.",
        comments: "Comentários",
        noComments: "Seja o primeiro a comentar.",
        writeComment: "Escreva um comentário...",
        writeReply: "Escreva uma resposta...",
        reply: "Responder",
        send: "Enviar",
        removeCommentConfirm: "Remover este comentário?",
        editDesc: "Editar descrição",
        descSaved: "Descrição salva.",
        descPlaceholder: "Escreva a descrição da área de cursos...",
        noDesc: "Área de cursos e treinamentos."
      },
      salesAgents: {
        fieldLabel: "Nome do campo",
        fieldKey: "Chave",
        fieldType: "Tipo",
        fieldRequired: "Obrigatório",
        addField: "Adicionar campo",
        schedulingOn: "Permitir agendar",
        meet: "Criar link do Meet",
        title: "Automação e Qualificação",
        new: "Novo agente",
        name: "Nome do agente",
        nameRequired: "Informe o nome do agente.",
        prompt: "Prompt de conversa",
        template: "Template de Extração de Dados",
        identification: "Identificação",
        fields: "O que o agente precisa descobrir",
        extraction: "Como a IA lê a conversa",
        knowledge: "Conhecimento e mídias",
        knowledgeUpload: "Enviar mídia",
        knowledgeEmpty: "Nenhuma mídia ainda.",
        knowledgeUploaded: "Mídia enviada.",
        knowledgeRemoved: "Item removido.",
        knowledgeRemoveConfirm: "Remover este item?",
        onQualify: "Quando qualificar",
        onDisqualify: "Quando desqualificar",
        scheduling: "Agendamento",
        tag: "Etiqueta",
        kanban: "Etapa do Kanban",
        queue: "Fila",
        user: "Atendente",
        transfer: "Transferir para humano",
        duplicate: "Duplicar",
        duplicated: "Agente duplicado.",
        remove: "Remover",
        removed: "Agente removido.",
        save: "Salvar",
        saved: "Agente salvo!",
        cancel: "Cancelar",
        activeOn: "Ativo",
        activeOff: "Pausado",
        none: "Nenhum",
        empty: "Nenhum agente comercial configurado ainda.",
        minValue: "Valor mínimo",
        maxValue: "Valor máximo",
        duration: "Duração (min)"
      },
      promissoryNotes: {
        title: "Notas Promissórias",
        installments: "Parcelas",
        firstDueDate: "1º Vencimento",
        paymentCondition: "Condições de Pagamento",
        cash: "À Vista",
        promissory: "A Prazo com Notas Promissórias",
        status: {
          aguardando: "Aguardando Assinatura",
          concluida: "Assinada (Válida)",
          cancelada: "Cancelada",
          expirada: "Expirada"
        },
        downloadPdf: "Baixar PDF Oficial",
        resendLink: "Reenviar Link",
        cancelPromissories: "Cancelar Promissórias"
      },
      agentTemplates: {
        title: "Modelos de Agente",
        new: "Novo modelo",
        label: "Nome do modelo",
        labelRequired: "Informe o nome do modelo.",
        description: "Descrição curta",
        scope: "Aplica-se a",
        scopeBoth: "Ambos",
        scopeConversation: "Conversa",
        scopeCommercial: "Comercial",
        niche: "Nicho (opcional)",
        promptTitle: "Prompt de conversa",
        extractionTitle: "Instruções de extração (agente comercial)",
        duplicate: "Duplicar",
        duplicated: "Modelo duplicado.",
        remove: "Remover",
        removed: "Modelo removido.",
        removeConfirm: "Remover este modelo?",
        save: "Salvar",
        saved: "Modelo salvo!",
        cancel: "Voltar",
        empty: "Nenhum modelo ainda.",
        systemLocked: "Modelo de sistema (somente leitura)"
      },
      whatsappQuality: {
        title: "Qualidade do número",
        connection: "Conexão",
        official: "Qualidade Meta (API Oficial)",
        notes: "Observações",
        checkedAt: "Última consulta",
        refresh: "Atualizar agora",
        close: "Fechar",
        empty: "Sem dados."
      },
      geoReport: {
        contactsTitle: "Contatos",
        contactsHelp: "Cada contato com o local inferido pelo número. Use o filtro para conferir quem caiu em cada região.",
        searchPlaceholder: "Buscar por nome ou número...",
        filterLocation: "Local",
        allLocations: "Todos os locais",
        noContacts: "Nenhum contato para este filtro.",
        contactName: "Nome",
        contactNumber: "Número",
        contactState: "Estado",
        contactRegion: "Região",
        contactCountry: "País",
        exportPdf: "Exportar PDF",
        exporting: "Gerando...",
        regions: { north: "Norte", northeast: "Nordeste", midwest: "Centro-Oeste", southeast: "Sudeste", south: "Sul" },
        title: "Contatos por Região",
        start: "Início",
        end: "Fim",
        filter: "Filtrar",
        totalContacts: "Contatos no período",
        mapped: "Localizados",
        unmapped: "Não identificados",
        byRegion: "Contatos por região",
        inferred: "Distribuição inferida pelo DDD/DDI do número. Número portado, linha corporativa ou fixo antigo podem cair na região errada.",
        topStates: "Top estados",
        topStatesHelp: "Os 12 estados com mais contatos no período.",
        noStates: "Nenhum contato brasileiro identificado no período.",
        otherCountries: "Outros países",
        countriesHelp: "Contatos com DDI fora do Brasil.",
        noInternational: "Nenhum contato internacional detectado."
      },
      utmLinks: {
        newLink: "Novo link de campanha",
        preview: "Prévia do link",
        previewEmpty: "Escolha a conexão ou informe o número para ver o link.",
        useConnection: "Usar número de uma conexão",
        useManual: "Informar número manualmente",
        noConnections: "Nenhuma conexão com número disponível.",
        reportMoved: "O relatório de anúncios ficou em Relatórios → Relatório de Anúncios.",
        title: "Links UTM",
        tabs: { links: "Meus links", report: "Relatório de anúncios" },
        help: "Crie um link por anúncio. O código no fim da mensagem é o que identifica de onde o lead veio — não apague nem edite esse trecho ao usar o link no anúncio.",
        reportHelp: "Leads e atendimentos gerados por cada anúncio. O lead entra aqui quando envia a primeira mensagem pelo link.",
        fields: {
          connection: "Conexão",
          name: "Nome do link", source: "Origem", medium: "Meio",
          campaign: "Campanha", content: "Anúncio / criativo",
          number: "Número do WhatsApp (com DDI)", message: "Mensagem pré-preenchida"
        },
        report: { converted: "Leads convertidos", leads: "Leads", tickets: "Atendimentos", closed: "Encerrados" },
        code: "Código", url: "Link para o anúncio", actions: "Ações",
        create: "Criar link", copy: "Copiar link", copied: "Link copiado!",
        remove: "Remover link", removed: "Link removido.", created: "Link criado!",
        nameRequired: "Informe o nome do link.",
        numberRequired: "Informe o número do WhatsApp com DDI.",
        emptyLinks: "Nenhum link criado ainda.",
        emptyReport: "Nenhum dado no período."
      },
      leadSource: {
        chipEmpty: "Origem",
        menuTitle: "Selecione a origem do lead",
        empty: "Nenhuma origem cadastrada",
        clear: "Limpar origem",
        saved: "Origem atualizada!",
        label: "Origem do lead",
        none: "Sem origem"
      },
      leadSourceSettings: {
        title: "Origem dos leads",
        description: "Defina de onde seus contatos vêm. O atendente escolhe a origem no cabeçalho do atendimento, e ela aparece no contato e no relatório de campanhas.",
        name: "Nome",
        icon: "Ícone",
        color: "Cor",
        add: "Adicionar",
        added: "Origem adicionada!",
        removed: "Origem removida.",
        remove: "Remover origem",
        nameRequired: "Informe o nome da origem.",
        newPlaceholder: "Nova origem",
        activeOn: "Ativa — aparece para o atendente",
        activeOff: "Inativa — não aparece para o atendente",
        icons: {
          facebook: "Facebook", instagram: "Instagram", messenger: "Messenger",
          google: "Google", tiktok: "TikTok", youtube: "YouTube",
          organic: "Orgânico", referral: "Indicação", other: "Outro"
        }
      },
      authTabs: {
        login: "Entrar",
        signup: "Cadastre-se"
      },
      welcome: {
        dontShowAgain: "Não ver esta saudação novamente",
        messages: {
          m1: "Que bom ter você por aqui. Bom atendimento!",
          m2: "Sua equipe já está esperando. Vamos lá?",
          m3: "Cada conversa é uma chance de encantar alguém.",
          m4: "Dia novo, novas oportunidades de atender bem.",
          m5: "Café na mão e tudo pronto para começar.",
          m6: "Nada como começar o dia com a caixa organizada.",
          m7: "Que hoje seja um dia leve e produtivo.",
          m8: "Um cliente bem atendido lembra disso por muito tempo.",
          m9: "Bom te ver de volta. Vamos fazer acontecer.",
          m10: "Respira fundo. Uma conversa de cada vez."
        },
        morning: "Bom dia!",
        afternoon: "Boa tarde!",
        evening: "Boa noite!",
        morningWithName: "Bom dia, {{name}}!",
        afternoonWithName: "Boa tarde, {{name}}!",
        eveningWithName: "Boa noite, {{name}}!",
        subtitle: "Que bom ter você por aqui. Bom atendimento!",
        close: "Fechar"
      },
    voiceIvr: {
      criarDestinos: "Criar transferência para cada opção",
      destinosCriados: "Transferências criadas. Escolha a fila de cada uma.",
      transferindoPara: "Aguarde, vou transferir você.",
      voz: {
        semVozEscolhida: "Nenhuma voz escolhida",
        buscarVozes: "Buscar vozes",
        escolhaVoz: "Voz",
        modeloPadrao: "Padrão do provedor",
        previa: "Prévia da voz",
        informeChave: "Informe a chave da API primeiro.",
        nenhumaVoz: "Nenhuma voz encontrada nesta conta.",
        falhaBusca: "Não foi possível consultar o provedor.",
        comecar: "Cole a chave da API e clique em Buscar vozes para carregar as vozes da sua conta.",
        titulo: "Voz da URA",
        provedor: "Provedor de voz",
        padraoServidor: "Voz padrão do servidor",
        idDaVoz: "ID da voz",
        idDaVozAjuda: "Copie o identificador da voz no painel do provedor.",
        chaveApi: "Chave da API",
        verChave: "Mostrar ou esconder a chave",
        modelo: "Modelo (opcional)",
        ajuda: "Sem escolher provedor, a URA usa a voz configurada no servidor. Piper roda na sua própria máquina, sem custo por uso.",
        avisoChave: "A chave fica guardada junto com esta URA, no servidor de voz. Use uma chave só para isso, com limite de uso, para poder revogar sem afetar o resto.",
        provedores: {
          piper: "Piper (no seu servidor)",
          elevenlabs: "ElevenLabs",
          openai: "OpenAI",
        },
      },
      titulo: "Construtor de URA",
      nova: "Nova URA",
      novaModelo: "Começar com um modelo pronto",
      novaVazia: "Começar do zero",
      editando: "Editando URA",
      editar: "Editar",
      excluir: "Excluir",
      voltar: "Voltar",
      salvar: "Salvar",
      salva: "URA salva.",
      excluida: "URA excluída.",
      ativa: "Ativa",
      inativa: "Inativa",
      passo: "Passo",
      semUras: "Nenhuma URA criada ainda.",
      semUrasDica: "Crie uma para que as ligações recebidas sejam atendidas automaticamente.",
      explicacao: "Monte o atendimento automático das ligações. Depois de salvar, vá em Conexões e escolha esta URA no campo de atendimento por voz.",
      comoFunciona: "Os passos são executados de cima para baixo. Só o menu desvia: cada opção leva ao passo que você escolher.",
      confirmarExclusao: "Excluir esta URA?",
      confirmarExclusaoTexto: "As conexões que usam esta URA voltam a tocar direto para o atendente.",
      naoEditavel: "Esta URA foi criada num formato antigo e não pode ser aberta neste editor. Crie uma nova URA com os passos desejados.",
      adicionarPasso: "Adicionar passo",
      removerPasso: "Remover passo",
      subir: "Mover para cima",
      descer: "Mover para baixo",
      adicionarOpcao: "Adicionar opção",
      removerOpcao: "Remover opção",
      seguirOrdem: "Seguir para o próximo passo",
      primeiroPasso: "Começa em",
      corrijaAntes: "Corrija antes de salvar:",
      nenhuma: "Nenhuma",
      qualquer: "Qualquer um da fila",
      colunas: {
        nome: "Nome",
        situacao: "Situação",
        acoes: "Ações",
      },
      tipos: {
        message: "Falar mensagem",
        voice_menu: "Menu de opções",
        dtmf_capture: "Pedir dígitos",
        record_audio: "Gravar recado",
        transfer: "Transferir para atendimento",
        end: "Encerrar ligação",
      },
      campos: {
        nome: "Nome da URA",
        ativa: "URA ativa",
        tipo: "Tipo do passo",
        falar: "O que a URA vai falar",
        falarAjuda: "Este texto é lido em voz alta para quem ligou.",
        menuFala: "Texto do menu",
        menuFalaAjuda: "Diga as opções em voz alta. Ex.: para Vendas, digite 1.",
        opcoes: "Opções",
        tecla: "Tecla",
        rotulo: "Nome da opção",
        irPara: "Ir para",
        teclaDica: "Use teclas de um dígito (1 a 9). Assim a URA reconhece o tom na hora, sem esperar. Quem ligou também pode falar o nome da opção.",
        tempo: "Tempo de espera (s)",
        seNaoResponder: "Se não responder",
        seNaoEntender: "Se não entender",
        pedirDigitos: "O que pedir",
        pedirDigitosAjuda: "Ex.: digite o número do seu CPF e finalize com a tecla jogo da velha.",
        maxDigitos: "Máximo de dígitos",
        guardarEm: "Guardar como",
        guardarEmAjuda: "Use {{nome}} nos textos seguintes",
        segundos: "Duração máxima (s)",
        gravarAjuda: "Grave um aviso antes deste passo, com um passo de fala, para a pessoa saber que pode começar.",
        avisoTransferencia: "Aviso antes de transferir",
        avisoTransferenciaAjuda: "Opcional. Ex.: aguarde, vou transferir você.",
        fila: "Fila",
        atendente: "Atendente",
        transferirAjuda: "A URA termina aqui: a ligação passa para o atendimento humano.",
        despedida: "Mensagem de despedida",
        despedidaAjuda: "A ligação é encerrada depois desta fala.",
      },
      erros: {
        nomeObrigatorio: "Dê um nome para a URA.",
        semPassos: "Adicione pelo menos um passo.",
        falaVazia: "Escreva o que a URA vai falar.",
        semOpcoes: "O menu precisa de pelo menos uma opção.",
        teclaRepetida: "Há duas opções com a mesma tecla.",
        semDestino: "Escolha uma fila ou um atendente para a transferência.",
      },
      title: "URA de voz (WhatsApp Plus)",
      desc: "Fluxo que atende a ligação antes do atendente. O cliente ouve o menu e escolhe pelo teclado.",
      none: "Sem URA — toca direto para o atendente",
      inactive: "(desativado)",
      empty: "Nenhum fluxo de voz cadastrado. Crie um em Automações e volte aqui para vincular."
    },
    ramais: {
      title: "Ramais internos",
      dial: "Discar ramal",
      call: "Ligar",
      callVoice: "Ligar (voz)",
      callVideo: "Ligar (vídeo)",
      empty: "Nenhum ramal cadastrado. Defina o ramal no cadastro de cada usuário.",
      extension: "ramal",
      available: "Disponível",
      onCall: "Em ligação",
      offline: "Offline",
      incoming: "Chamada recebida",
      calling: "Chamando...",
      inCall: "Em ligação",
      answer: "Atender",
      reject: "Recusar",
      hangup: "Desligar",
      mute: "Mudo",
      unmute: "Reativar som",
      transfer: "Transferir",
      transferTooltip: "Transferir esta ligação",
      close: "Fechar",
      transferredCall: "Ligação transferida",
      transferTitle: "Transferência de ligação",
      transferFrom: "{{name}} quer passar uma ligação para você.",
      accept: "Aceitar",
      noCameraLocal: "Sem câmera aqui — você vai ouvir e ver, mas só enviar voz.",
      noCameraAnswer: "Sem câmera aqui — você vai ver a outra pessoa e enviar só voz.",
      noCameraRemote: "A outra pessoa está sem câmera — você só ouve a voz dela.",
      toasts: {
        busy: "Ramal ocupado no momento.",
        notFound: "Ramal não encontrado.",
        self: "Você não pode ligar para o próprio ramal.",
        failed: "Não foi possível completar a ligação.",
        connectFailed: "Falha ao conectar a ligação.",
        alreadyInCall: "Você já está em uma ligação.",
        startFailed: "Não foi possível iniciar a ligação.",
        answerFailed: "Não foi possível atender.",
        lost: "Ligação encerrada (conexão perdida).",
        transferOffered: "Transferência oferecida para {{name}}."
      }
    },
    officialCall: {
      title: "Ligação pelo WhatsApp Oficial",
      connection: "Conexão",
      number: "Número com DDD",
      numberPlaceholder: "5511999999999",
      permissionHint: "Para ligar, o cliente precisa ter autorizado receber chamadas. Se ele nunca autorizou, a Meta recusa a ligação.",
      noConnection: "Nenhuma conexão oficial conectada. As ligações só funcionam em conexões WhatsApp Oficial.",
      incoming: "Chamada recebida",
      calling: "Chamando...",
      connecting: "Conectando...",
      inCall: "Em ligação",
      answer: "Atender",
      reject: "Recusar",
      hangup: "Desligar",
      mute: "Mudo",
      unmute: "Reativar som",
      call: "Ligar",
      close: "Fechar",
      tooltip: "Ligar pelo WhatsApp Oficial",
      toasts: {
        noSdp: "A chamada chegou sem os dados de áudio. Peça para ligar de novo.",
        typeNumber: "Digite o número com DDD.",
        chooseConnection: "Escolha a conexão oficial.",
        alreadyInCall: "Você já está em uma ligação.",
        answerFailed: "Não foi possível atender.",
        startFailed: "Não foi possível iniciar a ligação.",
        failed: "Não foi possível completar a ligação.",
        lost: "Ligação encerrada (conexão perdida).",
        rejected: "Chamada recusada.",
        missed: "Chamada não atendida.",
        callFailed: "A chamada falhou."
      }
    },
    groupGreeting: {
      cardTitle: "Saudação de boas-vindas",
      cardDesc: "Mensagem automática para quem entrar no grupo",
      dialogTitle: "Saudação de boas-vindas",
      intro: "Enviada automaticamente quando alguém entra em",
      introScope: "A configuração vale só para este grupo nesta conexão.",
      enable: "Ativar saudação neste grupo",
      whereToSend: "Onde enviar",
      inGroup: "No grupo, marcando quem entrou",
      inPrivate: "No privado do novo membro",
      privateWarning: "Quem nunca conversou com este número pode não receber a mensagem no privado — o WhatsApp bloqueia envios para desconhecidos.",
      message: "Mensagem",
      messagePlaceholder: "Ex.: {{saudacao}}, {{primeiro_nome}}! Seja bem-vindo(a) ao {{grupo}}.",
      variablesHint: "Clique para inserir uma variável:",
      preview: "Ver prévia",
      previewTitle: "Prévia (com dados de exemplo)",
      save: "Salvar",
      toasts: {
        loadError: "Não foi possível carregar a saudação deste grupo.",
        saved: "Saudação salva.",
        saveError: "Não foi possível salvar a saudação.",
        previewError: "Não foi possível gerar a prévia."
      }
    },
      googleSettings: {
        navTitle: 'Google',
        navSubtitle: 'Login e credenciais',
        title: 'Google (Login & Agenda)',
        subtitle: 'Credenciais OAuth do Google para login social e integração com o Google Agenda.',
        whereToGet: 'Google Cloud Console → APIs & Services → Credentials',
        loginSection: 'Login com Google (OAuth)',
        clientId: 'Google Client ID',
        clientSecret: 'Google Client Secret',
        calendarSection: 'Google Agenda',
        calendarClientId: 'Client ID do Google Agenda',
        calendarClientSecret: 'Client Secret do Google Agenda',
        hint: 'Dica: você pode usar o mesmo OAuth Client para o login e para a Agenda, desde que o escopo do Google Agenda esteja habilitado.',
        save: 'Salvar',
        saved: 'Credenciais do Google salvas com sucesso.',
        saveError: 'Erro ao salvar as credenciais do Google.'
      },
      voiceCampaign: {
        enable: 'Campanha de voz (liga para o contato e toca um áudio)',
        audioTitle: 'Áudio da ligação',
        record: 'Gravar',
        stop: 'Parar',
        upload: 'Enviar arquivo',
        remove: 'Remover áudio',
        savedAudio: 'Áudio salvo',
        hint: 'Grave pelo microfone ou envie um arquivo de áudio.',
        ringSeconds: 'Tocar chamando (s)',
        ringSecondsHelp: 'Tempo até considerar não atendida',
        attempts: 'Tentativas',
        attemptsHelp: 'Ligações por contato',
        sendText: 'Enviar uma mensagem de texto logo após a ligação',
        sendTextHelp: 'A mensagem é a configurada na etapa "Mensagem", com variáveis e anexo. Desmarque acima para fazer só a ligação, sem texto.',
        retryMinutes: 'Intervalo entre tentativas (min)',
        retryMinutesHelp: 'Espera antes de ligar de novo',
        errors: {
          noRecorder: 'Este navegador não permite gravar áudio. Envie um arquivo.',
          noMic: 'Não foi possível acessar o microfone. Verifique a permissão do navegador.',
          recordFailed: 'Falha ao iniciar a gravação.'
        }
      },
      sipSettings: {
        title: 'Troncal SIP',
        navSubtitle: 'Ligação via SIP',
        subtitle: 'Ligar/receber por uma linha SIP (Asterisk, FreePBX, operadora VoIP) independente do WhatsApp. Depois de salvar, use a aba "Via SIP" no discador do WhatsApp Plus.',
        warning: 'Requer o serviço de troncal SIP instalado no servidor — já é instalado automaticamente na instalação/atualização do sistema. Se o chip abaixo mostrar "SIP desconectado", rode instalador → Ferramentas → Instalar troncal SIP manualmente. Depois de trocar host/usuário/senha, pode ser necessário reiniciar o serviço manualmente para a nova conta ser lida.',
        connected: 'SIP conectado',
        disconnected: 'SIP desconectado',
        trunkEnabled: 'troncal habilitada',
        trunkDisabled: 'troncal desabilitada',
        enableTrunk: 'Habilitar troncal SIP',
        host: 'Servidor (host)',
        port: 'Porta',
        username: 'Usuário',
        usernamePlaceholder: 'ramal ou usuário da troncal',
        passwordFilled: 'Senha (preenchida — deixe em branco pra manter)',
        password: 'Senha',
        domain: 'Domínio SIP',
        domainPlaceholder: 'deixe em branco para usar o host',
        domainHelp: 'Só preencha se o domínio SIP for diferente do host/IP da troncal.',
        transport: 'Transporte',
        callerId: 'Caller ID',
        optional: 'opcional',
        save: 'Salvar',
        testCallHelp: 'Chamada de teste: depois de salvar e com o serviço SIP rodando, abra o discador do WhatsApp Plus, selecione "Via SIP" e disque um número/ramal conhecido do seu PABX.',
        saved: 'Configuração da troncal SIP salva.',
        saveError: 'Não foi possível salvar a troncal SIP.',
      },
      callModal: {
        contact: 'Contato',
        incoming: 'Chamada recebida',
        calling: 'Chamando...',
        inProgress: 'Ligação em andamento',
        finished: 'Ligação finalizada',
        ended: 'Encerrada',
      },
      dialer: {
        canais: {
          ramal: "Ramal",
          whatsapp: "WhatsApp Plus",
          oficial: "API Oficial",
          sip: "SIP",
        },
        semCanais: "Nenhum canal de ligação configurado. Fale com o administrador.",
        ramalPlaceholder: "Número do ramal",
        title: 'Discador',
        recent: 'Recentes',
        viaWhatsapp: 'Via WhatsApp',
        viaSip: 'Via SIP',
        noWhatsappConnected: 'Nenhum WhatsApp conectado.',
        sipWarning: 'Ligação via troncal SIP (independente do WhatsApp). Configure a troncal em Configurações → Troncal SIP.',
        sipNumberPlaceholder: 'Número/ramal SIP',
        numberPlaceholder: 'Número',
        audioOnly: 'Só áudio',
        videoCall: 'Chamada de vídeo',
        call: 'Ligar',
        noRecentCalls: 'Sem chamadas recentes',
        dialFailed: 'Falha ao discar',
      },
    schedulesHeader: {
      title: "Agendamento de Mensagens",
      subtitle: "Programe e visualize disparos automáticos e lembretes em calendário interativo",
      programmed: "Disparos Programados",
      schedulesWord: "agendamentos",
      cardTotal: "Total agendados",
      cardTotalHint: "Disparos registrados no sistema",
      cardToday: "Agendados para hoje",
      cardTodayHint: "Envios programados para o dia",
      cardWeek: "Próximos 7 dias",
      cardWeekHint: "Previsão da semana",
      cardPending: "Pendentes de envio",
      cardPendingHint: "Aguardando horário de disparo",
      googleCalendar: "Google Agenda",
      newSchedule: "Novo Agendamento",
    },
    scheduleGoogle: {
      connectAccount: "Conectar conta",
      notConnectedHint: "Nenhuma conta do Google conectada. Conecte uma conta para sincronizar este agendamento na agenda e gerar link do Meet.",
      title: "Integração Google Agenda & Meet",
      connectedAs: "Conectado:",
      syncCalendar: "Sincronizar no Google Agenda",
      generateMeet: "Gerar Link do Google Meet",
      eventTitle: "Título da Reunião / Assunto",
      eventTitlePlaceholder: "Ex.: Reunião com o cliente",
      duration: "Duração",
      minutes: "minutos",
      hour: "hora",
      hours: "horas",
      copyLink: "Copiar Link",
      copied: "Copiado!",
      openMeet: "Abrir Meet",
    },
      googleCalendar: {
        errors: {
          credentialsMissing: "O Google Agenda ainda não foi liberado nesta plataforma. Peça ao administrador para cadastrar o Client ID e o Client Secret do Google.",
          redirectMissing: "Não foi possível identificar o endereço do servidor para o retorno do Google. Avise o administrador.",
        },
        step1: "1. Credenciais da API do Google (OAuth 2.0)",
        step1Sub: "Configure seu Client ID e Client Secret gerados no Google Cloud Console",
        clientId: "Google Client ID",
        clientSecret: "Google Client Secret",
        redirectUri: "URI de Redirecionamento Autorizada (Cole no Google Cloud)",
        jsOrigin: "Origem JavaScript Autorizada (Cole no Google Cloud)",
        saveCredentials: "Salvar Credenciais da API",
        credentialsSaved: "Credenciais salvas.",
        credentialsFail: "Não foi possível salvar as credenciais.",
        copied: "Copiado!",
        howToTitle: "Ver Passo a Passo: Como gerar o Client ID e Client Secret no Google Cloud (2 Minutos)",
        how1: "Acesse console.cloud.google.com e crie (ou escolha) um projeto.",
        how2: "Em APIs e serviços → Biblioteca, ative a Google Calendar API.",
        how3: "Em Tela de permissão OAuth, configure como Externo e publique.",
        how4: "Em Credenciais → Criar credenciais → ID do cliente OAuth, escolha Aplicativo da Web.",
        how5: "Cole os dois valores acima nos campos de origens e URIs de redirecionamento autorizados.",
        how6: "Copie o Client ID e o Client Secret gerados e cole aqui em cima.",
        step2: "2. Conexão da Conta Google",
        step2Sub: "Conecte a conta que gerenciará as reuniões e o Meet",
        connectionStatus: "STATUS DA CONEXÃO",
        connectedAccount: "CONTA CONECTADA",
        disconnectAccount: "Desconectar Conta",
        openCalendar: "Abrir Google Agenda",
        prefsTitle: "Preferências do Google Meet & Agendamentos",
        prefsSubtitle: "Defina como os eventos e reuniões serão criados",
        autoMeet: "Gerar Google Meet Automaticamente",
        autoMeetHelp: "Cria um link de videoconferência exclusivo em cada agendamento",
        syncEvents: "Sincronizar Eventos no Google Agenda",
        syncEventsHelp: "Insere os agendamentos marcados no seu calendário do Google",
        sendInvite: "Enviar Convite por E-mail ao Cliente",
        sendInviteHelp: "O Google enviará convite automático se o contato possuir e-mail cadastrado",
        menu: "Google Agenda",
        title: "Integração Google Agenda",
        subtitle: "Conecte uma conta Google para permitir que o FlowBuilder crie eventos automáticos na agenda durante atendimentos.",
        notConnected: "Nenhuma conta Google conectada para esta empresa.",
        connect: "Conectar Google Agenda",
        connectedAs: "Conectado",
        disconnect: "Desconectar",
        defaultCalendar: "Agenda padrão",
        primary: "primary (padrão)",
        main: "principal",
        defaultDuration: "Duração padrão (minutos)",
        timezone: "Fuso horário",
        timezoneHelp: "Ex.: America/Sao_Paulo",
        save: "Salvar configurações",
        saving: "Salvando...",
        confirmDisconnect: "Desconectar Google Agenda?",
        toast: {
          connected: "Google Agenda conectado!",
          connectFail: "Falha ao conectar: ",
          unknownError: "erro desconhecido",
          authUrlError: "Erro ao gerar URL de autorização.",
          disconnected: "Desconectado.",
          disconnectError: "Erro ao desconectar.",
          saved: "Configuração salva.",
          saveError: "Erro ao salvar.",
        },
      },
      flowPage: {
        noDescription: "Sem descrição",
        trigger: "Gatilho",
        noKeywords: "Nenhuma palavra-chave configurada",
        executions: "execuções",
        node: "nó",
        nodes: "nós",
        successRate: "Taxa de sucesso",
        updated: "Atualizado",
        tooltipEdit: "Editar fluxo",
        tooltipActivate: "Ativar fluxo",
        tooltipDeactivate: "Desativar fluxo",
        triggerTypes: {
          keyword: "Palavra-chave",
          anyMessage: "Qualquer mensagem",
          firstContact: "Primeiro contato",
          outOfHours: "Fora do horário",
          regex: "Expressão regular (Regex)",
          integration: "Integração / Webhook",
          manual: "Manual (disparo via API)",
        },
        menu: {
          edit: "Editar",
          report: "Relatório",
          duplicate: "Duplicar",
          export: "Exportar",
          delete: "Excluir",
        },
      },
      flowFormModal: {
        description: "Descrição",
        triggerType: "Tipo de Gatilho",
        keywords: "Palavras-chave",
        keywordsPlaceholder: "Digite e pressione Enter ou vírgula",
        keywordsHelper: "Adicione várias palavras. Pressione Enter, Tab ou vírgula para confirmar cada uma.",
        anyMessageHelper: "O fluxo será disparado em qualquer mensagem recebida.",
        firstContactHelper: "O fluxo será disparado apenas no primeiro contato do cliente.",
        outOfHoursHelper: "O fluxo será disparado quando a mensagem chegar fora do horário de atendimento.",
        regexPattern: "Expressão regular",
        regexPatternPlaceholder: "Ex.: ^(oi|olá|bom dia)",
        regexHelper: "Use sintaxe JavaScript de RegExp (sem as barras).",
        regexFlags: "Flags",
        regexFlagsPlaceholder: "Ex.: i, gi",
        webhookUrl: "URL do Webhook",
        webhookUrlPlaceholder: "https://seu-servico.com/webhook",
        webhookHelper: "URL externa que receberá a chamada para acionar o fluxo.",
        integrationId: "ID da Integração",
        manualToken: "Token de API",
        manualTokenHelper: "Use este token no header Authorization ao chamar o endpoint.",
        manualEndpoint: "Endpoint",
        generateToken: "Gerar token",
        copy: "Copiar",
      },
      flowReport: {
        title: "Relatório do Fluxo",
        executions: "Execuções",
        completion: "Conclusão",
        clickRate: "Taxa de Clique",
        avgNodes: "Média de Nós",
        interactionRate: "Taxa de Interação",
        started: "Iniciaram",
        interacted: "Interagiram",
        completed: "Concluíram",
        completionRate: "Taxa de conclusão",
        close: "FECHAR",
      },
      common: {
        loading: "Carregando...",
      },
      integrationNode: {
        loading: "Carregando...",
        loadingIntegrations: "Carregando integrações...",
        available: "{{count}} integração(ões) disponível(is)",
        select: "Selecione...",
        empty: "Nenhuma integração encontrada",
        advanced: "Configurações avançadas",
        drawerTitle: "Configurações avançadas",
        tabGeneral: "Geral",
        tabExecution: "Execução",
        tabVariables: "Variáveis",
        tabFallback: "Fallback",
        nodeName: "Nome do nó",
        beforeMsg: "Mensagem antes de disparar",
        afterMsg: "Mensagem após executar",
        continueFlow: "Continuar o fluxo após a integração",
        timeout: "Timeout (segundos)",
        retries: "Tentativas em caso de falha",
        retryDelay: "Intervalo entre tentativas (ms)",
        async: "Modo assíncrono (não aguardar resposta)",
        varsSend: "Variáveis enviadas",
        responseVar: "Salvar resposta na variável",
        urlOverride: "URL do webhook (override)",
        method: "Método HTTP",
        headers: "Headers customizados",
        bodyExtra: "Body extra (JSON)",
        fallbackMsg: "Mensagem em caso de falha",
        transferOnFail: "Transferir ticket em caso de falha",
        transferQueueId: "ID da fila de transferência",
        transferUserId: "ID do usuário de transferência",
        add: "Adicionar",
        emptyKV: "Nenhum item.",
        save: "Salvar",
        cancel: "Cancelar",
      },
      adsReport: {
        sourceTitle: "Origem dos leads",
        charts: { funnel: "Funil de leads", byStatus: "Distribuição por status", topAds: "Top anúncios por leads" , bySource: "Por origem do lead" },
        utmTitle: "Links UTM",
        title: "Relatório de Anúncios",
        startDate: "Início",
        endDate: "Fim",
        status: "Status",
        search: "Buscar (telefone, anúncio, ctwa_clid)",
        filter: "Filtrar",
        export: "Exportar",
        statusOptions: {
          all: "Todos",
          new: "Novo",
          contact: "Em atendimento",
          qualified: "Qualificado",
          purchase: "Venda",
          lost: "Perdido",
        },
        kpis: {
          total: "Total",
          new: "Novos",
          contact: "Em atendimento",
          qualified: "Qualificados",
          purchase: "Vendas",
          lost: "Perdidos",
        },
        performanceTitle: "Desempenho por anúncio",
        leadsTitle: "Leads",
        columns: {
          ad: "Anúncio",
          id: "ID",
          leads: "Leads",
          sales: "Vendas",
          conv: "Conv. %",
          date: "Data",
          contact: "Contato",
          phone: "Telefone",
          origin: "Origem",
          channel: "Canal",
          status: "Status",
          capi: "CAPI",
        },
        empty: {
          ads: "Nenhum anúncio capturado no período.",
          leads: "Nenhum lead encontrado.",
        },
        capiTooltip: "Enviado {{when}}",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
          codeSent: "Código de verificação enviado para seu e-mail!",
          codeResent: "Novo código enviado!"
        },
        form: {
          name: "Nome",
          email: "E-mail",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        plan: {
          title: "Escolha seu Plano",
          subtitle: "Selecione o plano ideal para sua empresa",
          badge: "Ideal para sua empresa",
          period: "mês",
          meta: "Até {{users}} usuários · Até {{connections}} conexões"
        },
        formStep: {
          title: "Criar sua conta",
          subtitle: "Preencha os dados da sua empresa"
        },
        verify: {
          title: "Verificação de E-mail",
          subtitle: "Digite o código de 6 dígitos enviado para",
          confirm: "Verificar e Criar Conta",
          sending: "Enviando...",
          resend: "Reenviar código",
          resendIn: "Reenviar em"
        },
        actions: {
          continue: "Continuar",
          back: "Voltar",
          hasAccount: "Já tem uma conta?",
          enter: "Entrar"
        },
        document: {
          label: "CPF / CNPJ / Documento (opcional)",
          cpfValid: "CPF válido!",
          cnpjValid: "CNPJ válido! Nome preenchido automaticamente.",
          invalid: "Documento inválido.",
          error: "Erro ao validar documento."
        },
        validation: {
          required: "Campo obrigatório",
          nameMin: "Nome deve ter pelo menos 2 caracteres",
          nameMax: "Nome deve ter no máximo 50 caracteres",
          companyMin: "Empresa deve ter pelo menos 2 caracteres",
          companyMax: "Empresa deve ter no máximo 50 caracteres",
          passwordMin: "Senha deve ter pelo menos 5 caracteres",
          passwordMax: "Senha deve ter no máximo 50 caracteres",
          invalidEmail: "E-mail inválido",
          codeLength: "Digite o código completo de 6 dígitos."
        },
        features: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          integrations: "Integrações",
          openAi: "OpenAI",
          kanban: "Kanban"
        }
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        forgotPassword: "Esqueceu sua senha?",
        form: {
          email: "E-mail",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem uma conta? Cadastre-se!",
        },
        footer: "Todos os direitos reservados.",
      },
      forgotPassword: {
        title: "Recuperar acesso",
        subtitleLine1: "Informe o e-mail vinculado à sua conta.",
        subtitleLine2: "Enviaremos um código de verificação para você.",
        email: "E-mail",
        placeholder: "seu.email@exemplo.com",
        sending: "Enviando...",
        send: "Enviar Código",
        back: "Voltar para o login",
        toasts: {
          requiredEmail: "Digite seu e-mail",
          success: "Se o e-mail estiver cadastrado, um código será enviado.",
          error: "Erro ao enviar código. Verifique se o SMTP está configurado nas configurações."
        }
      },
      validateCode: {
        title: "Verifique seu e-mail",
        subtitle: "Enviamos um código de 6 dígitos para",
        label: "Código de Verificação",
        submitting: "Validando...",
        submit: "Verificar Código",
        resendPrompt: "Não recebeu? Reenviar código",
        back: "Voltar",
        toasts: {
          incomplete: "Digite o código completo de 6 dígitos",
          success: "Código validado com sucesso!",
          error: "Código inválido ou expirado. Tente novamente.",
          resent: "Novo código enviado!",
          resentError: "Erro ao reenviar código."
        }
      },
      resetPassword: {
        title: "Criar nova senha",
        subtitleLine1: "Escolha uma senha segura para",
        subtitleLine2: "proteger sua conta.",
        newPassword: "Nova Senha",
        confirmPassword: "Confirmar Senha",
        passwordPlaceholder: "Digite sua nova senha",
        confirmPlaceholder: "Repita a nova senha",
        minHint: "Mínimo de 6 caracteres",
        submitting: "Salvando...",
        submit: "Redefinir Senha",
        successTitle: "Senha redefinida com sucesso!",
        successSubtitle: "Redirecionando para o login...",
        toasts: {
          minLength: "A senha deve ter no mínimo 6 caracteres",
          mismatch: "As senhas não coincidem",
          success: "Senha redefinida com sucesso!",
          error: "Erro ao redefinir senha. Token inválido ou expirado."
        }
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir Empresa",
          deleteMessage: "Tem certeza que deseja excluir esta empresa? Todos os dados relacionados serão perdidos. Esta ação não pode ser desfeita.",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
          warning: "Sua assinatura vence em {{days}} {{unit}}",
          expired: "Sua assinatura venceu em {{date}}. Entre em contato com o Suporte para mais informações!",
        },
        token: "Token",
      },
      dashboard: {
        subtitle: "Visão geral dos indicadores de atendimento",
        fetchError: "Erro ao carregar dados do dashboard",
        hideFilters: "Ocultar Filtros",
        filters: "Filtros",
        filter: "FILTRAR ",
        exportExcel: "Exportar Excel",
        exportPdf: "Baixar PDF",
        pdfError: "Erro ao gerar PDF",
        npsTitle: "Pesquisa de Satisfação (NPS)",
        calls: "Atendimentos",
        analytics: {
          title: "Análises",
          ticketVolume: "Volume de Tickets",
          lastDays: "Últimos {{days}} dias",
          noData: "Sem dados",
          ticketStatus: "Status dos Tickets",
          distributionByStatus: "Distribuição por status",
          noTickets: "Sem tickets",
          conversationMetrics: "Métricas de Conversas",
          activeContacts: "Contatos Ativos",
          ticketsPerContact: "Tickets/Contato",
          days: "dias",
          ratingRate: "Taxa Avaliação",
          hourlyActivity: "Atividade por Hora",
          less: "Menos",
          more: "Mais",
          topContacts: "Top Contatos",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatórios de Atendimentos",
        subtitle: "Visualize e exporte dados dos atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        protocol: "Protocolo",
        protocolPlaceholder: "Ex.: 20260526000123",
        serviceProtocol: "Protocolo de atendimento",
        copyProtocol: "Copiar protocolo",
        searchPlaceholder: "Pesquisar...",
        saleValue: "Valor da Venda",
        noSaleReason: "Motivo da Não Venda",
        closedWithSale: "Finalizado com Venda",
        yes: "Sim",
        no: "Não",
        ticketLogs: "Logs do Ticket",
        accessTicket: "Acessar Ticket",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        openContact: "Abrir ficha do contato",
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        default: "Padrão",
        shareLink: "Link para compartilhamento",
        copy: "Copiar",
        linkCopied: "Link copiado!",
        stats: { last7days: "Últimos 7 dias", sent: "Enviadas", received: "Recebidas", noData: "Sem mensagens no período" },
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        searchPlaceholder: "Buscar por nome, ID ou número...",
        status: "Status",
        statusAll: "Todos",
        statusConnected: "Conectado",
        statusDisconnected: "Desconectado",
        statusOpening: "Conectando",
        statusQrcode: "QR Code",
        statusPairing: "Pareamento",
        clearFilters: "Limpar filtros",
        newConnection: "Nova Conexão",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",
        integrity: "Integridade",
        stable: "Estável",
        unstable: "Instável",
        statusConnected: "Conectado",
        statusDisconnected: "Desconectado",
        statusOpening: "Conectando",
        statusQrcode: "QR Code",
        statusPairing: "Pareando",
        active: "Ativo",
        inactive: "Inativo",
        updatedAt: "Atualizado",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        toasts: {
          reconnecting: "Reconectando... aguarde alguns segundos.",
          activate: "Ativar agente",
          deactivate: "Desativar agente",
          activated: "Agente ativado",
          deactivated: "Agente desativado",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
          importHistory: "Importar mensagens anteriores",
          importingHistory: "Importando mensagens...",
          importHistorySuccess: "Importação iniciada — as conversas antigas vão aparecer aos poucos.",
          importHistoryPeriodTitle: "Período da importação",
          importHistoryPeriodHint: "Escolha o período das mensagens a importar (opcional — deixe em branco para importar o lote recente inteiro).",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
          receiveComments: "Receber Comentários",
        },
        receiveComments: {
          label: "Receber Comentários",
          enabled: "Recebimento de comentários habilitado",
          disabled: "Recebimento de comentários desabilitado",
          tooltip: {
            enabled: "Comentários estão sendo recebidos. Clique para desabilitar.",
            disabled: "Comentários não estão sendo recebidos. Clique para habilitar.",
          },
        },
        transfer: {
          title: "Transferência de Tickets",
          description: "Selecione a conexão de origem e a de destino. Todos os atendimentos ativos serão movidos.",
          source: "Origem",
          target: "Destino",
          cancel: "Cancelar",
          transfer: "Transferir",
          transferTickets: "Transferir Tickets",
          transferring: "Transferindo Tickets",
          of: "de",
          waitMessage: "Aguarde enquanto os tickets são transferidos...",
          selectConnections: "Selecione as conexões de origem e destino",
          differentConnections: "As conexões de origem e destino devem ser diferentes",
          success: "Tickets transferidos com sucesso! {{count}} tickets transferidos.",
        },
        preDelete: {
          title: "Antes de excluir",
          message: "Você já transferiu os tickets desta conexão para outra? Se não, recomendamos transferir antes de excluir.",
          notYet: "Ainda não",
          yesTransferred: "Sim, já transferi",
        },
        importMessages: {
          title: "Importar Mensagens",
          button: "Importar Mensagens",
          connection: "Conexão",
          selectConnection: "Selecione uma conexão Z-API",
          startDate: "Data Início",
          endDate: "Data Fim",
          messageType: "Tipo de Mensagem",
          all: "Todas",
          individual: "Individual",
          group: "Grupo",
          ticketStatus: "Status do Ticket",
          open: "Atendendo",
          pending: "Aguardando",
          closed: "Resolvidos",
          queue: "Fila",
          noQueue: "Sem fila",
          import: "Importar",
          cancel: "Cancelar",
          importing: "Importando mensagens...",
          importingDescription: "Aguarde enquanto as mensagens são importadas. Isso pode levar alguns minutos.",
          success: "Importação concluída! {{messages}} mensagens, {{tickets}} tickets, {{contacts}} contatos importados.",
          noZApiConnections: "Nenhuma conexão Z-API encontrada.",
          noConnections: "Nenhuma conexão WhatsApp conectada encontrada.",
          errorMissingFields: "Preencha todos os campos obrigatórios.",
        },
        nativeImport: {
          importing: "Importando mensagens do WhatsApp...",
          finishing: "Finalizando importação...",
          processed: "Processadas",
          messages: "mensagens",
          currentDate: "Data atual",
          errors: "erros",
          cancelled: "Importação cancelada",
          cancel: "Cancelar",
        },
        importProgress: {
          done: "Importação concluída!",
          cancelled: "Importação cancelada",
          importing: "Importando mensagens...",
          starting: "Conectando...",
          scanning: "Buscando chats...",
          processingChat: "Processando chat {{current}} de {{total}}",
          allProcessed: "Todos os chats foram processados",
          cancelledAt: "Parado em {{current}} de {{total}} chats",
          initializing: "Iniciando...",
          progress: "Progresso",
          chats: "chats",
          messagesLabel: "Mensagens",
          tickets: "Tickets",
          contacts: "Contatos",
          errorsLabel: "Erros",
          cancelImport: "Cancelar Importação",
          close: "Fechar",
        },
        officialLabel: "Oficial",
        badges: {
          pairingCode: "Conectado via Código de Pareamento",
          qrCode: "Conectado via QR Code",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
        close: "Fechar",
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        close: "Fechar",
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
          chatbot: "Chatbot",
          defaultFlow: "Fluxo Padrão",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          allowSignature: "Permitir assinatura do atendente",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          autoImportRangeTitle: "Sincronização automática de histórico",
          autoImportRangeHint: "Ao conectar, esta conexão sempre traz automaticamente um pouco do histórico recente pra cada conversa nascer com pelo menos 1 mensagem salva. Por padrão isso cobre os últimos ~2 anos. Preencha as datas abaixo pra limitar essa janela (ex.: só ontem até hoje). Atenção: são datas fixas — se quiser manter sempre \"o último dia\" a cada reconexão, edite essas datas de novo antes de reconectar. Deixe em branco para usar o padrão.",
          autoImportRangeHintWacalls: "Deixe em branco pra manter o comportamento de sempre (só importa quando você clicar em \"Importar mensagens anteriores\"). Se preencher as datas abaixo, a importação desse período dispara sozinha assim que esta conexão parear (escanear o QR Code) — não precisa clicar em nada. São datas fixas: se quiser repetir isso numa próxima conexão, edite as datas de novo antes de reconectar.",
          importOldMessages: "Sincronizar histórico a partir de",
          importRecentMessages: "Sincronizar histórico até",
          importOldMessagesGroups: "Incluir mensagens de grupo nessa sincronização automática",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        webchat: {
          publicUrl: "URL pública (página)",
          embedIframe: "Embed iframe",
          floatingWidget: "Widget flutuante (botão no canto)",
          tokenInfo: "O token público será gerado ao salvar.",
          titleField: "Título",
          subtitle: "Subtítulo",
          welcomeMessage: "Mensagem de boas-vindas",
          primaryColor: "Cor primária (hex)",
          logoUrl: "URL do logo (opcional)",
          uploadLogo: "Enviar logo",
          remove: "Remover",
          logoSizeError: "Logo deve ter no máximo 1MB",
          allowedOrigins: "Origens permitidas (CORS, separadas por vírgula)",
          requireForm: "Exigir formulário antes de iniciar conversa",
          formFields: "Campos do formulário",
          fieldName: "Nome",
          fieldEmail: "E-mail",
          fieldPhone: "Telefone",
          defaults: {
            title: "Atendimento",
            subtitle: "Olá! Como podemos ajudar?",
            welcomeMessage: "Olá! Em que podemos ajudar?",
          },
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      qrcodeModal: {
        title: "Conectar ao WhatsApp",
        subtitle: "Escaneie o QR Code com seu celular para iniciar a sessão",
        connected: "Conectado com sucesso!",
        generating: "Gerando novo QR Code...",
        step1: "Abra o <strong>WhatsApp</strong> no seu celular",
        step2Options: "Toque em <strong>Mais opções ⋮</strong> ou <strong>Configurações ⚙</strong> e selecione <strong>Aparelhos conectados</strong>",
        step3: "Toque em <strong>Conectar um aparelho</strong> e aponte a câmera para este QR Code",
        refreshCountdown: "QR Code atualiza em {{seconds}}s",
        refreshing: "Atualizando QR Code...",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: "Fluxos",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Agente salvo com sucesso!",
        title: {
          add: "Criar Agente",
          edit: "Editar Agente",
        },
        subtitle: "Configure os parâmetros do agente de IA",
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        tabs: {
          basic: "Básico",
          behavior: "Comportamento",
          advanced: "Avançado",
          knowledge: "📚 Conhecimento",
          tools: "🛠️ Ferramentas",
          test: "🧪 Testar",
        },
        basic: {
          agentName: "Nome do Agente *",
          agentNamePlaceholder: "Ex: Assistente de Vendas",
          function: "Função",
          voiceTone: "Tom de Voz",
          aiModel: "Modelo de IA",
          apiKey: "API Key *",
          responseLanguages: "🌐 Idiomas de resposta",
          responseLanguagesHelp: "Selecione os idiomas em que a IA pode responder. Use \"Auto\" para responder no idioma do cliente automaticamente.",
          personality: "Personalidade",
          personalityPlaceholder: "Descreva a personalidade, conhecimentos e habilidades do agente",
          personalityHelp: "Descreva a personalidade, conhecimentos e habilidades do agente",
          activeAgent: "Agente Ativo",
        },
        behavior: {
          greetingMessage: "Mensagem Inicial (opcional)",
          greetingPlaceholder: "Olá! Como posso ajudá-lo?",
          greetingHelp: "Mensagem enviada automaticamente quando o agente inicia uma conversa",
          responseRules: "Regras de Resposta",
          responseRulesPlaceholder: "Liste regras específicas que o agente deve seguir",
          responseRulesHelp: "Liste regras específicas que o agente deve seguir",
          allowTransfer: "Permitir transferência para atendente",
          transferKeywords: "Palavras-chave para transferência",
          transferKeywordsPlaceholder: "atendente, sair, falar com humano, humano",
          transferKeywordsHelp: "Separe por vírgula. Quando detectadas, a IA transfere para um atendente",
          transferKeywordsDefault: "atendente, sair, falar com humano, humano",
          transferMessage: "Mensagem ao transferir",
          transferMessagePlaceholder: "Desculpe, não tenho informações sobre esse assunto. Vou transferir para um atendente.",
          transferMessageDefault: "Desculpe, não tenho informações sobre esse assunto. Vou transferir para um atendente.",
          insertVariable: "Inserir variável:",
          vars: {
            name: "Nome",
            firstName: "Primeiro nome",
            attendant: "Atendente",
            queue: "Fila",
            connection: "Conexão",
            protocol: "Protocolo",
            hour: "Hora",
            datetime: "Data e hora",
            company: "Empresa",
          },
          transferTargetTitle: "Destino da transferência",
          transferQueueLabel: "Fila",
          transferUserLabel: "Atendente (opcional)",
          useAgentDefaultQueue: "— Usar fila padrão do agente —",
          anyUserOfQueue: "— Qualquer atendente da fila —",
          whereTicket: "Onde o ticket deve aparecer",
          statusPending: "Aguardando",
          statusOpen: "Atendendo (do atendente)",
          statusOpenHelp: "\"Atendendo\" só fica disponível quando um atendente é selecionado — o ticket entra direto na lista dele.",
        },
        advanced: {
          responseDelay: "Delay de Resposta",
          responseDelayHelp: "Tempo de espera antes de enviar a resposta (simula digitação)",
          charLimit: "Limite de caracteres",
          charLimitHelp: "Tamanho máximo da resposta do agente",
          humanize: "✨ Humanizar conversa",
          humanizeHelp: "Alterna entre primeiro nome, nome completo e sem nome para parecer natural",
          audioFeatures: "🔊 Recursos de Áudio",
          transcribeAudio: "Transcrever áudios recebidos",
          transcribeAudioHelp: "Converte mensagens de áudio em texto para o agente entender",
          responseMode: "Modo de Resposta",
          agentVoice: "Voz do Agente",
          sendAsPTT: "Enviar como áudio gravado (PTT)",
          sendAsPTTHelp: "O áudio aparece como se fosse gravado na hora, igual um áudio de WhatsApp",
          temperatureHelp: "0 = preciso, 2 = criativo",
          maxTokens: "Max Tokens",
          maxMessages: "Histórico de Mensagens",
          maxMessagesHelp: "Quantidade máxima de mensagens anteriores enviadas ao agente como contexto/histórico da conversa. Quanto maior, mais o agente lembra — mas consome mais tokens.",
        },
        knowledge: {
          title: "Base de Conhecimento",
          subtitle: "Adicione textos, URLs, PDFs, áudios e vídeos para o agente usar como referência",
          upload: "Upload",
          add: "Adicionar",
          saveFirst: "Salve o agente primeiro para adicionar itens à base de conhecimento",
          newItem: "Novo Item",
          nameLabel: "Nome",
          textType: "📋 Texto",
          urlType: "🔗 URL",
          urlLabel: "URL do site",
          textLabel: "Conteúdo de texto",
          urlPlaceholder: "https://exemplo.com/pagina",
          textPlaceholder: "Cole aqui o texto de referência...",
          cancelBtn: "Cancelar",
          saveBtn: "Salvar",
          empty: "Nenhum item na base de conhecimento",
          emptyHelp: "Adicione textos, URLs ou faça upload de arquivos",
          noContent: "Sem conteúdo",
          fillNameContent: "Preencha o nome e o conteúdo",
          addedSuccess: "Item adicionado à base de conhecimento!",
          uploadSuccess: "Arquivo enviado com sucesso!",
          removeConfirm: "Tem certeza que deseja remover este item?",
          removeSuccess: "Item removido!",
        },
        tools: {
          title: "Capacidades do Agente",
          subtitle: "Habilite ferramentas para que o agente possa executar ações reais além de apenas conversar.",
          openTicket: {
            title: "Abrir Atendimento",
            desc: "Transfere o status da conversa em Aberto e pausa o Agente de IA.",
            config: {
              title: "🎧 Configuração — Abrir Atendimento",
              beforeLabel: "Mensagem ao cliente antes de transferir (opcional)",
              beforePlaceholder: "Ex: Vou te transferir para um atendente humano. Um momento, por favor.",
              queueLabel: "Fila padrão para transferência",
              queueNone: "— Nenhuma (decidir pela conversa) —",
              userLabel: "Atendente padrão (opcional)",
              userAny: "— Qualquer atendente da fila —",
              hint: "Se a fila estiver definida, o agente abrirá o atendimento diretamente nela (e no atendente, se informado) ao acionar a ferramenta.",
              pauseAi: "Pausar Agente de IA após abrir o atendimento",
            },
          },
          notifyHuman: {
            title: "Notificar Humano",
            desc: "Envia um alerta via WhatsApp para os responsáveis configurados.",
            config: {
              numbersTitle: "📱 Números do WhatsApp dos responsáveis",
              phonePlaceholder: "+55 (11) 99999-8888",
              removePhone: "Remover este número",
              addNumber: "+ Adicionar outro número",
              hint: "O agente enviará o alerta para <b>todos</b> os números configurados. Digite com DDI + DDD; a máscara é só visual — salvamos apenas dígitos.",
            },
          },
          httpRequest: {
            title: "Requisição HTTP",
            desc: "Permite que o agente chame APIs externas (GET, POST, etc.) para integrar com outros sistemas.",
            config: {
              title: "🛰️ Configuração — Requisição HTTP",
              domainsLabel: "Domínios permitidos (um por linha) — deixe vazio para permitir todos",
              headersLabel: "Headers padrão (JSON) — ex.: autenticação",
              invalidHeaders: "Headers padrão inválidos. Use JSON, ex: { \"Authorization\": \"Bearer xxx\" }",
            },
          },
          tags: {
            title: "Tags",
            desc: "Permite que o agente aplique tags ao atendimento com base na conversa.",
            config: {
              title: "🏷️ Tags que o agente pode aplicar",
              hint: "Selecione as tags permitidas. Se nenhuma for selecionada, o agente poderá usar qualquer tag.",
              empty: "Nenhuma tag cadastrada.",
            },
          },
          kanban: {
            title: "Kanban",
            desc: "Permite que o agente mova o atendimento entre colunas do Kanban.",
            config: {
              title: "🗂️ Colunas do Kanban que o agente pode usar",
              hint: "O agente poderá mover o atendimento para uma das colunas selecionadas. Se nenhuma for selecionada, qualquer coluna do Kanban será permitida.",
              empty: "Nenhuma coluna de Kanban cadastrada. Crie tags com Kanban ativo em <b>Tags</b>.",
            },
          },
          workingHours: {
            title: "⏰ Turno do Agente — Horário de Atendimento",
            subtitle: "Ferramenta que controla quando o agente responde. Fora do turno configurado, a IA é pausada e o cliente recebe apenas a mensagem definida.",
            tooltipTitle: "Como funciona",
            tooltipInside: "Quando ativado, o agente só responde mensagens <b>dentro</b> dos intervalos configurados para cada dia da semana (usando o fuso horário selecionado).",
            tooltipOutside: "<b>Fora do turno:</b> a IA <b>não</b> processa a mensagem nem consome tokens. O sistema envia automaticamente a <b>\"Mensagem fora do turno\"</b> e ignora o restante da conversa até voltar ao expediente.",
            tooltipLanguage: "Se o cliente estiver em outro idioma, a mensagem é traduzida automaticamente.",
            tooltipMultiple: "Você pode definir <b>múltiplos intervalos por dia</b> (ex.: 08:00–12:00 e 14:00–18:00) e deixar dias <b>sem intervalos</b> para mantê-los fechados.",
            timezone: "Fuso horário",
            outOfMessage: "Mensagem fora do turno",
            closed: "Fechado",
            to: "até",
            addInterval: "+ Adicionar intervalo",
            days: { mon: "Segunda", tue: "Terça", wed: "Quarta", thu: "Quinta", fri: "Sexta", sat: "Sábado", sun: "Domingo" },
          },
          scheduling: {
            title: "Agendamento",
            desc: "Agende mensagens e ações para serem executadas em data e hora definidas.",
          },
        },
        test: {
          model: "Modelo",
          usingApiKey: "Usando API Key e prompt da aba \"Básico\"",
          clear: "Limpar",
          emptyChat: "💬 Envie uma mensagem para testar seu Agente de IA",
          placeholder: "Digite sua mensagem de teste...",
          fillApiKey: "Preencha a API Key antes de testar",
          fillPrompt: "Preencha a personalidade/prompt antes de testar",
          fillApiKeyVoice: "Preencha a API Key na aba Básico para ouvir o preview da voz",
          voiceError: "Erro ao gerar preview da voz. Verifique a API Key.",
        },
        functions: {
          geral: "Geral",
          geralDesc: "Assistente multiuso",
          vendas: "Vendas",
          vendasDesc: "Focado em conversão",
          suporte: "Suporte",
          suporteDesc: "Atendimento técnico",
          agendamento: "Agendamento",
          agendamentoDesc: "Marcação de horários",
          financeiro: "Financeiro",
          financeiroDesc: "Cobranças e pagamentos",
        },
        voiceTones: {
          amigavel: "😊 Amigável",
          profissional: "💼 Profissional",
          formal: "🎩 Formal",
          casual: "😎 Casual",
          empatico: "🤗 Empático",
          tecnico: "🔧 Técnico",
        },
        responseModes: {
          text: "Apenas Texto",
          textDesc: "Responde somente com texto",
          audio: "Apenas Áudio",
          audioDesc: "Responde somente com áudio",
          both: "Texto e Áudio",
          bothDesc: "Responde com ambos",
        },
        agentVoices: {
          alloyDesc: "Neutra e equilibrada",
          ashDesc: "Masculina, suave",
          balladDesc: "Feminina, expressiva",
          coralDesc: "Feminina, clara",
          echoDesc: "Masculina, profunda",
          fableDesc: "Masculina, britânica",
          onyxDesc: "Masculina, grave",
          novaDesc: "Feminina, energética",
          sageDesc: "Masculina, calma",
          shimmerDesc: "Feminina, delicada",
        },
        aiModels: {
          gpt4oMiniDesc: "Recomendado - Equilíbrio entre velocidade e qualidade",
          gpt4oDesc: "Mais inteligente e detalhado",
          gpt41MiniDesc: "Rápido e eficiente",
          gpt41Desc: "Alta performance",
          gpt41NanoDesc: "Ultra rápido e econômico",
          o4MiniDesc: "Modelo de raciocínio avançado",
        },
        sectorRequired: "Selecione um setor de transferência",
      },
      prompts: {
        title: "Agente de IA",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          tokens_used: "Tokens Usados",
          status: "Status",
          actions: "Ações",
        },
        metrics: {
          title: "Métricas de Uso de Tokens",
          totalTokens: "Total de Tokens",
          inputTokens: "Tokens de Entrada",
          outputTokens: "Tokens de Saída",
          estimatedCost: "Custo Estimado (USD)",
          costTooltip: "Estimativa baseada nos preços médios do GPT-4o-mini. O custo real pode variar.",
          perAgent: "Consumo por Agente",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        toasts: {
          activate: "Ativar agente",
          deactivate: "Desativar agente",
          activated: "Agente ativado",
          deactivated: "Agente desativado",
        },
        buttons: {
          add: "Adicionar Agente",
        },
        inactivity: {
          title: "Mensagem de Inatividade",
          description: "Acorda o cliente automaticamente se ele demorar para responder.",
          timeoutLabel: "Tempo de inatividade (minutos)",
          maxRemindersLabel: "Máx. de lembretes",
          messageLabel: "Mensagem para acordar o cliente",
          messagePlaceholder: "Ex.: Olá! Ainda está por aí? 😊",
          helper: "Enviada se o cliente não responder após a última mensagem do agente.",
          defaultMessage: "Olá! Ainda está por aí? Posso te ajudar em mais alguma coisa? 😊",
          banner: {
            howItWorks: "Como vai funcionar:",
            intro: "se o cliente ficar",
            withoutReply: "sem responder, será enviado",
            oneReminder: "1 lembrete",
            nReminders: "{{n}} lembretes",
            withInterval: "com intervalo de",
            betweenEach: "entre cada um",
            maxWait: "no máximo",
            totalWait: "de espera total",
            singleTail: "com a mensagem abaixo. Depois disso o sistema para de insistir.",
            example: "Exemplo: cliente parou de responder às 10:00",
            firstReminderAt: "1º lembrete às",
            lastAt: "último às",
          },
        },
        noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
        totalContacts: "Total de Contatos",
        activeUsers: "Usuários Ativos",
        activeQueues: "Filas Ativas",
        withEmail: "Com E-mail",
        emptyTitle: "Nenhum contato na carteira",
        emptySubtitle: "Os contatos vinculados aparecerão aqui.",
        chartByUser: "Distribuição por Usuário",
        chartByQueue: "Contatos por Fila",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          aiAgent: "Agente de IA",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
           selectAiAgent: "Selecione um Agente de IA",
           selectModel: "Modelo de IA",
           addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      asaasBoletoNode: {
        title: "Segunda via boleto (Asaas)",
        description: "Pergunta o CPF/CNPJ, valida, consulta Asaas e envia os boletos automaticamente.",
        configure: "Configurar nó",
        dialogTitle: "Configurar Segunda via Asaas",
        tabs: { messages: "Mensagens", boletos: "Boletos", advanced: "Avançado" },
        buttons: { close: "Fechar", save: "Salvar" },
        statuses: { pending: "Pendente", overdue: "Vencido", received: "Pago", confirmed: "Confirmado" },
        summary: {
          template: "Status: {{statuses}} • Tentativas: {{attempts}} • Modo: {{mode}} • {{sort}}",
          modeSingle: "Única", modeSeparate: "Separadas", noSort: "Sem ordenação"
        },
        fields: {
          askMessage: "Mensagem de solicitação",
          askMessageHelper: "Texto enviado ao cliente para pedir o CPF/CNPJ",
          invalidMessage: "Mensagem de CPF/CNPJ inválido",
          notFoundMessage: "Mensagem se não encontrar boletos",
          errorMessage: "Mensagem de erro na consulta",
          giveUpMessage: "Mensagem após esgotar tentativas",
          finalMessage: "Mensagem final (após boletos)",
          finalMessageHelper: "Deixe vazio para não enviar",
          statusesLabel: "Status a buscar no Asaas",
          headerMessage: "Cabeçalho antes dos boletos",
          boletoTemplate: "Formato de cada boleto (template)",
          boletoTemplateHelper: "Variáveis: {{indice}} {{descricao}} {{valor}} {{vencimento}} {{status}} {{linkBoleto}} {{linhaDigitavel}} {{nossoNumero}} {{pixCopiaCola}}",
          sendMode: "Modo de envio",
          sendModeSingle: "Mensagem única (todos os boletos juntos)",
          sendModeSeparate: "Uma mensagem por boleto",
          sortBy: "Ordenar por", sortOrder: "Direção",
          sortDueDate: "Vencimento", sortValue: "Valor", sortNone: "Sem ordenação (ordem do Asaas)",
          sortOrderHelper: "Crescente: mais próximo primeiro",
          sortAsc: "Crescente (mais antigo/menor primeiro)",
          sortDesc: "Decrescente (mais recente/maior primeiro)",
          sendPixQrCode: "Incluir variável {{pixCopiaCola}} no template (legado)",
          pixDivider: "PIX por boleto",
          pixDelivery: "Como enviar o PIX",
          pixDeliveryHelper: "Enviado em mensagem separada após cada boleto",
          pixNone: "Não enviar PIX separado",
          pixCopyPaste: "Apenas copia-e-cola (texto)",
          pixQrImage: "Apenas imagem do QR Code",
          pixBoth: "Ambos (texto + imagem)",
          pixMessageTemplate: "Mensagem do PIX copia-e-cola",
          pixMessageTemplateHelper: "Use {{pixCopiaCola}} para o código",
          pixQrCaption: "Legenda da imagem do QR Code",
          asaasToken: "Token Asaas (API Key)",
          asaasTokenPlaceholder: "Cole aqui o access_token da sua conta Asaas",
          asaasTokenHelper: "Obrigatório. Cada empresa usa o seu próprio token, configurado por nó.",
          maxAttempts: "Tentativas máximas de validação",
          maxAttemptsHelper: "Após esgotar, segue para o próximo nó",
          timeoutDivider: "Timeout de resposta",
          inputTimeoutSeconds: "Timeout para o cliente responder (segundos)",
          inputTimeoutSecondsHelper: "0 = desativado. Se estourar, reenvia a solicitação e conta como tentativa",
          timeoutMessage: "Mensagem ao reenviar por timeout",
          countVariable: "Variável de saída (quantidade encontrada)",
          countVariablePlaceholder: "ex: qtdBoletos",
          countVariableHelper: "Opcional. Use depois em um nó Condicional"
        }
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          acceptanceMessage: "Saudação ao aceitar ticket",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          internalExtension: "Ramal interno",
          internalExtensionPlaceholder: "Ex.: 101",
          internalExtensionHelper: "Deixe em branco se este usuário não usa ramal",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          notifyPendingTicketWhatsapp: "Tickets pendentes",
          whatsappNumber: "WhatsApp para notificações",
          whatsappNumberHelper: "Informe DDI + DDD + número, apenas dígitos (qualquer país). Ex.: 5511999999999 (BR), 34662531131 (ES), 351912345678 (PT).",
          pendingTicketNotificationMessage: "Mensagem personalizada de notificação",
          pendingTicketNotificationMessagePlaceholder: "Ex.: Olá {usuario}, você tem um novo ticket #{ticket} na fila {fila} do contato {contato}.",
          pendingTicketNotificationMessageHelper: "Deixe em branco para usar a mensagem padrão. Variáveis: {fila}, {contato}, {ticket}, {usuario}.",
          notifyOpenTicketWhatsapp: "Tickets em atendimento",
          notifyKanbanTicketWhatsapp: "Mudanças no Kanban",
          notificationMaxCount: "Máximo de notificações",
          notificationMaxCountHelper: "Quantas vezes notificar o mesmo ticket (por tipo).",
          notificationIntervalMinutes: "Intervalo (min)",
          notificationIntervalMinutesHelper: "Tempo mínimo entre notificações repetidas. 0 = sem intervalo.",
          notificationsSectionTitle: "Notificações via WhatsApp",
          enableNotifications: "Ativar notificações via WhatsApp",
          enableNotificationsHelper: "Ativa ou desativa todas as notificações. Você pode ajustá-las individualmente abaixo.",
          notificationWhatsappId: "Conexão para enviar notificações",
          notificationWhatsappIdHelper: "Escolha a conexão usada para enviar as notificações deste usuário.",
          notificationWhatsappAuto: "Automática (usar conexão ativa)",
          showReturnQueueButton: "Mostrar botão de devolver para fila",
          showTransferTicketButton: "Mostrar botão de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automações",
          showSchedules: "Ver Agendamentos",
          showKanban: "Ver Kanban",
          showInternalChat: "Ver Chat Interno",
          showOpenAi: "Ver Agente de IA",
          showIntegrations: "Ver Integrações",
          finalizacaoComValorVenda: "Finalização com Valor de Venda",
          birthDate: "Data de Nascimento",
          birthDateHelper: "Data de nascimento para notificações de aniversário",
          connections: "Conexões",
          language: "Idioma",
          timezone: "Fuso horário (campanhas)",
        },
        tabs: {
          general: "Geral",
          notifications: "Notificações",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      
        notifyTest: {
          button: "Enviar notificação de teste",
          helper: "As notificações automáticas só disparam para tickets em filas em que o usuário está vinculado (aba Filas).",
          saveFirst: "Salve o usuário antes de enviar o teste.",
          invalidNumber: "Informe um número de WhatsApp válido (DDI + DDD + número, 8 a 15 dígitos).",
          success: "Notificação de teste enviada com sucesso!",
          fail: "Falha ao enviar notificação de teste.",
          reasons: {
            userNotFound: "Usuário não encontrado.",
            invalidNumber: "Número de WhatsApp inválido ou vazio (use DDI + DDD + número, apenas dígitos).",
            noDefaultWhatsapp: "Nenhuma conexão WhatsApp padrão encontrada. Defina uma conexão como padrão em Conexões.",
            wppNotInitialized: "Conexão padrão \"{{name}}\" não está inicializada. Acesse a página de Conexões e conecte-a antes de enviar o teste.",
            wppOffline: "Conexão padrão \"{{name}}\" não está online no momento.",
            sendFailed: "Falha no envio: {{error}}"
          }
        },
},
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        header: {
          title: "Conversas",
        },
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        elapsedPrefix: "há {{distance}}",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
        lastMessage: {
          deleted: "Mensagem Apagada",
          location: "Localização",
          contact: "Contato compartilhado",
          contactCount: "Contato compartilhado ({{count}})",
          missedCall: "Chamada de voz/vídeo perdida",
          audio: "Áudio",
          photo: "Foto",
          video: "Vídeo",
          document: "Documento",
          sticker: "Figurinha",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          courses: "Cursos",
          agentTemplates: "Modelos de Agente",
          salesAgents: "Agentes Comerciais",
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          myPlan: "Meu Plano",
          adminFinanceiro: "Gestão Financeira",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Agente de IA",
          allConnections: "Gerenciar conexões",
          whatsappHealth: "Saúde dos Números",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          automations: "Automações",
          groupManager: "Gestor de Grupos",
          n8nPanel: "Painel n8n",
          tasks: "Tarefas",
          followUp: "Follow UP (Templates)",
          salesPipeline: "Pipeline de Vendas",
          salesPipelineDesc: "Visualizar oportunidades",
          taskList: "Lista de Tarefas",
          taskListDesc: "Agendar e gerenciar",
          preferences: "Preferências",
          preferencesDesc: "Configurações do sistema",
          switchAccount: "Trocar de Conta",
          switchAccountDesc: "Gerenciar contas salvas",
        },
        planExpiresToday: "⚠️ Seu plano vence hoje! Renove agora para não perder o acesso.",
        planExpiresTomorrow: "⚠️ Seu plano vence amanhã! Renove para não perder o acesso.",
        planExpiresIn: "⏳ Seu plano vence em {{count}} dias. Renove para continuar usando o sistema.",
        renewNow: "Renovar agora",
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            switchAccount: "Trocar de Conta",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            informations: "Informativos",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        title: "Notificações", clearAll: "Limpar tudo",
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
        hideAll: "Ocultar notificações",
        hideAllTooltip: "Desativar notificações (você pode reativar nas Configurações)",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          media: "Mídia",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        sortBy: "Ordenar por",
        startDate: "Data de início",
        endDate: "Data de fim",
        search: "Buscar",
        addColumns: "Adicionar colunas",
        allTickets: "Todos os tickets",
        myTickets: "Meus tickets",
        slaOverdue: "SLA Atrasado",
        filterSla: "Filtrar SLA",
        filterUser: "Atendente",
        filterQueue: "Fila",
        filterChannel: "Canal",
        filterTag: "Tag",
        filterAll: "Todos",
        compact: "Compacto",
        expanded: "Expandido",
        clearFilters: "Limpar filtros",
        shortcutsHelp: "Atalhos: ←/→ navegar colunas · ↑/↓ navegar cards · Enter abrir · C alterna compacto · / focar busca",
        boardLabel: "Board",
        boardAll: "Todas as tags",
        manageBoards: "Gerenciar boards",
        sortOptions: {
          ticketNumber: "Número do Ticket",
          lastMessage: "Última Mensagem",
          valueDesc: "Valor (maior para menor)",
        },
        toasts: {
          tagUpdated: "Ticket Tag atualizado com sucesso!",
          tagRemoved: "Ticket Tag removido!",
          adminOnly: "Apenas administradores podem reordenar as lanes do Kanban",
          laneOrderUpdated: "Ordem das lanes atualizada com sucesso",
          laneOrderError: "Erro ao salvar ordem das lanes",
        },
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      kanbanBoards: {
        title: "Boards do Kanban",
        buttons: {
          backToKanban: "Voltar ao Kanban",
          newBoard: "+ Novo Board",
        },
        filters: {
          allBoards: "Todos os boards",
          myBoards: "Meus boards",
        },
        emptyState: "Nenhum board criado ainda. Clique em <b>+ Novo Board</b> para começar.",
        table: {
          name: "Nome",
          description: "Descrição",
          columns: "Colunas",
          visibility: "Visibilidade",
          owner: "Dono",
          default: "Padrão",
          actions: "Ações",
          user: "Usuário",
        },
        visibility: {
          shared: "Compartilhado",
          private: "Privado",
        },
        actions: {
          removeDefault: "Remover como padrão",
          setDefault: "Definir como padrão",
          openInKanban: "Abrir no Kanban",
          edit: "Editar",
          delete: "Excluir",
        },
        dialog: {
          newTitle: "Novo Board",
          editTitle: "Editar Board",
          nameLabel: "Nome do board",
          descriptionLabel: "Descrição",
          color: "Cor:",
          shareWithCompany: "Compartilhar com toda a empresa",
          sharedHelp: "<b>Compartilhado:</b> todos os usuários da empresa verão este board no seletor do Kanban e poderão visualizá-lo e editá-lo. Apenas o criador pode excluí-lo.",
          privateHelp: "<b>Privado:</b> somente você verá este board. Outros usuários da mesma empresa não terão acesso a ele no seletor do Kanban.",
          templateOptional: "Template (opcional)",
          blankTemplate: "Em branco",
          blankTemplateDesc: "Criar board sem colunas pré-definidas",
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando...",
        },
        confirmDelete: {
          title: "Excluir board",
          message: "Tem certeza que deseja excluir o board <b>{{name}}</b>? As tags/colunas não serão excluídas.",
        },
        toasts: {
          loadError: "Erro ao carregar boards",
          nameRequired: "Informe um nome",
          updated: "Board atualizado",
          created: "Board criado",
          saveError: "Erro ao salvar",
          defaultRemoved: "Board padrão removido",
          defaultSet: "Board padrão definido",
          defaultError: "Erro ao alterar padrão",
          deleted: "Board excluído",
          deleteError: "Erro ao excluir",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
          recurrence: "Recorrência",
          nextExecution: "Próxima Execução",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        statuses: {
          inactive: "Inativa",
          scheduled: "Programada",
          inProgress: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        recurrence: {
          minutely: "Por Minuto",
          hourly: "Por Hora",
          daily: "Diário",
          weekly: "Semanal",
          biweekly: "Quinzenal",
          monthly: "Mensal",
          yearly: "Anual",
        },
        stopRecurrence: {
          title: "Interromper Recorrência",
          message: "Tem certeza que deseja interromper a recorrência desta campanha? A campanha atual continuará sendo executada, mas não haverão mais execuções futuras.",
        },
        filters: {
          status: "Status",
          all: "Todos",
          allFem: "Todas",
          recurrence: "Recorrência",
          recurring: "Recorrentes",
          single: "Única",
        },
        tooltips: {
          recurring: "Campanha Recorrente",
          stop: "Parar Campanha",
          restart: "Reiniciar Campanha",
          stopRecurrence: "Interromper Recorrência",
          duplicate: "Duplicar Campanha",
          export: "Exportar CSV",
          preview: "Pré-visualizar mensagem",
        },
        summary: {
          total: "Total",
          scheduled: "Programadas",
          inProgress: "Em Andamento",
          finished: "Finalizadas",
          cancelled: "Canceladas",
        },
        bulk: {
          selected: "selecionada(s)",
          cancelAll: "Cancelar",
          restartAll: "Reiniciar",
          deleteAll: "Excluir",
          confirmTitle: "Ação em Lote",
          confirmMessage: "Tem certeza que deseja executar esta ação em {{count}} campanha(s)?",
        },
        noMessage: "Sem mensagem",
        listRemoved: "Nenhuma lista vinculada",
        connectionDeleted: "Conexão excluída",
        connectionPrefix: "Conexão",
        noConnection: "Nenhuma conexão",
        notCompleted: "Não concluída",
        totalLabel: "campanhas",
        pagination: {
          rowsPerPage: "Linhas por página:",
          of: "de",
          moreThan: "mais de",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
          duplicated: "Campanha duplicada com sucesso!",
          bulkSuccess: "Ação em lote executada com sucesso!",
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
          recurrenceStopped: "Recorrência interrompida com sucesso!",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        fetchError: "Erro ao buscar dados do relatório",
        backButton: "Voltar",
        awaitingTemplateResponseCard: "Aguardando resposta do template",
        templateRespondedCard: "Responderam (follow-up enviado)",
        followUpStatus: {
          waiting: "Aguardando resposta",
          waitingTooltip: "Template enviado. Aguardando o cliente responder para liberar as mensagens 2-5 (janela de 24h da Meta).",
          sent: "Follow-ups enviados",
          sentTooltip: "Cliente respondeu ao template. As mensagens de follow-up (2-5) já foram enviadas.",
          expired: "Janela expirada",
          expiredTooltip: "A janela de 24h da Meta expirou sem resposta do cliente. As mensagens 2-5 não podem mais ser enviadas.",
        },
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          avatar: "Avatar",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          internalExtension: "Ramal interno",
          internalExtensionPlaceholder: "Ex.: 101",
          internalExtensionHelper: "Deixe em branco se este usuário não usa ramal",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
          backfillChats: "Gerar chats existentes",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          amount: "Valor",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openAi: "Agente de IA",
          integrations: "Integrações",
          flows: "Fluxos",
          contacts: "Contatos",
          dashboard: "Dashboard",
          realTime: "Tempo Real",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
        },
        confirmationModal: {
          deleteTitle: "Exclusão de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
        toasts: {
          success: "Operação realizada com sucesso!",
          errorList: "Não foi possível carregar a lista de registros",
          errorSave: "Não foi possível realizar a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente",
          errorDelete: "Não foi possível realizar a operação",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
        confirmationModal: {
          deleteTitle: "Exclusão de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
        toasts: {
          success: "Operação realizada com sucesso!",
          error: "Não foi possível realizar a operação",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        more: "mais",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          leadSources: "Origem dos leads",
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
          finalizacao: "Finalização do Atendimento",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            enableCloseTicketModal:
              "Tela de fechamento de chamado (assunto e resumo)",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuário",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            autoReaction: "Reagir automaticamente na mensagem",
            autoReactionRules: "Regras de Reação Automática",
            autoReactionAddRule: "Adicionar Regra",
            autoReactionKeywords: "Palavras-chave (separadas por vírgula)",
            autoReactionEmojis: "Emojis para sorteio",
            autoReactionHelp: "Crie regras para o sistema reagir automaticamente. Se a mensagem do cliente contiver alguma das palavras-chave, o sistema sorteará um dos emojis configurados na regra. Se nenhuma regra der match, não haverá reação.",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            disableSystemNotifications: "Silenciar todas as notificações",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - use {{queue}} para o nome da fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite / para mensagens rápidas e # para produtos cadastrados",
        placeholderOpen:
          "Digite / para mensagens rápidas e # para produtos cadastrados",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
        tooltips: {
          bold: "Negrito",
          italic: "Itálico",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista Numerada",
          bulletList: "Lista com Marcadores",
          quote: "Citação",
          clearFormat: "Limpar Formatação",
          ghostMention: "Marcação Fantasma (notifica todos sem mostrar @)",
          triggerFlow: "Disparar Fluxo",
          aiSuggest: "IA: Sugerir Resposta",
          enableSignature: "Habilitar/Desabilitar Assinatura",
          enableComments: "Habilitar/Desabilitar Comentários",
          quickAnswers: "Respostas rápidas",
        },
        menuItems: {
          ghostMention: "Marcação Fantasma",
          signature: "Assinatura",
          triggerFlow: "Disparar Fluxo",
          catalog: "Catálogo de Produtos",
          comments: "Comentários",
        },
        errors: {
          ticketIdNotFound: "Erro: ID do ticket não encontrado",
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
        aiSummarize: "Resumo IA do Atendimento",
        aiSummarizeTitle: "Resumo IA do Atendimento",
        aiSummaryCopied: "Resumo copiado para a área de transferência!",
        aiSummaryCopy: "Copiar",
        aiSummaryClose: "Fechar",
        aiSummarySaveNote: "Salvar como Nota",
        aiSummarySaved: "Resumo salvo como nota do contato!",
        autoAiSummary: "Auto-resumo IA ao finalizar",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          attach: "Anexar arquivo",
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferência",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
          interactive: "Mensagem Interativa",
          pix: "PIX",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        react: "Reagir",
        reactionSent: "Reação enviada",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_PRODUCT_HAS_LINKS: "Este produto possui negociações vinculadas e não pode ser excluído. Altere o status para Inativo.",
        ERR_FIELD_TYPE_IN_USE: "Não é possível alterar o tipo deste campo, pois já existem produtos cadastrados utilizando-o.",
        ERR_CATEGORY_HAS_PRODUCTS: "Não é possível excluir esta categoria porque existem produtos vinculados a ela.",
        ERR_PROMOTIONAL_PRICE_INVALID: "O preço promocional deve ser estritamente menor que o preço normal.",
        ERR_RESERVED_SKU_PREFIX: "O prefixo '_SYS-' é reservado para identificadores automáticos do sistema.",
        ERR_NO_PRODUCT_FOUND: "Produto não encontrado.",
        ERR_NO_CATEGORY_FOUND: "Categoria não encontrada.",
        ERR_CATEGORY_NOT_FOUND: "A categoria selecionada não pertence a esta empresa ou não existe.",
        ERR_FLOW_AI_NO_KEY: "Nenhuma chave de IA configurada. Cadastre a chave em Configurações > IA antes de gerar fluxos.",
        ERR_FLOW_AI_SHORT_DESCRIPTION: "Descreva o fluxo com um pouco mais de detalhe.",
        ERR_FLOW_AI_REQUEST_FAILED: "Não foi possível falar com a IA. Verifique a chave e tente novamente.",
        ERR_FLOW_AI_INVALID_JSON: "A IA devolveu uma resposta inválida. Tente reescrever a descrição.",
        ERR_FLOW_AI_EMPTY: "A IA não conseguiu montar um fluxo com essa descrição. Tente detalhar melhor.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_QUICKMESSAGE_SHORTCODE_REQUIRED: "Informe o atalho da resposta rápida.",
        ERR_QUICKMESSAGE_MESSAGE_REQUIRED: "Escreva uma mensagem ou anexe uma mídia (imagem, áudio ou arquivo).",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_TICKET_NO_LINKED_CONNECTION:
          "Este ticket não possui conexão vinculada, provavelmente a conexão foi excluída.",
        ERR_PLAN_FEATURE_DISABLED: "Este recurso não está disponível no seu plano atual. Entre em contato com o administrador para fazer um upgrade.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
        total: "Total",
        inService: "Em atendimento",
        activeAgents: "Agentes ativos",
        searchPlaceholder: "Buscar contato, mensagem ou agente...",
        allQueues: "Todas as filas",
        all: "Todos",
        refresh: "Atualizar",
        fullscreen: "Tela cheia",
        exitFullscreen: "Sair da tela cheia",
        noTicketsForFilters: "Nenhum atendimento para os filtros atuais.",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        editMessage: "Editar Mensagem",
        messageLabel: "Mensagem",
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        logoMobile: "Logo Mobile (PWA)",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
      flowBuilder: {
        conversationFlows: "Fluxos",
        addImage: {
          title: "Adicionar imagem ao fluxo",
          editTitle: "Editar imagem",
          add: "Adicionar",
          save: "Salvar",
          caption: "Legenda (opcional)",
          uploadImage: "Enviar imagem",
          successAdd: "Imagem adicionada com sucesso!",
          fileTooLarge: "Arquivo é muito grande! 2MB máximo",
          error: "erro",
        },
        addText: {
          title: "Adicionar mensagem ao fluxo",
          editTitle: "Editar mensagem ao fluxo",
          add: "Adicionar",
          save: "Salvar",
          message: "Mensagem",
        },
        addAttendant: {
          title: "Adicionar um atendente ao fluxo",
          editTitle: "Editar atendente",
          add: "Adicionar",
          edit: "Editar",
          chooseAttendant: "Escolha um atendente",
          selectUser: "Selecione um usuário",
          addAttendant: "Adicione um atendente",
        },
        condition: {
          title: "Nova Condição",
          editTitle: "Editar Condição",
          variableField: "Variável / Campo",
          variablePlaceholder: "Digite $ para ver variáveis disponíveis",
          variableHelper: "Digite $ para autocompletar variáveis do fluxo",
          conditionType: "Tipo de condição",
          comparisonValue: "Valor da comparação",
          commaSeparated: "Valores separados por vírgula",
          regexExample: "Ex: ^[0-9]{11}$ — expressão regular JavaScript",
          anyTokenTrigger: "Qualquer token da lista dispara Verdadeiro",
          fixedOrVariable: "Valor fixo ou variável com $",
          insertVariable: "Inserir variável pelo seletor",
          addCondition: "Adicionar condição",
          logicTrue: "Lógica: Verdadeiro se",
          allConditions: "TODAS as condições",
          anyCondition: "QUALQUER condição",
          satisfied: "forem satisfeitas",
          quickTips: "💡 Dicas rápidas",
          tipContainsAny: "Contém qualquer (,): separe tokens por vírgula →",
          tipRegex: "Regex: use expressão JS →",
          tipVariable: "Use ${variavel} em qualquer campo para referenciar valores dinâmicos",
          cancel: "Cancelar",
          saving: "Salvando...",
          saveChanges: "Salvar alterações",
          errorRequired: "o campo \"Variável / Campo\" é obrigatório",
          errorComparisonRequired: "o campo \"Valor da comparação\" é obrigatório",
          errorSave: "Ocorreu um erro ao salvar. Tente novamente.",
          selectVariable: "Selecionar variável",
          dynamicVarsFound: "variável(is) encontrada(s) no fluxo",
          addVarNodes: "Adicione nós de Variável Global ou Input para variáveis dinâmicas",
          searchVariable: "Buscar variável...",
          noVariableFound: "Nenhuma variável encontrada",
          flowVariables: "Variáveis do fluxo",
          // Quick shortcuts (atalhos rápidos para montar condições comuns)
          quickShortcut: "Atalhos rápidos:",
          hasTag: "Contato com a tag",
          notHasTag: "Contato sem a tag",
          inQueue: "Ticket na fila",
          notInQueue: "Ticket fora da fila",
          selectQueueIn: "Selecione a fila que o ticket DEVE estar",
          selectQueueNotIn: "Selecione a fila que o ticket NÃO deve estar",
          searchQueue: "Buscar fila...",
          // Operators
          equals: "Igual a",
          notEquals: "Diferente de",
          contains: "Contém texto",
          notContains: "Não contém",
          containsAny: "Contém qualquer (,)",
          startsWith: "Começa com",
          endsWith: "Termina com",
          greaterThan: "Maior que",
          lessThan: "Menor que",
          greaterOrEqual: "Maior ou igual a",
          lessOrEqual: "Menor ou igual a",
          isEmpty: "Está vazio",
          isNotEmpty: "Não está vazio",
          regex: "Expressão regular",
          // Groups
          equality: "Igualdade",
          text: "Texto",
          numeric: "Numérico",
          state: "Estado",
          advanced: "Avançado",
          // Static variables
          contactName: "Nome do contato",
          contactEmail: "Email do contato",
          contactPhone: "Telefone / número do contato",
          lastMessage: "Última mensagem recebida",
          ticketIdDesc: "ID do ticket atual",
          ticketStatusDesc: "Status do ticket (open/pending/closed)",
          ticketQueueDesc: "Fila atual do ticket",
          ticketQueueIdDesc: "ID da fila atual do ticket",
          ticketConnectionDesc: "Nome da conexão (WhatsApp) do ticket",
          ticketConnectionIdDesc: "ID da conexão (WhatsApp) do ticket",
          ticketTagsDesc: "Tags do ticket (separadas por vírgula)",
          ticketIsOpenDesc: "Ticket está aberto (true/false)",
          ticketIsClosedDesc: "Ticket está fechado (true/false)",
          ticketIsPendingDesc: "Ticket está pendente (true/false)",
          ticketTransferredDesc: "Ticket foi transferido (true/false)",
          ticketUserIdDesc: "ID do atendente responsável pelo ticket",
          apiResponseDesc: "Resposta da última requisição HTTP",
          // Categories
          contact: "Contato",
          ticket: "Ticket",
          globalVariable: "Variável Global",
          capturedInput: "Input Capturado",
          menu: "Menu",
          httpApi: "HTTP / API",
          api: "API",
          // Dynamic descriptions
          globalVarDesc: "Variável global do fluxo",
          userResponseDesc: "Resposta capturada do usuário",
          responseFrom: "Resposta de:",
          menuResponse: "Resposta do menu:",
          menuOption: "Opção do menu:",
          mappedFrom: "Mapeado de:",
          httpVarDesc: "Variável da resposta HTTP",
          valuePrefix: "Valor:",
        },
      },
      flowBuilderTicketModal: {
        addTitle: "Adicionar Ticket",
        editTitle: "Editar Ticket",
        chooseQueue: "Escolher setor",
        selectConnection: "Selecione uma conexão",
        addQueueError: "Selecione um setor",
      },
      campaignModal: {
        // ===== Chaves planas usadas pelo CampaignModal (mescladas do bloco duplicado anterior) =====
        tabCampaign: "Campanha",
        tabContactLists: "📋 Listas de Contatos",
        tabSettings: "⚙️ Configurações",
        selectTemplateRequired: "Selecione um template aprovado para campanhas via API Oficial.",
        noTemplateFound: "Nenhum template aprovado encontrado. Crie um template antes de enviar.",
        templateRequired: "Obrigatório para API Oficial. Mensagens sem template falham fora da janela de 24h.",
        apiOfficialLabel: "API Oficial",
        recurrenceTitle: "Configuração de Recorrência",
        enableRecurrence: "Habilitar recorrência",
        recurrenceType: "Tipo de Recorrência",
        minutely: "Por Minuto",
        hourly: "Por Hora",
        daily: "Diário",
        weekly: "Semanal",
        biweekly: "Quinzenal",
        monthly: "Mensal",
        yearly: "Anual",
        interval: "Intervalo",
        everyInterval: "A cada {{count}} {{unit}}",
        minuteUnit: "minuto(s)",
        hourUnit: "hora(s)",
        dayUnit: "dia(s)",
        weekUnit: "semana(s)",
        biweekUnit: "quinzena(s)",
        monthUnit: "mês(es)",
        yearUnit: "ano(s)",
        daysOfWeek: "Dias da Semana",
        dayOfMonth: "Dia do Mês",
        dayOfMonthHelper: "Dia específico do mês (1-31)",
        endDate: "Data Final (opcional)",
        emptyRecurrence: "Deixe vazio para recorrência infinita",
        maxExecutions: "Máximo de Execuções (opcional)",
        hideExecutions: "Ocultar",
        showExecutions: "Visualizar",
        nextExecutions: "Próximas Execuções",
        next5Executions: "Próximas 5 Execuções:",
        nthExecution: "{{n}}ª Execução",
        campaignMessage: "Mensagem da Campanha",
        apiOfficialNote: "Para API Oficial, utilize o template selecionado ao lado. O campo de mensagem e anexo de mídia não estão disponíveis.",
        apiOfficialNoFollowUp: "⚠️ Follow-up disponível apenas para canais Baileys. Em campanhas via API Oficial, somente o template é enviado.",
        attachMedia: "Anexar Mídia",
        messageVariableHelper: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
        varName: "Nome",
        varNumber: "Número",
        varEmail: "Email",
        varGreeting: "Saudação",
        varProtocol: "Protocolo",
        varFirstName: "Primeiro Nome",
        varAgent: "Atendente",
        variationLabel: "Variação",
        generateVariantsTitle: "Gerar 5 variantes da mensagem",
        generateVariantsDesc: "A IA reescreve a Mensagem 1 de 5 formas diferentes para reduzir o padrão repetitivo de texto (proteção contra bloqueio).",
        generatingVariants: "Gerando variantes com IA...",
        variantsGenerated: "Variantes geradas! Confira as abas Variação 2 a 5.",
        variantsNeedBase: "Escreva a Mensagem 1 antes de gerar variantes.",
        contactListTitle: "📋 Lista de Contatos da Campanha",
        contactListDesc: "Selecione uma lista criada na aba \"📋 Listas de Contatos\". A lista define quem receberá as mensagens desta campanha.",
        contactList: "Lista de Contatos",
        noListSelected: "Nenhuma lista selecionada",
        contacts: "contatos",
        filterByTag: "Filtrar por Tag (opcional)",
        noTagFilter: "Sem filtro de tag",
        switchList: "Trocar lista → Ir para Listas de Contatos",
        createOrSelectList: "+ Criar ou selecionar lista na aba Listas de Contatos",
        dispatchIntervals: "Intervalos de Disparo",
        dispatchIntervalsDesc: "Configure os intervalos de tempo entre os disparos desta campanha para evitar bloqueios.",
        antiBan: "Anti-Ban",
        antiBanDesc: "Humaniza o disparo para reduzir risco de bloqueio",
        jitterLabel: "Variação aleatória (jitter)",
        jitterFixed: "fixo",
        jitterMax: "máximo",
        jitterBase: "Base {{base}}s → entre {{min}}s e {{max}}s",
        jitterSelectBase: "⚠️ Selecione um intervalo base acima",
        extraPauseEvery: "Pausa extra a cada N msgs",
        disabled: "Desabilitado",
        everyNMessages: "A cada {{n}} mensagens",
        extraPauseDuration: "Duração da pausa extra",
        seconds: "segundos",
        minute1: "1 minuto",
        minutes2: "2 minutos",
        minutes5: "5 minutos",
        settingsSaved: "Configurações salvas com sucesso!",
        daysOfWeekOptions: {
          sunday: "Domingo",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
        },
        autoListName: "Campanha - {{name}} - {{date}}",
        noName: "Sem nome",
        // ===== Sub-objetos originais (validation, tabs, recurrence, etc) =====
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          recurrenceTypeRequired: "Tipo de recorrência é obrigatório",
          intervalMin: "Intervalo deve ser maior que 0",
          intervalRequired: "Intervalo é obrigatório",
          selectDay: "Selecione pelo menos um dia da semana",
          dayRange: "Dia deve ser entre 1 e 31",
          dayRequired: "Dia do mês é obrigatório",
          endDateFuture: "Data final deve ser futura",
          maxExecMin: "Número máximo deve ser maior que 0",
          noneValue: "Nenhuma",
        },
        tabs: {
          campaign: "Campanha",
          contactLists: "📋 Listas de Contatos",
          settings: "⚙️ Configurações",
        },
        recurrence: {
          title: "Configuração de Recorrência",
          enable: "Habilitar recorrência",
          type: "Tipo de Recorrência",
          interval: "Intervalo",
          dayOfMonth: "Dia do Mês",
          dayOfMonthHelper: "Dia específico do mês (1-31)",
          endDate: "Data Final (opcional)",
          endDateHelper: "Deixe vazio para recorrência infinita",
          maxExecutions: "Máximo de Execuções (opcional)",
          maxExecutionsHelper: "Deixe vazio para recorrência infinita",
          showExecutions: "Visualizar",
          hideExecutions: "Ocultar",
          nextExecutions: "Próximas Execuções",
          next5: "Próximas 5 Execuções:",
          nthExecution: "ª Execução",
          minutely: "A cada X minutos",
          hourly: "A cada X horas",
          daily: "Diária",
          weekly: "Semanal",
          biweekly: "Quinzenal",
          monthly: "Mensal",
          yearly: "Anual",
        },
        days: {
          sunday: "Domingo",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
        },
        message: {
          title: "Mensagem da Campanha",
          variables: {
            name: "Nome",
            number: "Número",
            email: "Email",
            greeting: "Saudação",
            protocol: "Protocolo",
            firstName: "Primeiro Nome",
            attendant: "Atendente",
          },
          helperText: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          oficialNotAvailable: "Para API Oficial, utilize o template selecionado ao lado. O campo de mensagem e anexo de mídia não estão disponíveis.",
          attachMedia: "Anexar Mídia",
          preview: "Preview",
        },
        template: {
          label: "Template *",
          noTemplates: "Nenhum template aprovado encontrado. Crie um template antes de enviar.",
          helperText: "Obrigatório para API Oficial. Mensagens sem template falham fora da janela de 24h.",
          selectTemplate: "Selecione um template aprovado para campanhas via API Oficial.",
        },
        contactListGroup: {
          title: "📋 Lista de Contatos da Campanha",
          description: "Selecione uma lista criada na aba \"📋 Listas de Contatos\". A lista define quem receberá as mensagens desta campanha.",
          label: "Lista de Contatos",
          noList: "Nenhuma lista selecionada",
          contacts: "contatos",
          filterByTag: "Filtrar por Tag (opcional)",
          noTagFilter: "Sem filtro de tag",
          switchList: "Trocar lista → Ir para Listas de Contatos",
          createOrSelect: "+ Criar ou selecionar lista na aba Listas de Contatos",
        },
        triggerSettings: {
          title: "Intervalos de Disparo",
          description: "Configure os intervalos de tempo entre os disparos desta campanha para evitar bloqueios.",
          antiBan: "Anti-Ban",
          antiBanDesc: "Humaniza o disparo para reduzir risco de bloqueio",
          jitterLabel: "Variação aleatória (jitter)",
          jitterFixed: "fixo",
          jitterMax: "máximo",
          jitterBase: "Base",
          jitterBetween: "entre",
          jitterAnd: "e",
          selectBaseInterval: "⚠️ Selecione um intervalo base acima",
          extraPause: "Pausa extra a cada N msgs",
          extraPauseDuration: "Duração da pausa extra",
          disabled: "Desabilitado",
          every10: "A cada 10 mensagens",
          every20: "A cada 20 mensagens",
          every30: "A cada 30 mensagens",
          every50: "A cada 50 mensagens",
          every100: "A cada 100 mensagens",
          seconds: "segundos",
          minute1: "1 minuto",
          minutes2: "2 minutos",
          minutes5: "5 minutos",
          savedSuccess: "Configurações salvas com sucesso!",
          saveSettings: "Salvar Configurações",
        },
        followUp: {
          toggle: "Enviar mensagem após template",
          delayLabel: "Delay entre mensagens",
          description: "Mensagens enviadas em sequência após o template (dentro da janela de 24h).",
          multipleHelp: "Preencha apenas as mensagens que deseja enviar. Serão enviadas em sequência. Mídia é enviada na 1ª mensagem.",
          windowWarningTitle: "Janela de 24h da Meta",
          windowWarningBody: "As mensagens 2 a 5 só serão enviadas APÓS o cliente responder ao template. A API Oficial do WhatsApp exige que o destinatário responda para abrir uma janela de 24h. Se o cliente não responder, apenas o template será entregue.",
          delay3s: "3 segundos",
          delay5s: "5 segundos",
          delay10s: "10 segundos",
          delay30s: "30 segundos",
          delay60s: "1 minuto",
          useApprovedTemplate: "Usar template aprovado",
          noSimpleTemplate: "Nenhum template simples disponível",
          selectApprovedTemplate: "Selecione um template aprovado",
          simpleTemplateHelper: "Apenas templates aprovados sem variáveis aparecem aqui. A mídia do header (se houver) faz parte do template.",
          metaRestrictionTitle: "Restrição da Meta — janela de 24h",
          metaRestrictionBody: "Você preencheu mensagens adicionais (2-5) em uma campanha API Oficial. A Meta só permite o envio dessas mensagens após o cliente responder ao template inicial, e dentro de uma janela de 24h.",
          metaRestrictionEnableHint: "Ative o switch \"Enviar mensagem após template\" abaixo, caso contrário as mensagens 2-5 não serão enviadas.",
        },
      },
      chatMessages: {
        user: "Usuário",
        today: "HOJE",
        loadingOldMessages: "Carregando mensagens antigas...",
        viewDocument: "Visualizar Documento",
        doubleClickReply: "Clique duas vezes para responder",
        messageLabel: "Mensagem",
        messageNotFound: "[mensagem não encontrada]",
      },
      finalizacaoAtendimento: {
        title: "Finalização de Atendimento",
        generalSettings: "Configurações Gerais",
        informSaleValue: "Informar valor da venda ao finalizar atendimento",
        informSaleValueHelper: "Quando habilitado, o campo de valor da venda aparecerá no modal de finalização",
        finalizationReasons: "Motivos de Finalização",
        addReason: "Adicionar Motivo",
        name: "Nome",
        description: "Descrição",
        actions: "Ações",
        noDescription: "Sem descrição",
        noReasons: "Nenhum motivo cadastrado. Clique em \"Adicionar Motivo\" para começar.",
        editReason: "Editar Motivo",
        reasonName: "Nome do Motivo",
        descriptionOptional: "Descrição (opcional)",
        cancel: "Cancelar",
        saving: "Salvando...",
        update: "Atualizar",
        add: "Adicionar",
        nameRequired: "Nome do motivo é obrigatório",
        reasonUpdated: "Motivo atualizado com sucesso!",
        reasonCreated: "Motivo criado com sucesso!",
        reasonSaveError: "Erro ao salvar motivo",
        confirmDelete: "Tem certeza que deseja excluir este motivo?",
        reasonDeleted: "Motivo excluído com sucesso!",
        reasonDeleteError: "Erro ao excluir motivo",
        settingUpdated: "Configuração atualizada com sucesso!",
        settingUpdateError: "Erro ao atualizar configuração",
        currencyUpdated: "Moeda atualizada com sucesso!",
        currencyUpdateError: "Erro ao atualizar moeda",
      },
      interactiveMessage: {
        tabs: {
          buttons: "Botões",
          list: "Lista",
          billing: "Cobrança",
          offers: "Ofertas",
          pix: "PIX",
          url: "URL",
          call: "Ligação",
          location: "Local",
          carousel: "Carrossel",
          catalog: "Catálogo",
          poll: "Enquete",
        },
        select: "Selecionar",
        options: "Opções",
        reviewAndPay: "Revisar e pagar",
        templateLoaded: "Template \"{{name}}\" carregado",
        templateNameRequired: "Digite um nome para o template",
        templateSaved: "Template salvo!",
        templateSaveError: "Erro ao salvar template",
        templateRemoved: "Template removido",
        templateRemoveError: "Erro ao remover",
        fillMessageText: "Preencha o texto da mensagem",
        addAtLeastOneButton: "Adicione pelo menos um botão",
        addAtLeastOneListOption: "Adicione pelo menos uma opção na lista",
        fillLatLong: "Preencha latitude e longitude",
        fillUrl: "Preencha a URL",
        fillPhone: "Preencha o número de telefone",
        fillPixKey: "Preencha a chave PIX",
        addAtLeast2Options: "Adicione pelo menos 2 opções",
        addAtLeastOneCard: "Adicione pelo menos um card",
        fillBillingDescription: "Preencha a descrição da cobrança",
        pdfUploadError: "Erro ao enviar PDF",
        messageSent: "Mensagem interativa enviada!",
        sendError: "Erro ao enviar",
        buttonsInfo: "Envie até 3 botões clicáveis. O cliente pode tocar em um botão para responder rapidamente.",
        messageText: "Texto da mensagem *",
        footerOptional: "Rodapé (opcional)",
        buttonsMax3: "Botões (máx. 3)",
        addButton: "Adicionar",
        optionPlaceholder: "Opção {{number}}",
        listInfo: "Envie uma lista com até 10 opções. O cliente abre um menu para selecionar.",
        buttonText: "Texto do botão",
        sectionTitle: "Título da seção",
        titleLabel: "Título",
        descriptionLabel: "Descrição",
        addOption: "Adicionar opção",
        offerInfo: "Envie uma oferta com título, preço e descrição.",
        offerTitle: "Título da oferta",
        bodyDescription: "Descrição / Corpo da mensagem *",
        price: "Preço (ex: 99,90)",
        additionalDetails: "Detalhes adicionais",
        pixInfo: "Envie dados PIX formatados para o cliente.",
        pixKey: "Chave PIX *",
        pixKeyPlaceholder: "CPF, CNPJ, e-mail, telefone ou chave aleatória",
        beneficiaryName: "Nome do beneficiário",
        city: "Cidade",
        amount: "Valor",
        urlInfo: "Envie um link clicável com texto personalizado.",
        linkText: "Texto do link",
        linkTextPlaceholder: "Clique aqui",
        urlLabel: "URL *",
        urlPlaceholder: "https://...",
        callInfo: "Envie uma mensagem com número para ligação.",
        callButtonText: "Texto do botão",
        callButtonPlaceholder: "Ligar agora",
        phoneNumber: "Número de telefone *",
        locationInfo: "Envie uma localização para o cliente.",
        locationName: "Nome do local",
        address: "Endereço",
        latitude: "Latitude *",
        longitude: "Longitude *",
        carouselInfo: "Envie múltiplos cards como carrossel.",
        cardLabel: "Card {{number}}",
        addCard: "Adicionar card",
        catalogInfo: "Envie produtos do catálogo como cards.",
        productLabel: "Produto {{number}}",
        productName: "Nome do produto",
        priceDescription: "Descrição / Preço",
        addProduct: "Adicionar produto",
        pollInfo: "Crie uma enquete para o cliente votar.",
        pollQuestion: "Pergunta da enquete *",
        pollOptionsLabel: "Opções (mín. 2, máx. 12)",
        billingInfo: "Envie uma cobrança com detalhes do pagamento e botão \"Revisar e pagar\".",
        billingNumber: "Nº da cobrança",
        billingDescription: "Descrição da cobrança *",
        quantity: "Quantidade",
        totalAmount: "Valor total",
        billingMessage: "Mensagem adicional",
        paymentUrl: "URL de pagamento (opcional)",
        paymentButtonText: "Texto do botão de pagamento",
        attachPdf: "Anexar PDF (boleto)",
        save: "Salvar",
        cancel: "Cancelar",
        send: "Enviar",
        sending: "Enviando...",
        saveTemplate: "Salvar como template",
        templateNameLabel: "Nome do template",
        saveTemplateBtn: "Salvar Template",
        noTemplates: "Nenhum template salvo",
        templates: "Templates",
        deleteTemplate: "Excluir template",
      },
      flowBuilderInteractive: {
        title: "Mensagem Interativa (Baileys)",
        editTitle: "Editar Mensagem Interativa",
        add: "Adicionar",
        save: "Salvar",
        cancel: "Cancelar",
        messageType: "Tipo de mensagem interativa",
        buttonsMax3: "Botões (máx. 3)",
        infoText: "Botões interativos via Baileys (nativeFlowMessage). Funciona em conexões não-oficiais. Limite de 3 botões.",
        messageContent: "CONTEÚDO DA MENSAGEM",
        buttonsTab: "BOTÕES",
        messageBody: "Corpo da mensagem",
        footerOptional: "Rodapé (opcional)",
        headerImageOptional: "Imagem de cabeçalho (opcional)",
        changeImage: "Trocar imagem",
        uploadImage: "Enviar imagem",
        listButtonText: "Texto do botão da lista",
        listButtonHelper: "Texto exibido no botão que abre a lista",
        preview: "Pré-visualização",
        messageBodyPlaceholder: "Corpo da mensagem...",
        buttonsLabel: "Botões",
        listOptions: "Opções da lista",
        buttonTextPlaceholder: "Texto do botão {{number}}",
        optionPlaceholder: "Opção {{number}}",
        addAtLeastOneOption: "Adicione pelo menos uma opção.",
        bodyRequired: "O corpo da mensagem é obrigatório!",
        addOption: "Adicione pelo menos uma opção!",
        fileTooLarge: "Arquivo muito grande! Máximo 2MB",
        imageUploadError: "Erro ao enviar imagem",
        maxOptionsReached: "Limite máximo de {{max}} opções para botões!",
        // Tipos estendidos (API Oficial)
        officialOnlyBanner: "⚠ Recursos avançados (CTA, Flow, Catálogo, Carrossel) requerem WhatsApp API Oficial (Meta Cloud). Botões e Listas funcionam em ambos os canais.",
        flowOnlyOfficial: "WhatsApp Flows requer canal API Oficial (Meta).",
        typeButton: "Botões rápidos (Quick Reply)",
        typeList: "Lista interativa",
        typePix: "PIX (copia e cola)",
        typeCtaUrl: "CTA - Abrir link",
        typeCtaCall: "CTA - Ligar",
        typeFlow: "WhatsApp Flow (somente API Oficial)",
        typeCatalog: "Catálogo de produtos",
        typeCarousel: "Carrossel de produtos",
        typeDescButton: "Até 3 botões de resposta rápida. Use para perguntas com poucas escolhas (ex: Sim/Não, Falar com atendente). Funciona em Baileys e API Oficial.",
        typeDescList: "Lista com até 10 opções agrupadas em um menu. Use quando houver muitas escolhas (ex: setores, horários, produtos). Funciona em Baileys e API Oficial.",
        typeDescPix: "Envia um botão nativo 'Copiar código PIX' com o código copia e cola. Ideal para cobranças rápidas. Funciona em Baileys.",
        typeDescCtaUrl: "Botão único que abre uma URL externa (site, formulário, pagamento). Somente API Oficial.",
        typeDescCtaCall: "Botão único que inicia uma chamada telefônica para o número informado. Somente API Oficial.",
        typeDescFlow: "Formulário interativo nativo do WhatsApp (Flows) configurado no Meta Business. Somente API Oficial.",
        typeDescCatalog: "Envia um produto ou seu catálogo cadastrado no Meta Commerce. Opcionalmente envie uma imagem de capa. Somente API Oficial.",
        typeDescCarousel: "Vários cards roláveis com imagem, título, descrição e botão. Use para vitrine de produtos ou opções visuais. Somente API Oficial.",
        ctaButtonText: "Texto do botão",
        ctaUrl: "URL",
        ctaPhone: "Telefone (com DDI, ex: +5511999999999)",
        ctaUrlPlaceholder: "Ex: Abrir site",
        ctaCallPlaceholder: "Ex: Ligar agora",
        flowId: "Flow ID",
        flowToken: "Flow Token (opcional)",
        flowCta: "Texto do botão (CTA)",
        flowScreen: "Tela inicial",
        catalogId: "Catalog ID",
        catalogProductId: "Produto destaque (retailer_id, opcional)",
        carouselCards: "Cards do carrossel",
        addCard: "Adicionar card",
        cardTitle: "Título",
        cardDescription: "Descrição",
        cardImageUrl: "URL da imagem (opcional)",
        cardButtonText: "Texto do botão",
        cardButtonId: "ID do botão",
        cardLabel: "Card",
        ctaTextRequired: "Informe o texto do botão e a URL",
        callTextRequired: "Informe o texto do botão e o telefone",
        flowFieldsRequired: "Informe Flow ID e CTA",
        catalogIdRequired: "Informe o ID do catálogo",
        carouselCardsRequired: "Adicione pelo menos um card no carrossel",
        maxCards: "Máximo 10 cards",
        pixBoxInfo: "Envia um botão nativo \"Copiar código PIX\" com o código copia e cola.",
        pixReuseTitle: "Reutilize em várias cobranças:",
        pixReuseSubtitle: "use variáveis no corpo (acima) e nos campos abaixo.",
        pixFlowVars: "Variáveis do fluxo (capturadas/Webhook):",
        pixTicketVars: "Variáveis do atendimento:",
        pixCopyPasteLabel: "Código PIX copia e cola",
        pixButtonTextLabel: "Texto do botão",
        pixNameLabel: "Nome do beneficiário (opcional)",
        pixAmountLabel: "Valor (opcional)",
        pixQrCodeLabel: "Enviar QR Code (imagem) junto com o botão",
        pixDocBoxInfo: "📄 Anexar um PDF (boleto/fatura) como cabeçalho + botão \"Copiar chave Pix\" no mesmo balão.",
        pixTotalLabel: "Total exibido (opcional)",
        pixDocUrlLabel: "URL do PDF (boleto/fatura)",
        pixDocNameLabel: "Nome do arquivo (opcional)",
      },
      flowBuilderVideo: {
        title: "Adicionar video ao fluxo",
        editTitle: "Editar video",
        add: "Adicionar",
        save: "Salvar",
        captionOptional: "Legenda (opcional)",
        uploadVideo: "Enviar video",
        mp4Only: "ATENÇÃO! Apenas videos em MP4!",
        videoAdded: "Video adicionado com sucesso!",
        fileTooLarge: "Arquivo é muito grande! 20MB máximo",
        browserNotSupported: "seu navegador não suporta HTML5",
      },
      flowBuilderInput: {
        addTitle: "Adicionar input ao fluxo",
        title: "Adicionar input ao fluxo",
        editTitle: "Editar input do fluxo",
        add: "Adicionar",
        saveChanges: "Salvar alterações",
        question: "Pergunta",
        questionTooltip: "A pergunta que será enviada ao usuário. Você pode incluir variáveis usando $\\{nomeVariavel}",
        questionLabel: "Digite a pergunta",
        typeQuestion: "Digite a pergunta",
        questionPlaceholder: "Ex: Olá {{firstName}}, qual é a sua idade?",
        flowVariables: "Variáveis de fluxo (clique para inserir):",
        variableName: "Nome da variável",
        variableNameTooltip: "Nome da variável onde a resposta será armazenada. Não use espaços ou caracteres especiais.",
        variableTooltip: "Nome da variável onde a resposta será armazenada. Não use espaços ou caracteres especiais.",
        variableNameLabel: "Nome da variável",
        variableNamePlaceholder: "Ex: idade_cliente",
        variablePlaceholder: "Ex: idade_cliente",
        variableNameHelper: "A resposta do usuário será armazenada nesta variável",
        variableHelper: "A resposta do usuário será armazenada nesta variável",
        howItWorks: "Como funciona",
        howItWorksDescription: "Este nó enviará a pergunta ao usuário e aguardará uma resposta. Quando o usuário responder, o valor será armazenado na variável especificada e o fluxo continuará para o próximo nó.",
        howItWorksDesc: "Este nó enviará a pergunta ao usuário e aguardará uma resposta. Quando o usuário responder, o valor será armazenado na variável especificada e o fluxo continuará para o próximo nó.",
        examples: {
          name: "Nome do cliente",
          email: "Email do cliente",
          phone: "Telefone do cliente",
          city: "Cidade do cliente",
        },
        exampleVars: {
          nome: "Nome do cliente",
          email: "Email do cliente",
          telefone: "Telefone do cliente",
          cidade: "Cidade do cliente",
        },
      },
      flowBuilderTag: {
        addTitle: "Adicionar uma tag ao fluxo",
        editTitle: "Editar tag",
        chooseTag: "Escolha uma tag",
        selectTag: "Selecione uma tag",
        noTagSelected: "Nenhuma tag selecionada",
        addTag: "Adicione uma tag",
        add: "Adicionar",
        edit: "Editar",
      },
      flowBuilderSingleBlock: {
        addTitle: "Adicionar conteúdo ao fluxo",
        editTitle: "Editar conteúdo",
        addMenu: "Adicionar menu ao fluxo",
        add: "Adicionar",
        save: "Salvar",
        image: "Imagem",
        uploadImage: "Enviar imagem",
        captionOptional: "Legenda (opcional)",
        audio: "Audio",
        uploadAudio: "Enviar audio",
        sendAsRecorded: "Enviar como audio gravado na hora",
        video: "Video",
        uploadVideo: "Enviar video",
        text: "Texto",
        message: "Mensagem",
        interval: "Intervalo",
        timeInSeconds: "Tempo em segundos",
        document: "Documento",
        uploadDocument: "Enviar Documento",
        viewDocument: "Visualizar Documento",
        contentAdded: "Conteúdo adicionada com sucesso!",
        deleteEmptyCards: "Delete os cards vazios(Imagem, Audio e Video)",
        emptyMessageFields: "Campos de mensagem vazio!",
        intervalInvalid: "Intervalo não pode ser 0 ou maior que 120!",
        fileTooLargeImg: "Arquivo é muito grande! 2MB máximo",
        fileTooLargeAudio: "Arquivo é muito grande! 5MB máximo",
        fileTooLargeVideo: "Arquivo é muito grande! 20MB máximo",
        fileTooLargeDoc: "Arquivo é muito grande! 10MB máximo",
        browserNotSupported: "seu navegador não suporta HTML5",
        variableLabels: {
          firstName: "Primeiro Nome",
          name: "Nome",
          userName: "Atendente",
          ms: "Saudação",
          protocol: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          phoneNumber: "Telefone",
          email: "E-mail",
          kanban: "Kanban",
        },
      },
      flowBuilderGemini: {
        title: "Adicionar Gemini ao fluxo",
        editTitle: "Editar Gemini do fluxo",
        add: "Adicionar",
        save: "Salvar",
        cancel: "Cancelar",
        basicSettings: "Configurações Básicas - Google Gemini",
        assistantName: "Nome do Assistente",
        apiKey: "API Key Google AI",
        model: "Modelo Gemini",
        systemPrompt: "Prompt do Sistema",
        systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
        temperature: "Temperatura",
        temperatureHelper: "0 = conservador, 2 = criativo",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Tamanho máximo da resposta",
        maxMessages: "Max Mensagens",
        maxMessagesHelper: "Histórico de contexto",
        flowBehavior: "Comportamento do Fluxo",
        flowBehaviorTooltip: "Configure como o Gemini deve se comportar no fluxo",
        operationMode: "Modo de Funcionamento",
        permanent: "Permanente",
        permanentDesc: "Encerrar fluxo aqui",
        permanentHelper: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
        temporary: "Temporário",
        temporaryDesc: "Volta ao fluxo depois",
        temporaryHelper: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
        temporarySettings: "Configurações do Modo Temporário",
        temporarySettingsDesc: "Configure quando a IA deve parar e retornar ao fluxo",
        maxInteractions: "Máximo de Interações",
        maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
        timeout: "Timeout (minutos)",
        timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
        continueKeywords: "Palavras-chave para Continuar Fluxo",
        keywordPlaceholder: "Digite uma palavra-chave",
        addKeyword: "Adicionar",
        keywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
        objective: "Objetivo da IA",
        objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
        objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
        autoComplete: "Auto completar quando atingir objetivo",
        autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          describeTraining: "Descreva o treinamento para Inteligência Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informe o modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 8000 tokens",
          informMaxTokens: "Informe o número máximo de tokens",
          minTemp: "Mínimo 0",
          maxTemp: "Máximo 2",
          informTemp: "Informe a temperatura",
          informApiKey: "Informe a API Key",
          minMessages: "Mínimo 1 mensagem",
          maxMessages: "Máximo 100 mensagens",
          informMaxMessages: "Informe o número máximo de mensagens",
          invalidFlowMode: "Modo de fluxo inválido",
          selectFlowMode: "Selecione o modo de fluxo",
          minInteraction: "Mínimo 1 interação",
          maxInteraction: "Máximo 50 interações",
          minTimeout: "Mínimo 1 minuto",
          maxTimeout: "Máximo 60 minutos",
          keywordRequired: "Palavra-chave não pode estar vazia",
          atLeastOneKeyword: "Pelo menos uma palavra-chave é obrigatória no modo temporário",
          objectiveRequired: "Objetivo é obrigatório quando auto completar está ativo",
        },
      },
      flowBuilderOpenAI: {
        title: "Adicionar OpenAI ao fluxo",
        editTitle: "Editar OpenAI do fluxo",
        add: "Adicionar",
        save: "Salvar",
        cancel: "Cancelar",
        basicSettings: "Configurações Básicas - OpenAI",
        assistantName: "Nome do Assistente",
        apiKey: "API Key OpenAI",
        model: "Modelo OpenAI",
        systemPrompt: "Prompt do Sistema",
        systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
        temperature: "Temperatura",
        temperatureHelper: "0 = conservador, 2 = criativo",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Tamanho máximo da resposta",
        maxMessages: "Max Mensagens",
        maxMessagesHelper: "Histórico de contexto",
        voiceSettings: "Configurações de Voz (Opcional)",
        responseType: "Tipo de Resposta",
        textOnly: "Apenas Texto",
        voiceKeyLabel: "Voice Key (Azure)",
        voiceKeyPlaceholder: "Chave do Azure Speech Service",
        voiceRegionLabel: "Voice Region (Azure)",
        voiceRegionPlaceholder: "ex: brazilsouth",
        flowBehavior: "Comportamento do Fluxo",
        flowBehaviorTooltip: "Configure como o OpenAI deve se comportar no fluxo",
        operationMode: "Modo de Funcionamento",
        permanent: "Permanente",
        permanentDesc: "Encerrar fluxo aqui",
        permanentHelper: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
        temporary: "Temporário",
        temporaryDesc: "Volta ao fluxo depois",
        temporaryHelper: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
        temporarySettings: "Configurações do Modo Temporário",
        temporarySettingsDesc: "Configure quando a IA deve parar e retornar ao fluxo",
        maxInteractions: "Máximo de Interações",
        maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
        timeout: "Timeout (minutos)",
        timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
        continueKeywords: "Palavras-chave para Continuar Fluxo",
        keywordPlaceholder: "Digite uma palavra-chave",
        addKeyword: "Adicionar",
        keywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
        objective: "Objetivo da IA",
        objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
        objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
        autoComplete: "Auto completar quando atingir objetivo",
        autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          describeTraining: "Descreva o treinamento para Inteligência Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informe o modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4000 tokens",
          informMaxTokens: "Informe o número máximo de tokens",
          minTemp: "Mínimo 0",
          maxTemp: "Máximo 2",
          informTemp: "Informe a temperatura",
          informApiKey: "Informe a API Key",
          minMessages: "Mínimo 1 mensagem",
          maxMessages: "Máximo 100 mensagens",
          informMaxMessages: "Informe o número máximo de mensagens",
          informVoice: "Informe o modo para Voz",
          voiceKeyRequired: "Voice Key é obrigatória para síntese de voz",
          voiceRegionRequired: "Voice Region é obrigatória para síntese de voz",
          invalidFlowMode: "Modo de fluxo inválido",
          selectFlowMode: "Selecione o modo de fluxo",
          minInteraction: "Mínimo 1 interação",
          maxInteraction: "Máximo 50 interações",
          minTimeout: "Mínimo 1 minuto",
          maxTimeout: "Máximo 60 minutos",
          keywordRequired: "Palavra-chave não pode estar vazia",
          atLeastOneKeyword: "Pelo menos uma palavra-chave é obrigatória no modo temporário",
          objectiveRequired: "Objetivo é obrigatório quando auto completar está ativo",
        },
      },
      validation: {
        tooShort: "Muito curto!",
        tooLong: "Muito longo!",
        required: "Obrigatório",
        messageTooShort: "Mensagem muito curta",
        nameTooShort: "nome muito curto",
      },
    embeddedSignup: {
      title: "WhatsApp Embedded Signup",
      subtitle: "Cadastre seu número diretamente pelo CRM",
      steps: { configure: "Configurar", processing: "Processando", result: "Resultado" },
      description: "Clique no botão abaixo para iniciar o processo de cadastro do seu número WhatsApp Business diretamente pela Meta.",
      connectionName: "Nome da conexão",
      connectionNamePlaceholder: "Ex: WhatsApp Principal",
      infoTitle: "O que acontece:",
      infoItems: { popup: "Um popup da Meta será aberto", login: "Você fará login com sua conta do Facebook Business", select: "Selecionará ou criará uma conta WhatsApp Business", register: "O número será registrado automaticamente no CRM" },
      buttons: { loadingSdk: "Carregando SDK...", processing: "Processando...", start: "Iniciar Cadastro via Meta", close: "Fechar", cancel: "Cancelar" },
      success: { title: "Conexão criada com sucesso!", name: "Nome", number: "Número", numberPending: "Será exibido em breve", wabaId: "WABA ID", status: "Status" },
      errors: { title: "Erro no cadastro", noAppId: "App ID da Meta não configurado!", noConfigId: "Configuration ID da Meta não configurado!", noName: "Informe um nome para a conexão!", sdkNotLoaded: "SDK da Meta não carregou corretamente. Recarregue a página e tente novamente.", sdkInitFailed: "Falha ao inicializar o SDK da Meta.", sdkLoadFailed: "Falha ao carregar o SDK da Meta. Desative bloqueadores e permita popups.", sdkNotAvailable: "SDK do Facebook não ficou disponível no navegador.", appIdNotConfigured: "App ID da Meta não configurado! Peça ao administrador da plataforma para preencher em Configurações → Instagram / Facebook.", configIdNotConfigured: "ID de configuração do Embedded Signup não preenchido! Peça ao administrador da plataforma para preencher em Configurações → Instagram / Facebook.", timeout: "Tempo esgotado. O popup da Meta pode ter sido bloqueado pelo navegador. Permita popups e tente novamente.", noAuthCode: "Código de autorização não recebido. Verifique as permissões do app.", cancelled: "Processo cancelado pelo usuário.", signupError: "Erro durante o processo de cadastro.", processingError: "Erro ao processar o cadastro. Tente novamente.", popupError: "Erro ao abrir popup da Meta. Verifique se popups estão permitidos.", loginCancelled: "Login cancelado ou não autorizado.", metaStatus: "Meta retornou status:" },
      processing: { title: "Processando cadastro...", description: "Estamos trocando as credenciais com a Meta e configurando sua conexão." },
      menuItem: "WhatsApp Embedded Signup",
    },
    },
    flowBuilderConditionModal: {
      addTitle: "Adicionar condição ao fluxo",
      editTitle: "Editar condição",
      add: "Adicionar",
      save: "Salvar",
      conditionField: "Campo da condição (Digiter apenas 1 chave)",
      validationRule: "Regra de validação",
      conditionValue: "Valor da condição a ser analisada",
    },
    flowBuilderTypebot: {
      addTitle: "Adicionar Typebot ao fluxo",
      editTitle: "Editar Typebot ao fluxo",
      add: "Adicionar",
      edit: "Editar",
      save: "Salvar",
    },
    flowBuilderSwitchFlow: {
      addTitle: "Adicionar Troca de Fluxo",
      editTitle: "Editar Troca de Fluxo",
      add: "Adicionar",
      edit: "Editar",
      save: "Salvar",
      chooseFlow: "Escolha um fluxo",
    },
    flowBuilderRandomizer: {
      add: "Adicionar",
      edit: "Editar",
    },
    flowBuilderRandomizerModal: {
      addTitle: "Adicionar randomizador ao fluxo",
      editTitle: "Editar randomizador",
      addIntervalError: "O percentual deve ser maior que 0",
      maxTimeError: "O percentual não pode ser maior que 120",
    },
    flowBuilderKanbanNode: {
      title: "Kanban",
      moveTo: "Mover para: {{lane}}",
      noLane: "Nenhuma etapa selecionada",
    },
    flowBuilderKanbanModal: {
      addTitle: "Adicionar etapa do Kanban ao fluxo",
      editTitle: "Editar etapa do Kanban",
      description: "Ao passar por este nó, o atendimento é movido para a etapa escolhida do quadro Kanban. O fluxo continua normalmente depois.",
      laneLabel: "Etapa de destino",
      lanePlaceholder: "Selecione a etapa...",
      noLanesAvailable: "Nenhuma etapa de Kanban cadastrada. Crie em Tags (marcando a opção Kanban).",
      selectLaneError: "Selecione a etapa para onde o atendimento deve ir.",
      cancel: "Cancelar",
      add: "Adicionar",
      saveEdit: "Salvar",
    },
    flowBuilderDistributionNode: {
      title: "Distribuição",
      roundRobin: "Round Robin",
      leastBusy: "Menos ocupado",
      membersCount: "{{count}} membro(s)",
      noMembers: "Nenhum membro selecionado",
    },
    flowBuilderDistributionModal: {
      addTitle: "Adicionar distribuição ao fluxo",
      editTitle: "Editar distribuição",
      distributionTypeLabel: "Tipo de distribuição",
      roundRobinTitle: "Round Robin",
      roundRobinDesc: "Distribui em sequência, um de cada vez, entre os membros selecionados.",
      leastBusyTitle: "Menos ocupado",
      leastBusyDesc: "Distribui sempre para quem tiver menos conversas em aberto no momento.",
      memberTypeLabel: "Distribuir entre",
      memberTypeUser: "Atendentes",
      memberTypeQueue: "Filas",
      membersLabel: "Membros ({{count}} selecionado(s))",
      membersPlaceholder: "Buscar e selecionar...",
      selectMembersError: "Selecione ao menos um membro para distribuir.",
      add: "Adicionar",
      saveEdit: "Salvar",
    },
    flowBuilderMenu: {
      addTitle: "Adicionar menu ao fluxo",
      editTitle: "Editar menu do fluxo",
      add: "Adicionar",
      save: "Salvar",
      menuMessage: "Mensagem do menu",
      addOption: "Adicionar opção",
      digit: "Dígito",
      typeOption: "Digite a opção",
    },
    flowBuilderInterval: {
      addTitle: "Adicionar intervalo ao fluxo",
      editTitle: "Editar intervalo",
      add: "Adicionar",
      edit: "Editar",
      timeInSeconds: "Tempo em segundos",
      addIntervalError: "O intervalo deve ser maior que 0",
      maxTimeError: "O intervalo não pode ser maior que 120",
    },
    flowBuilderRemoveTag: {
      addTitle: "Remover uma tag do fluxo",
      editTitle: "Editar remoção de tag",
      addRemoval: "Adicionar Remoção",
      edit: "Editar",
      selectTagToRemove: "Selecione uma tag para remover",
      noTagSelected: "Nenhuma tag selecionada",
      chooseTag: "Escolha uma tag para remover do contato",
      actionDescription: "Esta ação removerá a tag selecionada do contato quando o fluxo for executado",
      selectTagError: "Selecione uma tag para remover",
      title: "Remover Tag",
      tagNotSelected: "Tag não selecionada",
      removesTagFromContact: "Remove a tag do contato",
    },
    flowBuilderTicket: {
      add: "Adicionar",
      edit: "Editar",
    },
    flowBuilderVideo: {
      addTitle: "Adicionar video ao fluxo",
      editTitle: "Editar video",
      add: "Adicionar",
      save: "Salvar",
    },
    flowBuilderAudio: {
      addTitle: "Adicionar audio ao fluxo",
      editTitle: "Editar audio",
      add: "Adicionar",
      save: "Salvar",
    },
    flowBuilderGeminiModal: {
      addTitle: "Adicionar Gemini ao fluxo",
      editTitle: "Editar Gemini do fluxo",
      add: "Adicionar",
      save: "Salvar",
      cancel: "Cancelar",
      basicSettings: "Configurações Básicas - Google Gemini",
      assistantName: "Nome do Assistente",
      geminiModel: "Modelo Gemini",
      systemPrompt: "Prompt do Sistema",
      systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
      temperature: "Temperatura",
      temperatureHelper: "0 = conservador, 2 = criativo",
      maxTokensLabel: "Max Tokens",
      maxTokensHelper: "Tamanho máximo da resposta",
      maxMessagesLabel: "Max Mensagens",
      maxMessagesHelper: "Histórico de contexto",
      flowBehavior: "Comportamento do Fluxo",
      flowBehaviorTooltip: "Configure como o Gemini deve se comportar no fluxo",
      operationMode: "Modo de Funcionamento",
      permanent: "Permanente",
      permanentDesc: "Encerrar fluxo aqui",
      permanentHelper: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
      temporary: "Temporário",
      temporaryDesc: "Volta ao fluxo depois",
      temporaryHelper: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
      temporarySettings: "Configurações do Modo Temporário",
      temporarySettingsDesc: "Configure quando a IA deve parar e retornar ao fluxo",
      maxInteractions: "Máximo de Interações",
      maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
      timeoutLabel: "Timeout (minutos)",
      timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
      continueKeywords: "Palavras-chave para Continuar Fluxo",
      keywordPlaceholder: "Digite uma palavra-chave",
      addKeyword: "Adicionar",
      keywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
      objectiveLabel: "Objetivo da IA",
      objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
      objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
      autoComplete: "Auto completar quando atingir objetivo",
      autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
      queueId: "ID da Fila (para transferência)",
      queueIdHelper: "ID da fila para onde transferir se usuário pedir atendente (0 = não transferir)",
    },
    interactiveMessageModal: {
      title: "Enviar Mensagem Interativa",
      subtitle: "Envie mensagens com botões, listas, ofertas, PIX ou links",
      templateActive: "📋 Template: {{name}}",
      cancel: "Cancelar",
      send: "Enviar",
      sending: "Enviando...",
      save: "Salvar",
      saveTemplate: "Salvar Template",
      saveAsTemplate: "Salvar como template",
      loadTemplate: "Carregar template salvo",
      models: "Modelos",
      templateNameLabel: "Nome do template",
      templateNamePlaceholder: "Ex: Boas-vindas com botões",
      saveCurrentConfig: "Salve a configuração atual como um modelo reutilizável para o tipo",
      noTemplates: "Nenhum template salvo para este tipo",
      templateLoaded: "Template \"{{name}}\" carregado",
      templateSaved: "Template salvo!",
      templateRemoved: "Template removido",
      templateSaveError: "Erro ao salvar template",
      templateRemoveError: "Erro ao remover",
      templateNameRequired: "Digite um nome para o template",
      messageSent: "Mensagem interativa enviada!",
      messageError: "Erro ao enviar",
      fillMessageText: "Preencha o texto da mensagem",
      addAtLeastOneButton: "Adicione pelo menos um botão",
      addAtLeastOneOption: "Adicione pelo menos uma opção na lista",
      fillLatLong: "Preencha latitude e longitude",
      fillUrl: "Preencha a URL",
      fillPhone: "Preencha o número de telefone",
      fillPixKey: "Preencha a chave PIX",
      addAtLeast2Options: "Adicione pelo menos 2 opções",
      addAtLeastOneCard: "Adicione pelo menos um card",
      fillBillingDesc: "Preencha a descrição da cobrança",
      pdfUploadError: "Erro ao enviar PDF",
      pdfTooBig: "PDF muito grande (máx. 16MB)",
      previewTitle: "Preview da Mensagem",
      billingDesc: "Descrição da cobrança...",
      messageBody: "Corpo da mensagem...",
      tabs: {
        buttons: "Botões",
        list: "Lista",
        billing: "Cobrança",
        offers: "Ofertas",
        pix: "PIX",
        url: "URL",
        call: "Ligação",
        location: "Local",
        carousel: "Carrossel",
        catalog: "Catálogo",
        poll: "Enquete",
      },
      buttonsTab: {
        info: "Envie até 3 botões clicáveis. O cliente pode tocar em um botão para responder rapidamente.",
        messageText: "Texto da mensagem *",
        footer: "Rodapé (opcional)",
        buttonsMax: "Botões (máx. 3)",
        add: "Adicionar",
        option: "Opção",
      },
      listTab: {
        info: "Envie uma lista com até 10 opções. O cliente abre um menu para selecionar.",
        messageText: "Texto da mensagem *",
        footer: "Rodapé (opcional)",
        buttonText: "Texto do botão",
        sectionTitle: "Título da seção",
        title: "Título",
        description: "Descrição",
        addOption: "Adicionar opção",
        select: "Selecionar",
      },
      offerTab: {
        info: "🏷️ Envie uma oferta com título, preço e descrição.",
        offerTitle: "Título da oferta",
        bodyText: "Descrição / Corpo da mensagem *",
        price: "Preço (ex: 99,90)",
        additionalDetails: "Detalhes adicionais",
        footer: "Rodapé (opcional)",
      },
      pixTab: {
        info: "💰 Envie dados PIX formatados para o cliente.",
        messageText: "Texto da mensagem *",
        pixKey: "Chave PIX *",
        pixKeyPlaceholder: "CPF, CNPJ, e-mail, telefone ou chave aleatória",
        beneficiaryName: "Nome do beneficiário",
        city: "Cidade",
        amount: "Valor",
      },
      urlTab: {
        info: "🔗 Envie um link clicável com texto personalizado.",
        messageText: "Texto da mensagem *",
        linkText: "Texto do link",
        linkPlaceholder: "Clique aqui",
        url: "URL *",
        footer: "Rodapé (opcional)",
      },
      callTab: {
        info: "📞 Envie uma mensagem com número para ligação.",
        messageText: "Texto da mensagem *",
        buttonText: "Texto do botão",
        buttonPlaceholder: "Ligar agora",
        phone: "Número de telefone *",
      },
      locationTab: {
        info: "📍 Envie uma localização para o cliente.",
        messageText: "Texto da mensagem",
        locationName: "Nome do local",
        address: "Endereço",
        latitude: "Latitude *",
        longitude: "Longitude *",
        searchPlaceholder: "Buscar endereço ou local...",
        myLocation: "Minha localização",
        mapHint: "Toque no mapa ou arraste o marcador para definir a localização.",
      },
      carouselTab: {
        info: "🎠 Envie múltiplos cards como carrossel.",
        messageText: "Texto da mensagem *",
        card: "Card",
        title: "Título",
        description: "Descrição",
        addCard: "Adicionar card",
      },
      catalogTab: {
        info: "🛍️ Envie produtos do catálogo como cards.",
        messageText: "Texto da mensagem *",
        product: "Produto",
        productName: "Nome do produto",
        descriptionPrice: "Descrição / Preço",
        addProduct: "Adicionar produto",
      },
      pollTab: {
        info: "📊 Crie uma enquete para o cliente votar.",
        officialNote: "(Será enviada como texto formatado na API Oficial)",
        question: "Pergunta da enquete *",
        optionsMinMax: "Opções (mín. 2, máx. 12)",
        add: "Adicionar",
        option: "Opção",
      },
      billingTab: {
        info: "🧾 Envie uma cobrança com detalhes do pagamento e botão \"Revisar e pagar\".",
        billingNumber: "Nº da cobrança",
        billingDesc: "Descrição da cobrança *",
        billingDescPlaceholder: "Cobrança pensão das crianças",
        quantity: "Quantidade",
        totalAmount: "Valor total *",
        customMessage: "Mensagem personalizada",
        footer: "Rodapé (opcional)",
        attachPdf: "📄 Anexar PDF / Boleto (opcional)",
        selectPdf: "Selecionar PDF",
        paymentButton: "Botão de pagamento",
        buttonText: "Texto do botão",
        paymentUrl: "URL de pagamento (opcional)",
        paymentUrlHelper: "Se preenchido, o botão será um link clicável (CTA URL)",
        reviewAndPay: "Revisar e pagar",
        total: "Total",
        billingNumberLabel: "Nº DA COBRANÇA",
      },
    },
    pairingCodeModal: {
      title: "📱 Conectar via Código de Pareamento",
      instructions: "Informe o número do WhatsApp com",
      countryCode: "código do país + DDD",
      example: "Exemplo:",
      phoneLabel: "Número do WhatsApp",
      phonePlaceholder: "+55 (11) 99999-8888",
      digitsCount: "{{count}}/13 dígitos — código do país + DDD + número",
      generateCode: "Gerar Código",
      tryAgain: "Tentar Novamente",
      close: "Fechar",
      cancel: "Cancelar",
      connected: "Conectado!",
      connectedDesc: "WhatsApp pareado com sucesso. O modal fechará automaticamente.",
      alreadyConnected: "✅ WhatsApp já está conectado!",
      codeNotReturned: "Código de pareamento não retornado pelo servidor.",
      codeGenerated: "🔑 Código gerado! Digite-o no seu WhatsApp em até 60 segundos.",
      whatsappInstructions: "No seu WhatsApp, vá em:",
      whatsappSteps: "Configurações → Dispositivos Vinculados → Vincular um dispositivo",
      tapLinkPhone: "Toque em",
      linkWithPhone: "Vincular com número de telefone",
      enterCodeExact: "e insira o código exatamente como exibido (sem espaços):",
      waitingCode: "Aguardando código...",
      enterCodeInWhatsapp: "Insira o código no WhatsApp",
      codeExpiring: "Código expirando!",
      waitingPairing: "Aguardando você inserir o código no WhatsApp...",
      syncingSession: "Sincronizando sessão... Quase lá!",
      steps: {
        generateCode: "Gerar código",
        enterCode: "Digitar no WhatsApp",
        syncing: "Sincronizando",
        connected: "Conectado",
      },
    },
    campaignContactSelector: {
      newListTitle: "Nova Lista de Contatos",
      stepName: "Nomear lista",
      stepImport: "Importar contatos",
      nameDescription: "Dê um nome para identificar esta lista de contatos.",
      listName: "Nome da lista",
      namePlaceholder: "Ex: Clientes VIP, Prospects Novembro...",
      charsCount: "{{count}}/50 caracteres",
      listCreated: "Lista \"{{name}}\" criada! Agora importe os contatos (opcional).",
      dragExcel: "Arraste o Excel aqui ou clique para selecionar",
      acceptedFormats: "Formatos aceitos: .xls, .xlsx",
      downloadTemplate: "📥 Baixar planilha modelo (.xlsx)",
      close: "Fechar",
      cancel: "Cancelar",
      skipImport: "Pular importação",
      creating: "Criando...",
      createList: "Criar Lista →",
      sending: "Enviando...",
      importContacts: "Importar Contatos",
      selectedForCampaign: "✓ Lista selecionada para esta campanha",
      selectForCampaign: "Selecionar esta lista para a campanha",
      backToCampaign: "Voltar para a Campanha →",
      searchSystemContacts: "Buscar Contatos do Sistema",
      selected: "{{count}} selecionado(s)",
      addingToList: "Adicionando à lista: {{name}}",
      searchPlaceholder: "Buscar por nome ou número...",
      filterByTag: "Filtrar por tag:",
      clearFilters: "Limpar ({{count}})",
      loadingTags: "Carregando tags...",
      noTagsAvailable: "Nenhuma tag disponível.",
      selectAll: "Selecionar todos ({{count}} exibidos)",
      noContactsFound: "Nenhum contato encontrado.",
      tryAnotherSearch: "Tente buscar por outro nome ou número.",
      name: "Nome",
      number: "Número",
      loadMore: "Carregar mais",
      cancelSearch: "Cancelar",
      adding: "Adicionando...",
      addToList: "Adicionar {{count}} à lista",
      contactLists: "Listas de Contatos",
      createListsDesc: "Crie listas, importe contatos e selecione a lista que será usada nesta campanha.",
      simpleList: "Lista Simples",
      newListExcel: "Nova Lista + Excel",
      selectedList: "Lista selecionada: {{name}}",
      contactsCount: "{{count}} contatos — esta lista será usada na campanha",
      remove: "Remover",
      searchList: "Buscar lista...",
      noListsYet: "Nenhuma lista criada ainda.",
      clickNewList: "Clique em \"Nova Lista\" para começar.",
      selectedBadge: "Selecionada",
      contacts: "contatos",
      alreadySelected: "Lista já selecionada",
      selectForCampaignTooltip: "Selecionar para a campanha",
      searchSystemContactsTooltip: "Buscar contatos do sistema para esta lista",
      editList: "Editar lista",
      deleteList: "Excluir lista",
      deleteListConfirm: "Excluir a lista \"{{name}}\"?",
      listSelected: "Lista \"{{name}}\" selecionada para a campanha!",
      listRemoved: 'Lista removida com sucesso',
      importStarted: 'Importação iniciada! Os contatos serão carregados em breve.',
      invalidFormat: 'Formato inválido. Use apenas arquivos .xls ou .xlsx',
      fileUploaded: 'Arquivo enviado! Os contatos serão carregados em breve.',
      searchContact: 'Buscar contato...',
      selectThisList: 'Selecionar esta lista para a campanha',
      listSelectedToast: 'Lista "{{name}}" selecionada para a campanha!',
      nameList: 'Nomear lista',
      giveNameToList: 'Dê um nome para identificar esta lista de contatos.',
      listNamePlaceholder: 'Ex: Clientes VIP, Prospects Novembro...',
      characters: 'caracteres',
      searchByNameOrNumber: 'Buscar por nome ou número...',
      listAlreadySelected: 'Lista já selecionada',
      selectWhatsapp: 'Selecione uma conexão WhatsApp na campanha antes de importar.',
    },
    contactsPage: {
      importFromPhone: "Importar contatos do telefone",
      selectConnection: "Selecione a conexão WhatsApp de onde deseja importar os contatos:",
      noConnectionFound: "Nenhuma conexão WhatsApp conectada encontrada.",
      selectAConnection: "Selecione uma conexão",
      noNumber: "sem número",
      cancel: "Cancelar",
      import: "Importar",
      profilePhoto: "Foto de Perfil",
      imageNotAvailable: "Imagem não disponível",
      blockContact: "Bloquear Contato {{name}}?",
      unblockContact: "Desbloquear Contato {{name}}?",
      contactBlocked: "Contato bloqueado",
      contactUnblocked: "Contato desbloqueado",
      deleteAll: "Excluir Todos ({{count}})",
      deleteSelected: "Excluir Selecionados ({{count}})",
      delete: "Excluir",
      selectAtLeastOne: "Selecione pelo menos um contato para excluir",
      allDeleted: "Todos os {{count}} contatos foram excluídos",
      selectedDeleted: "{{count}} contatos excluídos com sucesso",
      importStarting: "Iniciando importação...",
      importSuccess: "Contatos importados com sucesso!",
      notSynced: "Contatos ainda não sincronizados. Conecte o celular e aguarde.",
      importError: "Erro ao importar contatos",
    },
    kanbanCard: {
      assignValue: "Atribuir Valor",
      value: "Valor: {{value}}",
      remove: "Remover",
      viewTicket: "Ver Ticket",
      editValue: "Editar",
      assignValueTitle: "Atribuir Valor da Oportunidade",
      editValueTitle: "Editar Valor da Oportunidade",
      valueLabel: "Valor",
      cancel: "Cancelar",
      save: "Salvar",
      noName: "Sem nome",
      noMessages: "Sem mensagens",
      pending: "Pendente",
      addValue: "Adicionar valor",
      viewChat: "Visualizar conversa",
      slaOnTime: "No prazo",
      slaWarning: "Atenção",
      slaOverdue: "Atrasado",
    },
    kanbanColumn: {
      searchPlaceholder: "Buscar por nome, número...",
      noResults: "Nenhum resultado",
      noTickets: "Nenhum ticket",
      slaOnTime: "No prazo",
      slaWarning: "Atenção",
      slaOverdue: "Atrasado",
      totalValue: "Valor total",
    },
    kanbanLanes: {
      novo: "Novo",
      emAnalise: "Em análise",
      aguardandoCliente: "Aguardando cliente",
      resolvido: "Resolvido",
      lead: "Lead",
      qualificado: "Qualificado",
      proposta: "Proposta",
      fechado: "Fechado",
      perdido: "Perdido",
      emAberto: "Em aberto",
      negociacao: "Negociação",
      acordo: "Acordo",
      pago: "Pago",
      inadimplente: "Inadimplente",
      boasVindas: "Boas-vindas",
      treinamento: "Treinamento",
      ativacao: "Ativação",
      clienteAtivo: "Cliente ativo",
    },
    kanbanChat: {
      statusOpen: "Aberto",
      statusPending: "Pendente",
      statusClosed: "Fechado",
      contact: "Contato",
      noQueue: "Sem fila",
      noMessages: "Nenhuma mensagem ainda",
      inputPlaceholder: "Digite uma mensagem...",
    },
    tooltips: {
      edit: "Editar",
      delete: "Excluir",
      report: "Relatório",
      syncTemplates: "Sincronizar templates",
      copyWebhook: "Copiar webhook",
    },
    telegram: {
      botTokenTitle: "🤖 Token do Bot Telegram",
      botTokenHelp: "Crie um bot no @BotFather do Telegram e cole o token aqui. O webhook será configurado automaticamente ao salvar.",
      botTokenLabel: "Bot Token",
      webhookUrl: "Webhook URL",
      connectBot: "Conectar Bot",
      chip: "TELEGRAM",
    },
    locationPreview: {
      openInMaps: "Abrir no Google Maps",
    },
    flowBuilderConditionCompare: {
      saving: "Salvando...",
      saveChanges: "Salvar alterações",
      add: "Adicionar",
    },
    flowBuilderStart: {
      title: "Início do fluxo",
      description: "Este bloco marca o início do seu fluxo!",
    },
    flowBuilderConditionCompareNode: {
      title: "Se / Senão",
      contains: "contém",
      notContains: "não contém",
      containsAny: "contém algum",
      startsWith: "inicia com",
      endsWith: "termina com",
      isEmpty: "vazio",
      isNotEmpty: "não vazio",
      regex: "regex",
      field: "campo",
      value: "valor",
      and: "E",
      or: "OU",
      true: "Verdadeiro",
      false: "Falso",
    },
    flowBuilderHttpRequest: {
      title: "Requisição HTTP",
      preconfiguredWebhooks: "Webhooks Pré-configurados",
      selectPreset: "Selecionar preset",
      choosePreset: "Escolha uma configuração pronta...",
      system: "SISTEMA",
      remove: "Remover",
      usingPreset: "Usando preset:",
      urlFromPreset: "URL (do preset)",
      urlPlaceholder: "https://api.exemplo.com/webhook",
      editPresetUrl: "Você pode editar a URL base do preset se necessário",
      method: "Método",
      testRequest: "Testar Requisição",
      apiResponse: "Resposta da API:",
      viewFullResponse: "Ver resposta completa",
      hideAdvanced: "Ocultar avançado",
      showAdvanced: "Mostrar avançado",
      advancedWarning: "Configurações avançadas podem sobrescrever as configurações do preset",
      timeoutMs: "Timeout (ms)",
      queryParams: "Parâmetros de Query",
      key: "Chave",
      addParam: "Adicionar Parâmetro",
      headersJson: "Cabeçalhos (JSON)",
      requestBody: "Corpo da requisição (JSON)",
      editRequestBody: "Editar corpo da requisição",
      close: "Fechar",
      hideMapVars: "Ocultar Variáveis da Resposta",
      showMapVars: "Mapear Variáveis da Resposta",
      mapResponseData: "Mapear dados da resposta para variáveis",
      path: "Caminho",
      pathPlaceholder: "ex: data.user.id",
      variableName: "Nome da variável",
      variablePlaceholder: "ex: userId",
      addVariable: "Adicionar variável",
      tips: "Dicas úteis:",
      tipAutoSave: "A resposta completa da API é salva automaticamente na variável global",
      tipVarUsage: "Você pode usar ${nomeDaVariavel} no URL e corpo da requisição para incluir valores de variáveis.",
      requestError: "Erro na requisição",
      configSaved: "Configuração salva!",
      fullApiResponse: "Resposta completa da API",
      presetError: "Erro ao aplicar configuração do preset",
      value: "Valor",
    },
    flowBuilderInteractiveNode: {
      title: "Msg Interativa API",
      buttons: "Botões",
      maxButtons: "máx. 3",
      messageBody: "Corpo da mensagem...",
      select: "Selecionar",
      button: "Botão",
      item: "Item",
    },
    flowBuilderVariable: {
      title: "Variável Global",
      variableName: "Nome da variável",
      value: "Valor",
      helperText: "Você pode usar valores estáticos ou referências como ${outraVariavel}",
      saved: "Salvo!",
      saveVariable: "Salvar variável",
      variableSavedSuccess: "Variável salva com sucesso!",
    },
    flowBuilderAiAgent: {
      title: "Agente de IA",
      selectAgent: "Selecione um agente",
    },
    flowBuilderAttendant: {
      title: "Atendente",
    },
    flowBuilderAudioNode: {
      title: "Áudio",
      recordedLive: "Gravado na hora",
      audioSent: "Áudio enviado",
    },
    flowBuilderVideoNode: {
      title: "Vídeo",
    },
    flowBuilderMessageNode: {
      title: "Mensagem",
    },
    flowBuilderConditionNode: {
      title: "Condição",
    },
    flowBuilderImageNode: {
      title: "Imagem",
    },
    flowBuilderInputNode: {
      title: "Input",
      question: "Pergunta:",
      questionNotDefined: "Pergunta não definida",
      variableToStore: "Variável para armazenar resposta:",
      variableNotDefined: "Variável não definida",
      usingVariables: "Usando variáveis:",
      alwaysAsk: "Sempre perguntar (mesmo se variável já existir)",
    },
    flowBuilderMenuNode: {
      title: "Menu Numérico",
    },
    flowBuilderIntervalNode: {
      title: "Intervalo",
    },
    flowBuilderRandomizerNode: {
      title: "Randomizador",
    },
    flowBuilderSingleBlockNode: {
      title: "Conteúdo",
    },
    flowBuilderSwitchFlowNode: {
      title: "Trocar Fluxo",
    },
    flowBuilderTypebotNode: {
      title: "TypeBot",
      description: "Encaminha a conversa para um fluxo do Typebot. Útil para formulários, qualificação e respostas guiadas. O cliente interage com o bot e o fluxo retoma quando o Typebot finaliza ou pela palavra-chave configurada.",
    },
    flowBuilderQuestionNode: {
      title: "Pergunta",
    },
    flowBuilderTagNode: {
      title: "Tag",
    },
    flowBuilderTicketNode: {
      title: "Fila",
    },
    flowBuilderAiAgentModal: {
      addTitle: "Adicionar Agente de IA",
      editTitle: "Editar Agente de IA",
      add: "Adicionar",
      save: "Salvar",
      cancel: "Cancelar",
      selectAgent: "Selecione um Agente de IA",
      agentLabel: "Agente de IA",
      selectPlaceholder: "Selecione...",
      subtitle: "Selecione um agente ativo para usar neste fluxo",
      noAgentsFound: "Nenhum agente ativo encontrado. Crie um agente na página \"Agentes de IA\".",
      defaultAgentName: "Agente de IA",
    },
    flowBuilderValidation: {
      tooShort: "Muito curto!",
      tooLong: "Muito longo!",
      enterName: "Digite um nome!",
      enterMessage: "Digite uma mensagem!",
      required: "Obrigatório",
    },
    audioTranscription: {
      transcription: "Transcrição:",
      transcribing: "Transcrevendo...",
      transcribe: "Transcrever",
      failed: "Conversão para texto falhou",
    },
    birthdayModal: {
      congratulations: "🎉 Parabéns!",
      specialDay: "Hoje é um dia especial!",
      loading: "Carregando aniversariantes...",
      youLabel: "(Você!)",
      systemUser: "Usuário do Sistema",
      contact: "Contato",
      sending: "Enviando...",
      messageSent: "Mensagem já enviada",
      sendCongrats: "Enviar Parabéns",
      remindLater: "Lembrar mais tarde",
      understood: "Entendi, obrigado!",
      year: "ano",
      years: "anos",
      notAvailable: "N/A",
      toasts: {
        sent: "Mensagem de parabéns enviada para {{name}}! 🎉",
        alreadySent: "Mensagem de aniversário já foi enviada hoje para este contato",
        loadError: "Erro ao carregar aniversariantes",
        sendError: "Erro ao enviar mensagem de aniversário",
      },
    },
    birthdaySettings: {
      title: "🎂 Configurações de Aniversário",
      loading: "Carregando configurações...",
      userSection: "Aniversários de Usuários",
      contactSection: "Aniversários de Contatos",
      generalSection: "Configurações Gerais",
      enableUserNotifications: "Habilitar notificações de aniversário de usuários",
      enableUserNotificationsHelp: "Quando habilitado, será exibido modal de parabéns e criado informativo automático",
      createAnnouncementUsers: "Criar informativo automático para aniversários de usuários",
      createAnnouncementUsersHelp: "Cria um informativo automático que é exibido para todos os usuários da empresa",
      userBirthdayMessage: "Mensagem de aniversário para usuários",
      userMessageHelper: "Use {nome} para incluir o nome do usuário",
      enableContactMessages: "Habilitar envio automático de mensagens de aniversário para contatos",
      enableContactMessagesHelp: "Envia automaticamente mensagem de parabéns via WhatsApp para contatos aniversariantes",
      contactBirthdayMessage: "Mensagem de aniversário para contatos",
      contactMessageHelper: "Use {nome} para incluir o nome do contato e {idade} para a idade",
      testMessage: "Testar Mensagem",
      sendTime: "Horário de envio das mensagens",
      sendTimeHelper: "Horário em que as mensagens automáticas serão enviadas",
      whatsappConnection: "Conexão WhatsApp para Envio",
      selectConnection: "Selecione uma conexão",
      whatsappConnectionHelp: "Conexão WhatsApp que será usada para enviar mensagens de aniversário",
      createInternalAnnouncement: "Criar informativo interno para aniversários de usuários",
      createInternalAnnouncementHelp: "Cria um informativo interno quando um usuário faz aniversário",
      availableVariables: "Variáveis disponíveis nas mensagens:",
      varName: "Nome da pessoa",
      varAge: "Idade da pessoa (apenas para contatos)",
      preview: "Pré-visualização:",
      saving: "Salvando...",
      saveSettings: "Salvar Configurações",
      toasts: {
        saved: "Configurações de aniversário salvas com sucesso! 🎉",
        loadError: "Erro ao carregar configurações de aniversário",
        saveError: "Erro ao salvar configurações",
        testSent: "Mensagem de teste enviada! 📱",
        testError: "Erro ao enviar mensagem de teste",
      },
    },
    // (bloco campaignModal duplicado removido — todas as chaves foram mescladas no bloco principal acima, próximo à linha 2851)
    campaignModalPhrase: {
      campaignName: "Nome da campanha",
      nameRequired: "Nome é obrigatório",
      selectFlow: "Selecione um fluxo",
      flowRequired: "Fluxo é obrigatório",
      connections: "Conexões WhatsApp",
      connectionsMultiple: "(Múltiplas)",
      atLeastOneConnection: "Você deve selecionar pelo menos uma conexão",
      connectionsSelected: "{{count}} conexão(ões) selecionada(s):",
      connectionsInfo: "A campanha será executada quando qualquer conexão receber mensagens que correspondam às frases configuradas.",
      filterByTag: "Filtrar por Tag do Contato",
      optional: "(opcional)",
      filterByTagDesc: "Se selecionado, o fluxo só será disparado para contatos que tenham pelo menos uma destas tags.",
      tagsLabel: "Tags (opcional)",
      filterActive: "🏷️ Filtro ativo: o fluxo só será disparado para contatos com pelo menos uma das {{count}} tag(s) selecionada(s).",
      triggerKeywords: "Palavras-chave que disparam o fluxo",
      logicOr: "🔀 Lógica OU: o fluxo será disparado se o contato enviar qualquer uma das palavras/frases abaixo.",
      exactLabel: "Exata: mensagem idêntica.",
      partialLabel: "Parcial: palavra contida em qualquer parte da mensagem.",
      orChip: "OU",
      phraseLabel: "Palavra/frase {{index}}",
      phrasePlaceholder: "Ex: olá, quero orçamento...",
      fieldRequired: "Campo obrigatório",
      typeLabel: "Tipo",
      exact: "Exata",
      partial: "Parcial",
      addPhrase: "+ Adicionar outra palavra/frase (OU)",
      active: "Ativa",
      inactive: "Inativa",
      saving: "Salvando...",
      update: "Atualizar",
      create: "Criar",
      fillAllFields: "Por favor, preencha todos os campos obrigatórios",
      flowNotFound: "Fluxo selecionado não encontrado",
      toasts: {
        updated: "Campanha atualizada!",
        created: "Campanha criada!",
        saveError: "Erro ao salvar campanha",
        loadFlowsError: "Erro ao carregar fluxos",
        loadConnectionsError: "Erro ao carregar conexões",
        loadDataError: "Erro ao carregar dados da campanha",
      },
    },
    contactNotes: {
      deleteTitle: "Excluir Registro",
      deleteConfirm: "Deseja realmente excluir este registro?",
      noteAdded: "Observação adicionada com sucesso!",
      noteDeleted: "Observação excluída com sucesso!",
      cancel: "Cancelar",
      save: "Salvar",
      close: "Fechar",
    },
    contactDeleteConfirm: {
      titleAll: "Excluir TODOS os {{count}} contatos?",
      titleSelected: "Excluir {{count}} contatos selecionados?",
      warningAll: "⚠️ ATENÇÃO: Esta ação irá excluir TODOS os {{count}} contatos da empresa permanentemente!",
      warningAllBody: "Esta operação não pode ser desfeita. Todos os contatos, seus históricos de mensagens, tags e relacionamentos serão perdidos definitivamente.",
      warningSelected: "Esta ação irá excluir {{count}} contatos selecionados permanentemente.",
      warningSelectedBody: "Os contatos selecionados e seus dados relacionados serão excluídos definitivamente.",
      confirmPrompt: "Para confirmar, digite exatamente:",
      confirmLabel: "Confirmação",
      cancel: "Cancelar",
      deleteAll: "Excluir Todos",
      deleteSelected: "Excluir Selecionados",
      expectedAll: "EXCLUIR TODOS",
      expectedSelected: "EXCLUIR SELECIONADOS",
      typeExact: "Digite exatamente: {{text}}",
    },
    colorBoxModal: {
      title: "Escolha uma cor",
      cancel: "Cancelar",
      ok: "OK",
    },
    contactGroupModal: {
      title: "Criar Grupo de Contatos",
      groupName: "Nome do Grupo",
      groupNamePlaceholder: "Ex: Clientes VIP, Leads Janeiro...",
      searchPlaceholder: "Buscar contatos...",
      selectedCount: "{{count}} contato(s) selecionado(s)",
      clearSelection: "Limpar seleção",
      name: "Nome",
      number: "Número",
      email: "Email",
      tags: "Tags",
      noContacts: "Nenhum contato encontrado",
      perPage: "Por página:",
      displayedRows: "{{from}}-{{to}} de {{count}}",
      cancel: "Cancelar",
      creating: "Criando...",
      createGroup: "Criar Grupo ({{count}} contatos)",
      groupNameRequired: "Informe um nome para o grupo",
      selectAtLeastOne: "Selecione pelo menos um contato",
      groupCreated: "Grupo \"{{name}}\" criado com {{count}} contatos",
    },
    contactListTable: {
      name: "Nome",
      contacts: "Contatos",
      actions: "Ações",
    },
    contactTagListModal: {
      contacts: "Contatos",
      id: "ID",
      name: "Nome",
      number: "Número",
      actions: "Ações",
    },
    contactsFilter: {
      placeholder: "Contatos",
    },
    contactImport: {
      fields: {
        name: "Nome",
        number: "Número",
        email: "E-mail",
        birthDate: "Data de Nascimento",
        tags: "Tags",
        wallet: "Carteira",
      },
      errors: {
        noNumber: "Não foi selecionado o campo de número do contato",
        noName: "Não foi selecionado o campo de nome do contato",
        noSelection: "Nenhum contato selecionado",
        fieldAlreadySelected: "O campo {{field}} já foi selecionado.",
      },
      results: {
        title: "Resultado da importação",
        created: "✅ {{count}} contatos criados com sucesso",
        ignored: "⚠️ {{count}} contatos ignorados (número inválido ou não marcados para atualizar)",
        successAll: "Importação realizada com sucesso! {{count}} contatos importados.",
        successPartial: "Importação concluída: {{created}} contatos importados e {{ignored}} ignorados.",
        failed: "Falha na importação. Nenhum contato foi importado.",
        importMore: "Importar mais contatos",
      },
      validateSwitch: "Validar contatos no WhatsApp",
      uploading: "Importando... Aguarde",
      importButton: "Importar contatos",
      cancel: "Cancelar",
      processing: "Processando arquivo...",
      invalidFile: "Arquivo inválido!",
      invalidFileDesc: "O arquivo que você tentou importar não é válido. Por favor, tente novamente com um arquivo no formato correto.",
      tryAgain: "Tentar novamente",
      dropzoneTitle: "Clique ou arraste um arquivo Excel",
      dropzoneFormats: "* Formatos aceitos: xls, xlsx, csv, txt",
      dropzoneHelp: "Para importar contatos, você deve ter pelo menos as colunas de nome e número de telefone.",
      back: "Voltar",
    },
    contactImportWpModal: {
      importingPhone: "Importando contatos do telefone...",
      importPhoneButton: "📱 Importar contatos do telefone (WhatsApp)",
      phoneImported: "Contatos do telefone importados com sucesso!",
      statusInProgress: "importação em andamento {{current}} de {{total}} não saia desta tela até concluir a importação",
      statusComplete: "importação concluída com exito a importação",
    },
    contactDrawer: {
      noParticipants: "Nenhum participante encontrado",
      chat: "Conversar",
      superAdmin: "Super Admin",
      admin: "Admin",
      participant: "Participante",
      searching: "Buscando...",
      noMessages: "Nenhuma mensagem encontrada",
      searchPlaceholder: "Pesquisar nas mensagens...",
      infoTab: "Informações",
      imagesTab: "Imagens",
      videosTab: "Vídeos",
      audiosTab: "Áudios",
      documentsTab: "Documentos",
      linksTab: "Links",
      participantsTab: "Participantes",
      noImages: "Nenhuma imagem encontrada",
      noVideos: "Nenhum vídeo encontrado",
      noAudios: "Nenhum áudio encontrado",
      noDocs: "Nenhum documento encontrado",
      noLinks: "Nenhum link encontrado",
      contactUpdated: "Contato atualizado com sucesso!",
      contactBlocked: "Contato bloqueado",
      contactUnblocked: "Contato desbloqueado",
      blockTooltip: "Bloquear contato",
      unblockTooltip: "Desbloquear contato",
      lidWarning: "⚠️ Possível erro: Número parece ser LID",
      you: "(Você)",
      exportParticipants: "Exportar Participantes",
      noParticipantsExport: "Não há participantes para exportar",
      exportSuccess: "Arquivo \"{{name}}\" exportado com sucesso!",
      noName: "Sem nome",
    },
    companiesManager: {
      generateInvoice: "Gerar Fatura",
      yes: "Sim",
      no: "Não",
      loadError: "Não foi possível carregar a lista de registros",
      operationSuccess: "Operação realizada com sucesso!",
      operationError: "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
      deleteError: "Não foi possível realizar a operação",
    },
    birthdaySettingsPage: {
      title: "🎂 Configurações de Aniversário",
    },
    groupManager: {
      title: "Gestor de Grupos",
      groups: "Grupos",
      refresh: "Atualizar",
      sync: "Sincronizar Grupos",
      syncing: "Sincronizando...",
      clearAll: "Limpar todos os grupos",
      selectConnection: "Selecione uma conexão",
      selectConnectionFirst: "Selecione uma conexão para começar",
      clickSyncToLoad: "Clique em Sincronizar para carregar os grupos",
      connection: "Conexão",
      allConnections: "Todas as conexões",
      searchGroup: "Buscar grupo...",
      noGroupsFound: "Nenhum grupo encontrado",
      noName: "Sem nome",
      connectionLabel: "Conexão {{id}}",
      selectGroup: "Selecione um grupo",
      selectGroupDesc: "Escolha um grupo na lista para gerenciar",
      participants: "participantes",
      groupActions: "Ações do Grupo",
      changeName: "Alterar nome",
      changeNameDesc: "Mudar o nome do grupo",
      changeDescription: "Alterar descrição",
      changeDescriptionDesc: "Editar a descrição do grupo",
      inviteLink: "Link de convite",
      inviteLinkDesc: "Gerar ou copiar link de compartilhamento",
      addParticipants: "Adicionar participantes",
      addParticipantsDesc: "Adicionar pelo número do telefone",
      sendMessage: "Enviar mensagem",
      sendMessageDesc: "Enviar mensagem ao grupo com menção fantasma",
      settings: "Configurações",
      onlyAdminsSend: "Somente admins enviam",
      onlyAdminsSendDesc: "Apenas administradores podem enviar mensagens",
      restrictEdit: "Restringir edição",
      restrictEditDesc: "Somente admins editam dados do grupo",
      participantsCount: "Participantes ({{count}})",
      creator: "Criador",
      admin: "Admin",
      demoteAdmin: "Rebaixar de admin",
      promoteAdmin: "Promover a admin",
      removeFromGroup: "Remover do grupo",
      dialogChangeName: "Alterar nome do grupo",
      groupName: "Nome do grupo",
      cancel: "Cancelar",
      save: "Salvar",
      dialogChangeDesc: "Alterar descrição do grupo",
      description: "Descrição",
      dialogInviteLink: "Link de convite",
      close: "Fechar",
      dialogAddParticipants: "Adicionar participantes",
      phoneNumbers: "Número(s) do telefone",
      phoneNumbersPlaceholder: "5521999999999 (separe por vírgula para vários)",
      phoneNumbersHelper: "Informe o número com DDI+DDD, sem espaços. Ex: 5521999999999",
      add: "Adicionar",
      dialogSendMessage: "Enviar mensagem ao grupo",
      message: "Mensagem",
      mentionAll: "Mencionar todos os participantes (menção fantasma)",
      send: "Enviar",
      confirmRemoveParticipant: "Tem certeza que deseja remover este participante?",
      toasts: {
        loadError: "Erro ao carregar grupos",
        selectConnectionFirst: "Selecione uma conexão primeiro",
        syncSuccess: "{{count}} grupos sincronizados!",
        metadataError: "Erro ao carregar dados do grupo",
        nameUpdated: "Nome do grupo atualizado!",
        nameError: "Erro ao atualizar nome do grupo",
        descUpdated: "Descrição atualizada!",
        descError: "Erro ao atualizar descrição",
        inviteLinkError: "Erro ao gerar link de convite",
        linkCopied: "Link copiado!",
        participantAdded: "Participante(s) adicionado(s)!",
        participantAddError: "Erro ao adicionar participante",
        messageSent: "Mensagem enviada!",
        messageError: "Erro ao enviar mensagem",
        settingUpdated: "Configuração atualizada!",
        settingError: "Erro ao atualizar configuração",
        participantRemoved: "Participante removido!",
        removeError: "Erro ao remover participante",
        promoted: "Participante promovido a admin!",
        promoteError: "Erro ao promover participante",
        demoted: "Admin rebaixado!",
        demoteError: "Erro ao rebaixar participante",
      },
    },
    contactImportPage: {
      title: "Importar contatos de arquivo",
    },
    forwardMessageModal: {
      title: "Encaminhar mensagem",
      noContactFound: "Nenhum contato encontrado com o nome {{name}}",
      sending: "Enviando {{id}}...",
      forward: "Encaminhar",
    },
    newTicketModal: {
      selectQueue: "Selecione uma fila",
      selectConnection: "Selecione uma Conexão",
      createAndSendTemplate: "Criar e Enviar Template",
    },
    finalizacaoVendaModal: {
      title: "Finalização de Atendimento - Valor de Venda",
      loading: "Carregando configurações...",
      saleCompleted: "A venda foi concluída?",
      yes: "Sim, venda concluída",
      no: "Não, venda não concluída",
      saleValue: "Valor da Venda",
      noSaleReason: "Motivo da Não Venda *",
      finalizationReason: "Motivo da Finalização *",
      selectReason: "Selecione um motivo",
      cancel: "Cancelar",
      finalizing: "Finalizando...",
      finalize: "Finalizar Atendimento",
      errorSaleValue: "Por favor, informe o valor da venda.",
      errorNoSaleReason: "Por favor, selecione o motivo da não venda.",
      errorFinalizationReason: "Por favor, selecione o motivo da finalização.",
    },
    forbiddenPage: {
      title: "403",
      message: "Oops! Acesso Negado!",
      back: "Voltar",
    },
    showTicketLogModal: {
      close: "Fechar",
    },
        backupRestore: {
          backupTitle: "Backup do Banco de Dados",
          backupDescription: "Faça o download de uma cópia completa do banco de dados. Escolha o formato desejado:",
          backupSQL: "Backup SQL (.sql)",
          backupJSON: "Backup JSON (.json)",
          generating: "Gerando...",
          tip: "O backup SQL é ideal para restauração completa. O backup JSON é útil para análise e migração de dados.",
          restoreTitle: "Restaurar Banco de Dados",
          dangerZone: "Zona de perigo",
          dangerDescription: "A restauração irá sobrescrever todos os dados atuais do banco. Certifique-se de ter um backup atualizado antes de prosseguir.",
          restoring: "Restaurando...",
          uploadRestore: "Enviar arquivo .sql para restaurar",
          confirmRestore: "⚠️ ATENÇÃO: A restauração irá sobrescrever os dados atuais do banco. Tem certeza que deseja continuar? Recomendamos fazer um backup antes.",
          important: "Importante",
          importantText: "Após restaurar o backup, reinicie o servidor para que as conexões com Redis/Bull sejam recriadas corretamente.",
          toasts: {
            sqlSuccess: "Backup SQL baixado com sucesso!",
            sqlError: "Erro ao gerar backup SQL.",
            jsonSuccess: "Backup JSON baixado com sucesso!",
            jsonError: "Erro ao gerar backup JSON.",
            sqlOnly: "Apenas arquivos .sql são aceitos para restauração.",
            restoreSuccess: "Banco restaurado com sucesso! Recarregue a página.",
            restoreError: "Erro ao restaurar o banco de dados.",
          },
        },
        smtpSettings: {
          title: "Configurações SMTP",
          description: "Configure o servidor de e-mail para envio de códigos de recuperação de senha e notificações.",
          server: "Servidor SMTP",
          port: "Porta",
          secure: "Conexão segura (SSL/TLS na porta 465)",
          secureHelp: "Ative para usar SSL/TLS direto (porta 465). Desativado usa STARTTLS (porta 587).",
          senderEmail: "E-mail do Remetente",
          senderName: "Nome do Remetente",
          senderNameHelp: "Ex.: CRM Moovein. O e-mail remetente será o campo acima.",
          authentication: "Autenticação",
          authMethod: "Método de Autenticação",
          password: "Senha (Padrão)",
          passwordLabel: "Senha",
          gmailHelp: "Para Gmail, use uma \"Senha de App\" gerada em myaccount.google.com/apppasswords",
          save: "Salvar",
          testConfig: "Testar Configuração",
          testEmail: "E-mail para teste",
          sendTest: "Enviar Teste",
          toasts: {
            saveSuccess: "Configurações SMTP salvas com sucesso!",
            saveError: "Erro ao salvar configurações SMTP.",
            emailRequired: "Informe um e-mail para teste.",
            testSuccess: "E-mail de teste enviado com sucesso!",
            testError: "Falha ao enviar e-mail de teste. Verifique as configurações.",
          },
        },
        uploaderCert: {
          noPermission: "Sem permissão para acessar!",
          p12Only: "Use somente arquivos em formato p12!",
          chooseFile: "Escolha um arquivo!",
          chooseDestination: "Escolha um destino!",
          uploadSuccess: "Arquivo enviado com sucesso!",
          tabLabel: "Certificado Efí - API PIX (p12)",
          chooseOption: "Escolha uma opção:",
          certOption: "Certificado Efí p12 API PIX",
          chooseCert: "Escolher Certificado Efí p12 API PIX",
          submit: "ENVIAR CERTIFICADO",
        },
        triggerFlowModal: {
          selectRequired: "Selecione um fluxo para disparar",
          success: "Fluxo disparado com sucesso!",
          processingMessage: "Disparando fluxo... Campo de mensagem temporariamente desabilitado.",
        },
        queueOptions: {
          titlePlaceholder: "Título da opção",
          untitled: "Título não definido",
          messagePlaceholder: "Digite o texto da opção",
          add: "Adicionar",
          options: "Opções",
        },
        flowBuilderAudio: {
          toasts: {
            success: "Áudio adicionado com sucesso!",
            fileTooLarge: "Arquivo é muito grande! 5MB máximo",
          },
          captionLabel: "Legenda (opcional)",
          sendAudio: "Enviar audio",
          sendAsRecorded: "Enviar como audio gravado na hora",
        },
        common: {
          browserNoSupport: "Seu navegador não suporta HTML5",
        },
        flowBuilderVideo: {
          toasts: {
            success: "Vídeo adicionado com sucesso!",
            fileTooLarge: "Arquivo é muito grande! 20MB máximo",
          },
          sendVideo: "Enviar video",
          mp4Only: "ATENÇÃO! Apenas videos em MP4!",
        },
        flowBuilder: {
          condition: {
            commaSeparated: "Valores separados por vírgula",
            comparisonValue: "Valor da comparação",
            typeDollar: "Digite $ para ver variáveis disponíveis",
            regexHelper: "Ex: ^[0-9]{11}$ — expressão regular JavaScript",
            anyTokenHelper: "Qualquer token da lista dispara Verdadeiro",
            fixedOrVariable: "Valor fixo ou variável com $",
            insertVarSelector: "Inserir variável pelo seletor",
            errors: {
              variableRequired: "Condição {{num}}: o campo \"Variável / Campo\" é obrigatório",
              valueRequired: "Condição {{num}}: o campo \"Valor da comparação\" é obrigatório",
              saveError: "Ocorreu um erro ao salvar. Tente novamente.",
            },
            editCondition: "Editar Condição",
            newCondition: "Nova Condição",
            howItWorksTitle: "Como funciona este nó",
            howItWorksDesc: "Compara um valor (à esquerda) com outro (à direita) usando o operador escolhido. Se Verdadeiro, segue pelo caminho verde; se Falso, pelo vermelho. Você pode somar várias condições ligadas por E (todas precisam ser verdadeiras) ou OU (basta uma). Use ${variavel} para referenciar dados do ticket — ex.: ${ticketTags}, ${ticketQueue}, ${nome}, ${telefone}, ${ticketStatus}.",
            howItWorksExample: "Ex.: ${ticketTags} contém SUPORTE  →  Verdadeiro se a tag SUPORTE estiver no ticket.",
            and: "E (AND)",
            or: "OU (OR)",
            addCondition: "Adicionar condição",
            logic: "Lógica: Verdadeiro se",
            allConditions: "TODAS as condições",
            anyCondition: "QUALQUER condição",
            areSatisfied: "forem satisfeitas",
            quickTips: "Dicas rápidas",
            containsAnyTip: "Contém qualquer (,): separe tokens por vírgula",
            regexTip: "Regex: use expressão JS",
            dynamicVarTip: "Use ${variavel} em qualquer campo para referenciar valores dinâmicos",
            selectVariable: "Selecionar variável",
            varsFound: "{{count}} variável(is) encontrada(s) no fluxo",
            addVarNodes: "Adicione nós de Variável Global ou Input para variáveis dinâmicas",
            searchVar: "Buscar variável...",
            noVarsFound: "Nenhuma variável encontrada",
            flowVariables: "Variáveis do fluxo",
          },
        },
        flowBuilderInteractive: {
          title: "Mensagem Interativa (Baileys)",
          editTitle: "Editar Mensagem Interativa",
          add: "Adicionar",
          save: "Salvar",
          selectDefault: "Selecionar",
          toasts: {
            messageRequired: "O corpo da mensagem é obrigatório!",
            addOption: "Adicione pelo menos uma opção!",
            imageError: "Erro ao enviar imagem",
            fileTooLarge: "Arquivo muito grande! Máximo 2MB",
          },
          preview: "Pré-visualização",
          messagePlaceholder: "Corpo da mensagem...",
          messageType: "Tipo de mensagem interativa",
          buttonsMax3: "Botões (máx. 3)",
          infoText: "Botões interativos via Baileys (nativeFlowMessage). Funciona em conexões não-oficiais. Limite de 3 botões.",
          tabContent: "CONTEÚDO DA MENSAGEM",
          messageBody: "Corpo da mensagem",
          footer: "Rodapé (opcional)",
          headerImage: "Imagem de cabeçalho (opcional)",
          changeImage: "Trocar imagem",
          uploadImage: "Enviar imagem",
          listButtonLabel: "Texto do botão da lista",
          listButtonHelper: "Texto exibido no botão que abre a lista",
          buttons: "Botões",
          listOptions: "Opções da lista",
          addAtLeastOne: "Adicione pelo menos uma opção.",
          button: "Botão",
        },
        flowBuilderSingleBlock: {
          addTitle: "Adicionar conteúdo ao fluxo",
          editTitle: "Editar conteúdo",
          addMenuTitle: "Adicionar menu ao fluxo",
          add: "Adicionar",
          save: "Salvar",
          message: "Mensagem",
          timeInSeconds: "Tempo em segundos",
          image: "Imagem",
          audio: "Audio",
          video: "Video",
          document: "Documento",
          text: "Texto",
          interval: "Intervalo",
          uploadImage: "Enviar imagem",
          uploadDocument: "Enviar Documento",
          uploading: "Subindo os arquivos e criando o conteúdo...",
          availableVars: "Variáveis disponíveis",
          toasts: {
            emptyMessage: "Campos de mensagem vazio!",
            invalidInterval: "Intervalo não pode ser 0 ou maior que 120!",
            fileTooLarge2MB: "Arquivo é muito grande! 2MB máximo",
            fileTooLarge5MB: "Arquivo é muito grande! 5MB máximo",
            fileTooLarge20MB: "Arquivo é muito grande! 20MB máximo",
            fileTooLarge10MB: "Arquivo é muito grande! 10MB máximo",
            success: "Conteúdo adicionado com sucesso!",
            deleteEmpty: "Delete os cards vazios (Imagem, Audio e Video)",
          },
          vars: {
            firstName: "Primeiro Nome",
            name: "Nome",
            userName: "Atendente",
            greeting: "Saudação",
            protocol: "Protocolo",
            date: "Data",
            hour: "Hora",
            ticketId: "Nº do Chamado",
            queue: "Setor",
            connection: "Conexão",
            phone: "Telefone",
            email: "E-mail",
            kanban: "Kanban",
          },
        },
    installPrompt: {
      title: 'Deixe o {{appName}} sempre à mão',
      body: 'Instale como aplicativo do Windows e ative as notificações para não perder nenhum atendimento, mesmo com o navegador minimizado.',
      blocked: 'As notificações estão bloqueadas nas permissões do navegador para este site. Libere manualmente para ativar.',
      install: 'Instalar no Windows',
      enableNotifications: 'Ativar notificações',
      later: 'Agora não',
      done: 'Tudo certo por aqui',
    },
    settingsOptions: {
      generalSettings: 'Configurações Gerais',
      schedulingBot: 'Agendamento & Bot',
      pushNotifications: 'Notificações Push',
      pushProcessing: 'Processando...',
      pushEnabled: '🔔 Push Ativado',
      pushDisabled: '🔕 Push Desativado',
      pushDescription: 'Ative para receber notificações push neste navegador quando houver novas mensagens.',
      pushDeactivated: 'Notificações push desativadas',
      pushActivated: 'Notificações push ativadas com sucesso!',
      pushActivateError: 'Não foi possível ativar as notificações push. Verifique as permissões do navegador.',
      pushVapidError: 'Push notifications não configuradas no servidor. Configure as chaves VAPID no backend.',
      pushChangeError: 'Erro ao alterar notificações push',
      pushTestButton: 'Testar push neste aparelho',
      pushTestSent: 'Push de teste enviado! Desligue a tela e aguarde.',
      pushTestError: 'Não foi possível enviar o push de teste.',
      pushTestNotSubscribed: 'Ative o push neste aparelho antes de testar.',
      pushTestExpired: 'Inscrição expirada. Desative e ative o push novamente.',
      systemCurrency: 'Moeda da Empresa',
      currency: 'Moeda',
      currencyDescription: 'Define o símbolo da moeda exibido nos valores de venda, relatórios, financeiro e checkout desta empresa.',
      currencyUpdated: 'Moeda atualizada com sucesso!',
      currencyPersistError: 'Falha ao persistir moeda',
      currencySaveError: 'Erro ao salvar moeda',
      currencyUpdateError: 'Erro ao atualizar moeda',
      operationUpdated: 'Operação atualizada com sucesso.',
      operationError: 'Não foi possível concluir a operação.',
      publicFolderRetention: 'Limpeza das pastas (mídias)',
      publicFolderDisabled: 'Desativada',
      publicFolder1Month: 'Manter 1 mês',
      publicFolder2Months: 'Manter 2 meses',
      publicFolder3Months: 'Manter 3 meses',
      publicFolder6Months: 'Manter 6 meses',
      publicFolder12Months: 'Manter 12 meses',
      publicFolderHelp: 'Remove mídias antigas mantendo apenas os meses mais recentes.',
      publicFolderPeriodLabel: 'Período de retenção',
      publicFolderPeriodHelp: 'Define por quanto tempo as mídias são mantidas antes da limpeza.',
      publicFolderCurrentSize: 'Tamanho atual',
      publicFolderCurrentSizeHelp: 'Total no disco hoje. Não muda ao trocar o período — veja a prévia ao lado.',
      publicFolderNoTypesHint: 'Marque os tipos de mídia acima para ver a prévia',
      publicFolderSizeAfter: 'Tamanho após limpeza',
      publicFolderFreed: 'Liberado',
      publicFolderFiles: 'arquivo(s)',
      publicFolderLoading: 'Calculando...',
      publicFolderRefresh: 'Atualizar tamanho',
      publicFolderNoCleanYet: 'Nenhuma limpeza executada ainda',
      publicFolderWouldFree: 'Seria liberado',
      publicFolderRetentionDisabledHint: 'Selecione um período de retenção pra ver a prévia',
      publicFolderCleanNow: 'Limpar agora',
      // Chaves que faltavam: como i18n.t() devolve a própria chave quando ela
      // não existe, o "|| texto padrão" usado no componente NUNCA entrava em
      // ação (a chave é um texto válido, então nunca é falsy) — por isso a
      // tela mostrava "settingsOptions.publicFolderTypesLabel" cru.
      publicFolderTypesLabel: 'Tipos de mídia da limpeza',
      publicFolderTypesHelp: 'Só os tipos marcados são apagados por idade. Os não marcados ficam preservados.',
      publicFolderTypesNone: 'Nenhum (não apaga nada)',
      publicFolderNoTypesSelected: 'Selecione ao menos um tipo de mídia para a limpeza.',
      publicFolderDedupeNow: 'Remover duplicados',
      publicFolderDeduping: 'Removendo duplicados...',
      publicFolderDuplicatesRemoved: 'duplicado(s) liberado(s)',
      publicFolderSelectedTotal: 'Total nos tipos selecionados',
      publicFolderAllRecent: 'todos dentro do período de retenção',
      publicFolderCutoff: 'Apaga apenas mídias anteriores a',
      cleaning: 'Limpando...',
      publicFolderCleanConfirm: 'Deseja realmente limpar as mídias com mais de {{months}} mês(es)? Esta ação não pode ser desfeita.',
      publicFolderCleaned: '{{count}} arquivo(s) removido(s).',
      supportNumber: '📞 Número de Suporte',
      supportNumberPlaceholder: 'Ex: 5511999998888',
      supportNumberHelper: 'Número com código do país (usado no botão Chamar Suporte)',
      supportNumberUpdated: 'Número de suporte atualizado!',
      pixEfiConfig: 'Configuração Pix Efí (GerenciaNet)',
      pixKey: 'Chave PIX',
      tokenAsaas: 'Token Asaas',
      text: 'Texto',
      enabled: '✓ HABILITADO',
      disabledLabel: '✕ DESABILITADO',
      copyContactPrefix: 'Sigla para copiar contatos',
      aiSection: '🤖 Inteligência Artificial',
      autoAiSummary: 'Auto-resumo IA ao finalizar atendimento',
      aiSuggestReply: 'Sugerir Resposta com IA no Chat',
    },
    whitelabelSettings: {
      operationUpdated: 'Operação atualizada com sucesso.',
      appName: 'Nome do Aplicativo',
      appNameHelper: 'Nome exibido no navegador e e-mails',
      mobileAppName: 'Nome Mobile (PWA)',
      mobileAppNameHelper: 'Nome exibido ao instalar no celular',
      languages: {
        ptBR: 'Português',
        en: 'English',
        es: 'Español',
      },
    },
    campaignsPhrase: {
      deleted: 'Campanha deletada com sucesso',
      newCampaign: 'Nova Campanha',
      active: 'Ativo',
      inactive: 'Desativado',
      editCampaign: 'Editar campanha',
      deleteCampaign: 'Excluir campanha',
      noCampaigns: 'Nenhuma campanha encontrada',
      clickNewCampaign: 'Clique em "Nova Campanha" para criar sua primeira campanha de fluxo',
      name: 'Nome',
      connectionsCol: 'Conexões',
      statusCol: 'Status',
      nameNotDefined: 'Nome não definido',
      phrasesConfigured: 'frase(s) configurada(s)',
    },
    contactsPage: {
      importFromPhone: 'Importar contatos do telefone',
      selectAConnection: 'Selecione uma conexão',
      cancel: 'Cancelar',
      import: 'Importar',
      notSynced: 'Contatos ainda não sincronizados. Conecte o celular e aguarde.',
      deleteAllContacts: 'Excluir todos os contatos',
      deleteSelectedContacts: 'Excluir contatos selecionados',
      cancelSelection: 'Cancelar seleção',
      deleteSelected: 'Excluir selecionados',
      status: 'Status',
      userNotFound: 'Usuário não encontrado',
      notAssigned: 'Não atribuído',
      openConversation: 'Abrir conversa',
    },
    financeiroPage: {
      paid: 'Pago',
      overdue: 'Vencido',
      open: 'Em Aberto',
      refunded: 'Estornada',
      yes: 'Sim',
      no: 'Não',
    },
    adminFinanceiro: {
      title: 'Gestão Financeira',
      totalRevenue: 'Receita Total',
      openInvoices: 'Faturas em Aberto',
      overdueInvoices: 'Faturas Vencidas',
      totalInvoices: 'Total de Faturas',
      paidInvoices: 'faturas pagas',
      allCompanies: 'Todas as empresas',
      statusDistribution: 'Distribuição por Status',
      revenueByMonth: 'Receita por Mês',
      defaultByMonth: 'Inadimplência por Mês',
      revenue: 'Receita',
      defaulting: 'Inadimplência',
      search: 'Buscar fatura...',
      filterStatus: 'Filtrar Status',
      all: 'Todos',
      paid: 'Pago',
      open: 'Em Aberto',
      overdue: 'Vencido',
      company: 'Empresa',
      detail: 'Detalhes',
      users: 'Usuários',
      connections: 'Conexões',
      value: 'Valor',
      dueDate: 'Vencimento',
      daysLeft: 'Dias',
      status: 'Status',
      daysRemaining: 'dias restantes',
      daysOverdue: 'dias em atraso',
      action: 'Ação',
      refund: 'Estornar',
      refunded: 'Estornada',
      refundTitle: 'Estornar fatura',
      refundMessage: 'Tem certeza que deseja estornar esta fatura?',
      refundSuccess: 'Fatura estornada com sucesso.',
    },
    companyFinanceiro: {
      title: 'Meu Plano & Financeiro',
      myPlan: 'Meu Plano',
      company: 'Empresa',
      users: 'Usuários',
      connections: 'Conexões',
      queues: 'Filas',
      value: 'Valor',
      daysLeft: 'dias restantes',
      daysOverdue: 'dias em atraso',
      expiresOn: 'Vence em',
      expiredTitle: 'Assinatura Vencida!',
      expiredMessage: 'Sua assinatura está vencida. Regularize para continuar usando o sistema.',
      availablePlans: 'Planos Disponíveis',
      currentPlan: 'Plano Atual',
      changePlan: 'Trocar Plano',
      earlyPayment: 'Pagamento Antecipado',
      month: 'mês',
      invoiceHistory: 'Histórico de Faturas',
      detail: 'Detalhes',
      dueDate: 'Vencimento',
      status: 'Status',
      action: 'Ação',
      pay: 'Pagar',
      refund: 'Estornar',
      refundTitle: 'Estornar fatura',
      refundMessage: 'Tem certeza que deseja estornar esta fatura?',
      refundSuccess: 'Fatura estornada com sucesso.',
      features: {
        campaigns: 'Campanhas',
        schedules: 'Agendamentos',
        internalChat: 'Chat Interno',
        integrations: 'Integrações',
        flows: 'Fluxos',
        contacts: 'Contatos',
        realTime: 'Tempo Real',
        kanban: 'Kanban',
        openai: 'OpenAI',
        telegram: 'Telegram',
        zapi: 'Z-API',
        dashboard: 'Painel',
      },
    },
    checkout: {
      almostDone: 'Falta pouco!',
      steps: { data: 'Dados', customize: 'Personalizar', review: 'Revisar' },
      back: 'VOLTAR',
      pay: 'PAGAR',
      next: 'PRÓXIMO',
      select: 'SELECIONAR',
      users: 'Usuários',
      connection: 'Conexão',
      queues: 'Filas',
      perMonth: '/mês',
      subscriptionSuccess: 'Assinatura realizada com sucesso!, aguardando a realização do pagamento',
      total: 'TOTAL',
      copied: 'Copiado',
      copyQrPix: 'Copiar código QR PIX',
      pixInstructions: 'Para finalizar, basta realizar o pagamento escaneando ou colando o código Pix acima ou escolha Pagar com Cartão de Crédito abaixo.',
      payWithCard: 'Pagar com Cartão de Crédito',
      payWithMercadoPago: 'Pagar com MercadoPago',
      payWithAsaas: 'Pagar com Asaas',
      licenseRenewed: 'Sua licença foi renovada até',
      subscriptionSummary: 'Resumo da assinatura',
      planDetails: 'Detalhes do plano',
      billing: 'Cobrança',
      monthly: 'Mensal',
      paymentInfo: 'Informação de pagamento',
      email: 'Email',
      name: 'Nome',
      cpfCnpj: 'CPF/CNPJ',
      fullName: 'Nome completo*',
      fullNameRequired: 'O nome completo é obrigatório',
      address: 'Endereço*',
      addressRequired: 'O Endereço é obrigatório',
      city: 'Cidade*',
      cityRequired: 'Cidade é obrigatória',
      state: 'Estado*',
      stateRequired: 'Estado é obrigatório',
      cpfCnpjLabel: 'CPF/CNPJ*',
      cpfCnpjRequired: 'CPF/CNPJ é obrigatório',
      country: 'País*',
      countryRequired: 'País é obrigatório',
    },
    chatPage: {
      loadUsersError: 'Erro ao carregar usuários',
      chatExists: 'Chat com este usuário já existe!',
      chatCreated: 'Chat criado com sucesso!',
      chatCreateError: 'Erro ao criar chat',
      group: 'Grupo',
      user: 'Usuário',
      internalChat: 'Chat interno nº ',
      chat: 'Chat',
      noMessages: 'Nenhuma mensagem',
      editGroup: 'Editar Grupo',
      createGroup: 'Criar Grupo',
      changeGroupPhoto: 'Alterar Foto do Grupo',
      addGroupPhoto: 'Adicionar Foto do Grupo',
      titleLabel: 'Título',
      titlePlaceholder: 'Título',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Descrição do grupo',
      editTimeLimit: 'Só é possível editar mensagens enviadas há menos de 10 minutos.',
      messageDeleted: 'Esta mensagem foi apagada',
      chatEditError: 'Erro ao criar/editar chat',
    },
    flowBuilderPage: {
      activeStatus: 'Ativo',
      inactiveStatus: 'Inativo',
      flowDeleted: 'Fluxo excluído com sucesso',
      flowDuplicated: 'Fluxo duplicado com sucesso',
      flowActivated: 'Fluxo ativado com sucesso',
      flowDeactivated: 'Fluxo desativado com sucesso',
      searchFlows: 'Buscar fluxos...',
      createFlow: 'Criar fluxo',
      statTotal: 'Total de Fluxos',
      statActive: 'Fluxos Ativos',
      statPaused: 'Pausados',
      statDrafts: 'Rascunhos',
    },
    instagramReplyCommentNode: {
      count: '{{count}} resposta(s)',
      help: '💬 Responde <b>publicamente</b> o comentário (todo mundo vê). Se tiver várias variações, escolhe uma aleatória — assim não parece robô.',
    },
    instagramIsFollowerNode: {
      title: 'É seguidor?',
      follows: 'Segue',
      notFollows: 'Não segue',
      help: '👤 Checa se quem comentou <b>segue sua conta</b>. Tem 2 saídas:<br />🟢 <b>Verde (segue)</b> → recebe a recompensa.<br />🔴 <b>Vermelho (não segue)</b> → recebe DM tipo "siga a conta primeiro".',
    },
    instagramRewardPdfNode: {
      title: 'Enviar recompensa',
      noFile: '(nenhum arquivo selecionado)',
      help: '🎁 Manda um <b>arquivo (PDF, imagem, vídeo)</b> direto no privado da pessoa. Ótimo para isca digital: e-book, cupom, checklist…',
    },
    n8nTriggerNode: {
      configureUrl: 'Configure a URL do webhook',
      help: 'Dispara webhook n8n com os eventos selecionados.',
    },
    flowBuilderConfigPage: {
      basics: 'Básicos',
      addNodes: 'Adicionar Nós',
      start: 'Início',
      startDesc: 'Ponto inicial do fluxo',
      content: 'Conteúdo',
      contentDesc: 'Enviar texto, imagem, áudio ou vídeo',
      textNode: 'Texto',
      textDesc: 'Mensagem de texto simples',
      interaction: 'Interação',
      menu: 'Menu',
      menuDesc: 'Menu numérico de opções',
      interactiveApi: 'Msg Interativa API',
      interactiveApiDesc: 'Botões e listas (Baileys + API Oficial)',
      input: 'Input',
      inputDesc: 'Coletar entrada do usuário',
      interval: 'Intervalo',
      intervalDesc: 'Pausar execução por tempo',
      logic: 'Lógica',
      randomizer: 'Randomizador',
      randomizerDesc: 'Escolha aleatória de caminhos',
      distribution: 'Distribuição',
      distributionDesc: 'Distribui o ticket entre filas ou atendentes (round robin ou menos ocupado)',
      kanban: 'Kanban',
      kanbanDesc: 'Move o atendimento para uma etapa do quadro Kanban',
      ifElse: 'Se/Senão (If/Else)',
      ifElseDesc: 'Bifurcar fluxo com base em condição',
      system: 'Sistema',
      queues: 'Filas',
      queuesDesc: 'Gerenciar filas de atendimento',
      tags: 'Tags',
      tagsDesc: 'Adicionar tags ao contato',
      removeTag: 'Remover Tag',
      removeTagDesc: 'Remover tags do contato',
      switchFlow: 'Trocar Flow',
      switchFlowDesc: 'Direcionar para outro fluxo',
      attendant: 'Atendente',
      attendantDesc: 'Transferir para atendente',
      variable: 'Variável',
      variableDesc: 'Definir variáveis globais',
      aiAgent: 'Agente de IA',
      aiAgentDesc: 'Usar agente de IA configurado',
      httpRequest: 'HTTP Request',
      httpRequestDesc: 'Requisição HTTP externa',
      flowEditor: 'Editor de Fluxos',
      n8nTriggerName: 'n8n Trigger',
      n8nTriggerDesc: 'Dispara um webhook n8n configurável (ticket, conexão, mensagem, contato) com Basic Auth e logs em tempo real.',
      googleCalendarName: 'Google Agenda',
      googleCalendarDesc: 'Cria um evento no Google Agenda da empresa usando dados coletados no chat (data, hora, profissional, cliente).',
      instagramCategory: 'Instagram',
      igTrigger: 'Gatilho: Comentário IG',
      igTriggerDesc: 'Começa aqui! Inicia o fluxo quando alguém comenta no seu post ou reel.',
      igReply: 'Responder comentário',
      igReplyDesc: 'Responde publicamente o comentário (todo mundo vê a resposta).',
      igLike: 'Curtir comentário',
      igLikeDesc: 'Dá like automático no comentário — mostra que você viu.',
      igIsFollower: 'É seguidor?',
      igIsFollowerDesc: 'Verifica se a pessoa segue você. Cria 2 caminhos: segue / não segue.',
      igSendDm: 'Enviar DM',
      igSendDmDesc: 'Manda mensagem privada (direct) para quem comentou.',
      igRewardPdf: 'Enviar recompensa (PDF)',
      igRewardPdfDesc: 'Manda um arquivo (PDF, imagem, vídeo) no privado. Ótimo para iscas.',
      waitInput: 'Aguardar Resposta',
      waitInputDesc: 'Pausa o fluxo até o cliente responder',
      exit: 'Sair / Encerrar',
      exitDesc: 'Finaliza o atendimento (fecha o ticket)',
      exitNodeClosesTicket: 'Fecha o atendimento',
      waitInputSaveIn: 'Salvar em',
      waitInputNodePausesFlow: 'Pausa o fluxo até resposta do cliente',
      exitDefaultFarewell: 'Atendimento encerrado. Obrigado pelo contato!',
      exitModalTitle: 'Sair / Encerrar Atendimento',
      exitModalBody: 'Ao chegar neste nó o atendimento é finalizado (ticket fechado). Ideal para conectar em uma opção "Sair" de um menu.',
      exitModalFarewellLabel: 'Mensagem de despedida (opcional)',
      exitModalKeywordsLabel: 'Palavras que encerram o atendimento (opcional)',
      exitModalKeywordsPlaceholder: 'sair, encerrar, fechar',
      exitModalKeywordsHelp: 'Separe por vírgula. Se o cliente enviar exatamente uma dessas palavras em qualquer ponto do fluxo, o atendimento é encerrado na hora. Não diferencia maiúscula nem acento.',
      exitModalLaneLabel: 'Mover para a etapa do Kanban ao encerrar',
      exitModalLanePlaceholder: 'Nenhuma (deixar onde está)',
      exitModalLaneHelp: 'Opcional. Ao encerrar, o card vai para esta coluna do Kanban (ex.: Perdido). Deixe vazio para não mexer no Kanban.',
      cancel: 'Cancelar',
      save: 'Salvar',
      waitInputDefaultReminder: 'Olá {{name}}, você ainda está aí? Podemos continuar seu atendimento?',
      waitInputModalTitle: 'Aguardar Resposta do Cliente',
      waitInputModalBody: 'O fluxo pausa neste nó até o cliente enviar uma nova mensagem. A resposta fica disponível como variável para os nós seguintes.',
      waitInputVariableLabel: 'Nome da variável',
      waitInputVariableHelp: 'A resposta será salva como {{nomeDaVariavel}}',
      waitInputSendReminder: 'Enviar lembrete se o cliente não responder',
      waitInputReminderDelay: 'Aguardar antes do lembrete (minutos)',
      waitInputReminderMessage: 'Mensagem de lembrete',
      waitInputAvailableVars: 'Variáveis disponíveis: {{name}}, {{firstName}}, {{queue}}, {{protocol}}, {{userName}}, {{ms}}, {{date}}, {{hour}}, {{ticket_id}}, {{connection}}',
      waitInputTimeoutActionLabel: 'Após o lembrete, se o cliente não responder',
      waitInputTimeoutContinueFlow: 'Retomar o fluxo de onde parou',
      waitInputTimeoutCloseTicket: 'Encerrar o atendimento',
      waitInputTimeoutKeepWaiting: 'Continuar aguardando indefinidamente',
      waitInputTimeoutDelay: 'Tempo de espera após o lembrete (minutos)',
      waitInputTimeoutDelayHelp: 'Se 0, a ação acontece imediatamente após enviar o lembrete',
    },
    flowBuilderGoogleCalendarModal: {
      addTitle: 'Adicionar Agendamento Google',
      editTitle: 'Editar Agendamento Google',
      infoAlert: 'Coleta as variáveis de data e hora antes deste nó (use o nó Pergunta). Variáveis aceitam o formato 15/06/2026, 15:30, "hoje", "amanhã".',
      eventTitle: 'Título do evento',
      eventTitleHelper: 'Use {{variavel}} para inserir dados coletados',
      description: 'Descrição',
      flowVariables: 'Variáveis do fluxo',
      dateVar: 'Variável da data',
      dateVarHelper: 'Ex.: data',
      timeVar: 'Variável da hora',
      timeVarHelper: 'Ex.: hora',
      professionalVar: 'Variável do profissional (opcional)',
      customerEmailVar: 'Variável do e-mail do cliente (opcional)',
      event: 'Evento',
      duration: 'Duração (minutos)',
      timezone: 'Fuso horário',
      calendarId: 'Calendar ID (vazio = padrão da empresa)',
      saveResponseVar: 'Nome da variável de saída',
      saveResponseVarHelper: 'Gera {nome}Id e {nome}Link para próximos nós',
      confirmationMessage: 'Mensagem de confirmação ao cliente (opcional)',
      confirmationMessageHelper: 'Use {{googleEventLink}} para o link do evento',
      cancel: 'Cancelar',
      save: 'Salvar',
      nodeTitle: 'Google Agenda',
      nodeDateLabel: 'data',
      nodeTimeLabel: 'hora',
      nodeDescription: 'Cria evento no Google Agenda da empresa.',
    },
    templateMetaModal: {
      title: 'Templates do WhatsApp',
      searchPlaceholder: 'Pesquisar Templates',
      templateContent: 'Conteúdo do Template:',
      category: 'Categoria:',
      language: 'Idioma:',
      selectedDetails: 'Detalhes do Template Selecionado',
      name: 'Nome:',
      content: 'Conteúdo:',
      fillValue: 'Preencha o valor para',
      requiredField: 'Campo obrigatório',
      sendTemplate: 'Enviar Template',
      back: 'Voltar',
    },
    messagesAPIPage: {
      sendTextMedia: 'Enviar Texto / Mídia',
      yourMessageHere: 'Sua mensagem aqui',
      sendImageUrl: 'Enviar Imagem por URL',
      imageCaption: 'Legenda da imagem',
      sendNoTicket: 'Envio Rápido (Sem Ticket)',
      messageNoTicket: 'Mensagem sem ticket',
      batchSend: 'Envio em Lote',
      interactiveMessages: 'Mensagens Interativas',
      chooseOption: 'Escolha uma opção:',
      optionalFooter: 'Rodapé opcional',
      sales: 'Vendas',
      support: 'Suporte',
      financial: 'Financeiro',
      // Sidebar
      sidebar: {
        playground: 'PLAYGROUND',
        history: 'HISTÓRICO',
        intro: 'INTRODUÇÃO',
        messages: 'API DE MENSAGENS',
        contacts: 'CONTATOS',
        tickets: 'TICKETS / CONVERSAS',
        testEndpoint: 'Testar Endpoint',
        searchEndpoint: 'Buscar endpoint...',
        requestCount: 'requisição(ões)',
        clearHistory: 'Limpar histórico',
        noRequests: 'Nenhuma requisição ainda',
        remove: 'Remover',
        supportsGroups: 'Suporta grupos',
        docSubtitle: 'Documentação completa — {{count}} endpoints',
      },
      // Intro items
      introItems: {
        auth: 'Autenticação',
        rateLimit: 'Rate Limiting',
        errorCodes: 'Códigos de Erro',
      },
      // Endpoint labels
      endpoints: {
        checkNumber: 'Verificar Número',
        listConnections: 'Listar Conexões',
        listContacts: 'Listar Contatos',
        showContact: 'Buscar Contato',
        createContact: 'Criar Contato',
        updateContact: 'Atualizar Contato',
        deleteContact: 'Deletar Contato',
        listTickets: 'Listar Tickets',
        showTicket: 'Buscar Ticket',
        createTicket: 'Criar Ticket',
        updateTicket: 'Atualizar Ticket',
        deleteTicket: 'Deletar Ticket',
        closeAllTickets: 'Fechar Todos os Tickets',
        messagesRange: 'Mensagens por Período',
      },
      // Playground UI
      playground: {
        title: 'API Playground',
        desc: 'Teste os endpoints da sua API diretamente aqui. Informe a URL base do servidor e seu token de autenticação.',
        apiUrl: 'URL da API',
        token: 'Token',
        copyCurl: 'Copiar cURL',
        selectEndpoint: 'Selecionar endpoint pré-definido',
        group: 'Grupo',
        send: 'Enviar',
        uploadMedia: 'Upload Mídia',
        formatJson: 'Formatar JSON',
        mediaHint: 'Imagem, vídeo, áudio ou documento. Também funciona para grupos!',
        error: 'Erro',
        response: 'Resposta',
        yourToken: '<seu_token>',
      },
      // Badges
      badges: {
        new: 'NOVO',
        required: 'obrigatório',
        optional: 'opcional',
      },
      // Docs
      docs: {
        authTitle: 'Autenticação',
        authDesc: 'Todos os endpoints exigem autenticação via token Bearer. O token deve ser cadastrado na conexão WhatsApp através do menu <b>Conexões → Editar → Token</b>.',
        rateLimitTitle: 'Rate Limiting',
        rateLimitDesc: 'Para evitar bloqueios do WhatsApp, recomenda-se um intervalo mínimo de <b>2 segundos</b> entre envios. No envio em lote, utilize o parâmetro <code>delay</code> para controlar o intervalo.',
        errorCodesTitle: 'Códigos de Erro',
        messagesSection: 'API de Mensagens',
        contactsSection: 'Contatos',
        ticketsSection: 'Tickets / Conversas',
        // Table headers
        parameter: 'Parâmetro',
        type: 'Tipo',
        description: 'Descrição',
        code: 'Código',
        meaning: 'Significado',
        // Error codes
        success: 'Sucesso',
        invalidParams: 'Parâmetros inválidos ou ausentes',
        invalidToken: 'Token inválido ou não informado',
        notFound: 'Recurso não encontrado',
        serverError: 'Erro interno do servidor',
        // Send Text/Media
        sendTextTitle: 'Enviar Texto / Mídia',
        sendTextDesc: 'Envia mensagem de texto ou mídia (imagem, vídeo, áudio, documento) para contatos individuais ou <b>grupos</b>. Para enviar a um grupo, informe <code>"isGroup": true</code> e o JID do grupo no campo <code>number</code>.',
        paramNumber: 'Número do contato ou JID do grupo',
        paramBody: 'Texto da mensagem ou legenda da mídia',
        paramIsGroup: 'Se <code>true</code>, envia para grupo usando <code>@g.us</code>',
        paramMedias: 'Arquivo de mídia (multipart/form-data)',
        paramUserId: 'ID do atendente para atribuir',
        paramQueueId: 'ID da fila para direcionar',
        paramSendSignature: 'Incluir nome do atendente na mensagem',
        paramCloseTicket: 'Fechar ticket após envio',
        paramNoRegister: 'Enviar sem registrar ticket',
        // Send Image URL
        sendImageTitle: 'Enviar Imagem por URL',
        sendImageDesc: 'Envia imagem a partir de URL pública para contato ou <b>grupo</b>.',
        paramUrl: 'URL pública da imagem',
        paramCaption: 'Legenda',
        paramIsGroupSend: 'Se <code>true</code>, envia para grupo',
        // Send No Ticket
        sendNoTicketTitle: 'Envio Rápido (Sem Ticket)',
        sendNoTicketDesc: 'Envia mensagem de texto sem criar ticket. Funciona para contatos e <b>grupos</b>.',
        // Bulk
        bulkTitle: 'Envio em Lote (Bulk)',
        bulkDesc: 'Envia até 100 mensagens por lote. Cada mensagem pode ter <code>isGroup: true</code> individualmente.',
        // Buttons
        buttonsTitle: 'Mensagens Interativas',
        buttonsDesc: 'Envia mensagens interativas com botões, listas, URLs e PIX. Funciona para contatos e <b>grupos</b>.',
        // Check Number
        checkNumberTitle: 'Verificar Número',
        checkNumberDesc: 'Verifica se um número possui WhatsApp ativo.',
        // Contacts
        listContactsTitle: 'Listar Contatos',
        listContactsDesc: 'Retorna todos os contatos da empresa. Suporta paginação e busca.',
        paramSearchParam: 'Busca por nome, número ou email',
        paramPageNumber: 'Número da página (padrão: 1)',
        showContactTitle: 'Buscar Contato por ID',
        showContactDesc: 'Retorna os dados de um contato específico pelo ID.',
        createContactTitle: 'Criar Contato',
        createContactDesc: 'Cria um novo contato na base de dados.',
        paramName: 'Nome do contato',
        paramNumberWhatsApp: 'Número do WhatsApp com DDI+DDD',
        paramEmail: 'Email do contato',
        paramExtraInfo: 'Campos personalizados',
        updateContactTitle: 'Atualizar Contato',
        updateContactDesc: 'Atualiza os dados de um contato existente.',
        deleteContactTitle: 'Deletar Contato',
        deleteContactDesc: 'Remove permanentemente um contato. <b>Atenção:</b> Esta ação não pode ser desfeita.',
        // Tickets
        listTicketsTitle: 'Listar Tickets',
        listTicketsDesc: 'Retorna tickets com filtros por status, fila e atendente. Suporta paginação.',
        paramStatus: '<code>open</code>, <code>pending</code>, <code>closed</code>',
        paramQueueIds: 'IDs das filas separados por vírgula',
        paramSearchTicket: 'Busca por mensagem, contato ou ticket',
        paramShowAll: '<code>"true"</code> para listar todos os tickets',
        showTicketTitle: 'Buscar Ticket por ID',
        showTicketDesc: 'Retorna os detalhes completos de um ticket, incluindo contato, fila, atendente e mensagens.',
        createTicketTitle: 'Criar Ticket',
        createTicketDesc: 'Cria um novo ticket vinculado a um contato. Útil para iniciar conversas programaticamente.',
        paramContactId: 'ID do contato vinculado',
        paramStatusDefault: '<code>open</code>, <code>pending</code> (padrão: open)',
        paramQueueIdTicket: 'ID da fila',
        paramUserIdTicket: 'ID do atendente responsável',
        updateTicketTitle: 'Atualizar Ticket',
        updateTicketDesc: 'Atualiza status, fila ou atendente de um ticket. Útil para transferir ou fechar tickets via API.',
        paramNewQueueId: 'ID da nova fila',
        paramNewUserId: 'ID do novo atendente',
        deleteTicketTitle: 'Deletar Ticket',
        deleteTicketDesc: 'Remove permanentemente um ticket e suas mensagens. <b>Atenção:</b> Esta ação é irreversível.',
        closeAllTitle: 'Fechar Todos os Tickets',
        closeAllDesc: 'Fecha todos os tickets abertos de uma vez. Ideal para limpeza em lote.',
        messagesRangeTitle: 'Mensagens por Período',
        messagesRangeDesc: 'Retorna mensagens dentro de um intervalo de datas.',
        paramCompanyId: 'ID da empresa',
        paramStartDate: 'Data início (YYYY-MM-DD)',
        paramEndDate: 'Data fim (YYYY-MM-DD)',
        // Number/JID
        paramNumberOrJid: 'Número ou JID do grupo',
      },
    },
    templateManagerPage: {
      title: 'Gerenciamento de Templates',
      connection: 'Conexão',
      search: 'Buscar...',
      syncTooltip: 'Sincronizar com Meta',
      sync: 'Sync',
      createTemplate: 'Criar Template',
      submitApproval: 'Enviar para Aprovação',
      noOfficialConnection: 'Nenhuma conexão de API Oficial encontrada. Adicione uma conexão oficial para gerenciar templates.',
      noTemplatesFound: 'Nenhum template encontrado. Clique em "Sync" para sincronizar ou "Criar Template" para criar um novo.',
      tableName: 'Nome',
      tableCategory: 'Categoria',
      tableLanguage: 'Idioma',
      tableStatus: 'Status',
      tableActions: 'Ações',
      viewDetails: 'Ver detalhes',
      editTemplate: 'Editar (recriar template)',
      deleteTemplate: 'Excluir template',
      marketing: 'Marketing',
      utility: 'Utilidade',
      authentication: 'Autenticação',
    },
    userPerformance: {
      title: 'Desempenho dos Atendentes',
      subtitle: 'Análise detalhada do desempenho individual de cada atendente',
      fetchError: 'Erro ao carregar dados de desempenho',
      loading: 'Carregando...',
      noData: 'Nenhum dado encontrado para o período selecionado',
      summary: {
        totalTickets: 'Total de Tickets',
        activeUsers: 'Atendentes Ativos',
        avgSupportTime: 'Tempo Médio Atendimento',
        avgWaitTime: 'Tempo Médio Espera',
        avgRating: 'Avaliação Média',
      },
      charts: {
        ticketsByUser: 'Tickets por Atendente',
        statusDistribution: 'Distribuição por Status',
      },
      table: {
        title: 'Detalhamento por Atendente',
        user: 'Atendente',
        totalTickets: 'Total',
        open: 'Abertos',
        pending: 'Pendentes',
        closed: 'Finalizados',
        avgTime: 'Tempo Médio',
        avgWait: 'Espera Média',
        minTime: 'Menor Tempo',
        maxTime: 'Maior Tempo',
        rating: 'Avaliação',
        distribution: 'Distribuição',
      },
    },
    messagePreview: {
      title: "Pré-visualização",
      subtitle: "Veja como sua mensagem será exibida",
      contact: "Contato",
      online: "online",
      emptyState: "Nenhuma mensagem para visualizar",
      typePlaceholder: "Digite uma mensagem...",
      availableVars: "Variáveis disponíveis:",
      greetingExample: "Bom dia",
      attachedMedia: "Mídia anexada",
    },
    chatMessages: {
      clickToGoToOriginal: "Clique para ir à mensagem original",
      delete: "Excluir",
      deleted: "Mensagem apagada",
      deletedAdmin: "Mensagem apagada pelo admin",
      edit: "Editar",
      forward: "Encaminhar",
      forwarded: "Encaminhada",
      reply: "Responder",
      replyingTo: "Respondendo a",
    },
    contactDrawerBase: {
      editButton: "Editar",
      extraInfo: "Informações extras",
      header: "Dados do contato",
    },
    contactDrawerRoles: {
      admin: "Admin",
      superAdmin: "Super Admin",
    },
    contactImportWpModal: {
      title: "Importar Contatos do WhatsApp",
      downloadModel: "Baixar Modelo",
      importBtn: "Importar",
      closed: "Fechar",
    },
    contactListDialog: {
      dialog: "Lista de Contatos",
    },
    contactsFilters: {
      createdAt: "Data de criação",
      to: "Até",
    },
    contactsFilterConnections: {
      connections: "Conexões",
    },
    documentModal: {
      compressed: "Compactado",
      excel: "Excel",
      html: "HTML",
      json: "JSON",
      odpPresentation: "Apresentação ODP",
      odsSheet: "Planilha ODS",
      odt: "Documento ODT",
      ofx: "OFX",
      pdf: "PDF",
      ppt: "PowerPoint",
      word: "Word",
      xml: "XML",
    },
    flowBuilderAttendant: {
      add: "Adicionar",
      addAttendant: "Adicionar Atendente",
      chooseAttendant: "Escolha um atendente",
      edit: "Editar",
      editTitle: "Editar Atendente",
      selectUser: "Selecionar usuário",
      title: "Adicionar Atendente ao Fluxo",
    },
    flowBuilderImage: {
      add: "Adicionar",
      caption: "Legenda (opcional)",
      editTitle: "Editar Imagem",
      error: "Erro ao enviar imagem",
      fileTooLarge: "Arquivo muito grande!",
      save: "Salvar",
      successAdd: "Imagem adicionada com sucesso!",
      title: "Adicionar Imagem ao Fluxo",
      uploadImage: "Enviar imagem",
    },
    flowBuilderText: {
      add: "Adicionar",
      editTitle: "Editar Texto",
      message: "Mensagem",
      save: "Salvar",
      title: "Adicionar Texto ao Fluxo",
    },
    flowBuilderAI: {
      addKeyword: "Adicionar",
      aiObjective: "Objetivo da IA",
      apiKeyLabel: "Chave da API",
      assistantName: "Nome do Assistente",
      autoComplete: "Auto completar ao atingir objetivo",
      autoCompleteHelp: "A IA analisará se completou o objetivo",
      basicSettings: "Configurações Básicas",
      cancel: "Cancelar",
      continueKeywords: "Palavras-chave para Continuar Fluxo",
      flowBehavior: "Comportamento do Fluxo",
      flowBehaviorTooltip: "Configure como a IA deve se comportar no fluxo",
      keywordsHelp: "Quando o usuário enviar uma dessas palavras, o fluxo continuará",
      maxInteractions: "Máximo de Interações",
      maxInteractionsHelp: "Número máximo de mensagens antes de voltar ao fluxo",
      maxMessages: "Max Mensagens",
      maxMessagesHelp: "Histórico de contexto",
      maxTokensHelp: "Tamanho máximo da resposta",
      modelLabel: "Modelo",
      objectiveHelp: "Descreva o que a IA deve completar",
      objectivePlaceholder: "Ex: Coletar dados do cliente...",
      operatingMode: "Modo de Funcionamento",
      permanent: "Permanente",
      permanentDesc: "Encerrar fluxo aqui",
      permanentHelp: "O usuário segue conversando com a IA até pedir transferência",
      promptPlaceholder: "Descreva como a IA deve se comportar...",
      queueId: "ID da Fila (para transferência)",
      queueIdHelp: "ID da fila para transferir se o usuário pedir agente (0 = não transferir)",
      responseType: "Tipo de Resposta",
      systemPrompt: "Prompt do Sistema",
      temperature: "Temperatura",
      temperatureHelp: "0 = conservador, 2 = criativo",
      temporary: "Temporário",
      temporaryDesc: "Volta ao fluxo depois",
      temporaryHelp: "A IA executa uma tarefa específica e retorna ao fluxo normal",
      temporarySettings: "Configurações do Modo Temporário",
      temporarySettingsHelp: "Configure quando a IA deve parar e retornar ao fluxo",
      textOnly: "Apenas texto",
      timeout: "Timeout (minutos)",
      timeoutHelp: "Limite de tempo antes de voltar ao fluxo",
      typeKeyword: "Digite uma palavra-chave",
      voiceKeyLabel: "Chave de Voz",
      voiceKeyPlaceholder: "Chave da API de voz",
      voiceRegionLabel: "Região de Voz",
      voiceRegionPlaceholder: "Região da API de voz",
      voiceSettings: "Configurações de Voz",
    },
    n8nNodes: {
      webhook: "n8n Webhook",
      wait: "n8n Aguardar",
      query: "n8n Consulta",
      sendMessage: "n8n Mensagem",
      configureUrl: "Configurar URL do Webhook",
      configureQuery: "Configurar Consulta",
      configureWebhook: "Configurar Webhook",
      waitingReturn: "Aguardando retorno n8n",
      receiveAndSend: "Receber e enviar mensagem",
      sendsTicketData: "Envia dados do ticket",
      sendsContactData: "Envia dados do contato",
      queryN8n: "Consulta n8n",
      resultIn: "Resultado em",
      sendsResponseToClient: "Envia resposta ao cliente",
      waitsN8nResponse: "Aguarda resposta do n8n",
      field: "Campo",
      variable: "Var",
      saveIn: "Salvar em",
      error: "erro",
      webhookDesc: "Dispara um webhook do n8n com os dados do ticket/contato. O fluxo continua imediatamente — use para registrar eventos, integrar CRMs ou iniciar automações.",
      waitDesc: "Envia dados ao n8n e pausa o fluxo até receber o callback. Use para tarefas longas (aprovações, processamentos) e retome com a resposta salva em variável.",
      queryDesc: "Consulta síncrona ao n8n para buscar dados (CRM, ERP, planilhas). A resposta é salva em variável e pode ser usada nos próximos nós ou enviada ao cliente.",
      sendMessageDesc: "Envia dados ao n8n, aguarda o texto processado e o envia automaticamente ao cliente. Útil para respostas geradas por IA ou modeladas no n8n.",
    },
    n8nModal: {
      editWebhook: "Editar n8n Webhook",
      editWait: "Editar n8n Aguardar Retorno",
      editQuery: "Editar n8n Consulta",
      editSendMessage: "Editar n8n Enviar Mensagem",
      addWebhook: "n8n - Webhook",
      addWait: "n8n - Aguardar Retorno",
      addQuery: "n8n - Consulta",
      addSendMessage: "n8n - Enviar Mensagem",
      nodeType: "Tipo de Nó n8n",
      webhookOption: "Webhook - Enviar dados",
      waitOption: "Aguardar Retorno - Pausar até callback",
      queryOption: "Consulta - Buscar e retornar dados",
      sendMessageOption: "Enviar Mensagem - Receber texto do n8n e enviar",
      webhookInfo: "Envia dados para um webhook do n8n. O fluxo continua imediatamente após o envio.",
      waitInfo: "Envia dados para o n8n e PAUSA o fluxo até receber um callback via POST /n8n-callback com os dados processados.",
      queryInfo: "Faz uma consulta síncrona ao n8n (ex: buscar dados de CRM/ERP) e salva a resposta em uma variável para uso no fluxo.",
      sendMessageInfo: "Envia dados do ticket/contato ao n8n, aguarda o texto processado na resposta e envia automaticamente como mensagem ao cliente.",
      webhookUrlLabel: "URL do Webhook n8n",
      webhookUrlPlaceholder: "https://seu-n8n.com/webhook/...",
      authTokenLabel: "Token de Autenticação (opcional)",
      authTokenPlaceholder: "Token para autenticar no n8n",
      dataToSend: "Dados a enviar",
      ticketData: "Dados do Ticket (ID, fila, status, etc.)",
      contactData: "Dados do Contato (nome, telefone, email)",
      lastMessage: "Última mensagem recebida",
      customPayload: "Payload customizado (JSON opcional)",
      waitConfig: "Configuração de Espera",
      timeoutMinutes: "Timeout (minutos)",
      timeoutHelper: "Tempo máximo de espera. Após isso, segue pelo handle 'timeout'.",
      saveResponseVar: "Variável para salvar resposta",
      saveResponseHelper: "A resposta do n8n será salva nesta variável. Use {{n8n_resultado}} nos próximos nós.",
      waitingMessage: "Mensagem enquanto aguarda (opcional)",
      queryConfig: "Configuração da Consulta",
      queryNameLabel: "Nome da Consulta",
      queryPayloadLabel: "Payload da consulta (JSON)",
      queryPayloadHelper: "Use {{variavel}} para inserir variáveis do fluxo",
      queryResultVar: "Variável para salvar resultado",
      queryResultHelper: "O resultado da consulta será salvo nesta variável",
      sendResultAsMessage: "Enviar resultado como mensagem ao cliente",
      messageTemplate: "Template da mensagem",
      messageTemplateHelper: "Use {{variavel}} para interpolar o resultado",
      sendConfig: "Configuração de Envio",
      responseFieldLabel: "Campo da resposta com a mensagem",
      responseFieldHelper: "O campo do JSON de resposta do n8n que contém o texto.",
      timeoutSeconds: "Timeout (segundos)",
      timeoutSecondsHelper: "Tempo máximo de espera pela resposta do n8n",
      saveResponseVarOptional: "Variável para salvar resposta (opcional)",
      saveResponseVarHelper: "Salva o texto retornado em uma variável para uso posterior",
      fallbackMessage: "Mensagem de fallback (se n8n falhar)",
      fallbackHelper: "Enviada ao cliente caso o n8n não responda ou ocorra erro",
      flowWarning: "Os dados do ticket e contato são enviados ao n8n → o n8n processa e retorna o texto → o texto é enviado automaticamente ao cliente via WhatsApp.",
      webhookRequired: "URL do Webhook é obrigatória",
      cancel: "Cancelar",
      save: "Salvar",
      add: "Adicionar",
    },
    n8nMonitor: {
      title: "Monitoramento n8n",
      total: "Total",
      success: "Sucesso",
      errors: "Erros",
      pending: "Pendentes",
      avgDuration: "Tempo Médio",
      successRate: "Taxa Sucesso",
      startDate: "Data Início",
      endDate: "Data Fim",
      status: "Status",
      nodeType: "Tipo de Nó",
      all: "Todos",
      webhook: "Webhook",
      waitReturn: "Aguardar Retorno",
      query: "Consulta",
      sendMessage: "Enviar Mensagem",
      id: "ID",
      dateTime: "Data/Hora",
      type: "Tipo",
      ticket: "Ticket",
      contact: "Contato",
      duration: "Duração",
      details: "Detalhes",
      noLogs: "Nenhum log encontrado",
      executionDetail: "Detalhes da Execução",
      nodeTypeLabel: "Tipo do Nó",
      webhookUrl: "URL do Webhook",
      errorMessage: "Mensagem de Erro",
      payloadSent: "Payload Enviado",
      responseReceived: "Resposta Recebida",
      noData: "Sem dados",
      close: "Fechar",
      loadError: "Erro ao carregar logs n8n",
      detailError: "Erro ao carregar detalhes",
      of: "de",
    },
    flowBuilderN8N: {
      integrations: "Integrações",
      webhookName: "n8n Webhook",
      webhookDesc: "Enviar dados para webhook n8n",
      waitName: "n8n Aguardar",
      waitDesc: "Pausar até retorno do n8n",
      queryName: "n8n Consulta",
      queryDesc: "Buscar dados via n8n",
      sendMessageName: "n8n Mensagem",
      sendMessageDesc: "Receber texto do n8n e enviar",
    },
    n8nMenuLabel: "Monitor n8n",
    n8nPanel: {
      title: "n8n Automações",
      refresh: "Atualizar",
      openInNewTab: "Abrir em nova aba",
      iframeBlocked: "Não foi possível carregar o n8n aqui",
      iframeBlockedHint: "O n8n pode estar bloqueando o carregamento em iframe. Configure N8N_SECURE_COOKIE=false no seu servidor n8n ou abra em uma nova aba.",
    },
    frontEndErrors: {
      getUsers: "Erro ao carregar usuários",
    },
    loadingText: {
      loading: "Carregando...",
    },
    showTicketLogModal: {
      header: "Log do Ticket",
      access: "Acessou",
      chatBot: "Chatbot",
      clientClosed: "Fechado pelo cliente",
      closed: "Fechado",
      create: "Criado",
      open: "Aberto",
      pending: "Pendente",
      queue: "Fila",
      receivedTransfer: "Recebeu transferência",
      redirect: "Redirecionado",
      reopen: "Reaberto",
      transfered: "Transferido",
    },
    ticketListIntegration: {
      integrationTriggered: "Integração disparada com sucesso!",
    },
    campaignModalExtra: {
      preview: "Pré-visualização",
      seconds: "segundos",
    },
    messagesInputExtra: {
      internalMessage: "Mensagem interna",
      placeholderPending: "Digite uma mensagem para tickets pendentes",
      placeholderPendingAccept: "Aceite ou reabra este ticket para enviar uma mensagem.",
      placeholderWindowExpired: "Fora da janela de 24h. Use um template para enviar a mensagem.",
      ticketPendingTitle: "Ticket pendente.",
      ticketPendingMessage: "Aceite ou reabra este ticket para responder.",
      flowProcessingTitle: "Fluxo em Execução:",
      flowProcessingMessage: "Campo de mensagem temporariamente desabilitado.",
      windowExpiredTitle: "Janela de 24h expirou",
      windowExpiredMessage: "Recomendamos enviar um template, mas você também pode digitar normalmente.",
      windowExpiredSubtitle: "Última mensagem do cliente: há {{elapsed}}. Envie um template aprovado para reengajar esse contato.",
      windowExpiredSubtitleNoTime: "Envie um template aprovado para reengajar esse contato.",
      placeholderTemplateOnly: "Mensagens livres indisponíveis — use um template",
      chooseTemplate: "Escolher Template",
    },
    quickMessageExtra: {
      required: "Obrigatório",
      finishRecordingFirst: "Finalize a gravação do áudio antes de salvar (ou escreva um texto).",
      messageOrMediaRequired: "Escreva uma mensagem ou anexe uma mídia para salvar a resposta rápida.",
      attachMedia: "Anexar mídia",
      editMedia: "Editar mídia",
      removeMedia: "Remover mídia",
      newFile: "Novo arquivo",
      newRecordedAudio: "Novo áudio gravado",
      newAudio: "Novo áudio",
      replaceMedia: "Escolha uma nova mídia para substituir:",
      chooseMedia: "Escolha uma opção para anexar mídia:",
      attachFile: "Anexar arquivo",
      recordAudio: "Gravar áudio",
      cancelEdit: "Cancelar edição",
      type: "Tipo",
      value: "Valor",
    },
    contactDrawerExtra: {
      admin: "Admin",
      chatAriaLabel: "Abrir conversa",
      contactPhoto: "Foto do contato",
      exportError: "Erro ao exportar participantes",
      group: "Grupo",
      nameCol: "Nome",
      noQueue: "Sem fila",
      numberCol: "Número",
      otherUser: "Outro usuário",
      participantsSheet: "Planilha de participantes",
      roleCol: "Papel",
      superAdmin: "Super Admin",
    },
    contactModalExtra: {
      leadSourceHelper: "Definida pelo atendente no atendimento.",
      birthDate: "Data de nascimento",
      birthDateHelper: "Formato: DD/MM/AAAA",
      lid: "LID",
      lidHelper: "Identificador LID do contato",
      noActiveFloup: "Nenhum fluxo ativo",
      noActiveFloupHelper: "Nenhum fluxo está ativo para este contato",
      noQueuesForUser: "Usuário não possui filas associadas",
      searchMinChars: "Digite pelo menos 3 caracteres para buscar",
      searching: "Buscando...",
      selectUserFirst: "Selecione um usuário primeiro",
      followUpPanel: "Painel FollowUP",
      aboutFollowUpTitle: "Sobre o Sistema Follow UP",
      aboutFollowUpDesc: "O Follow UP permite criar fluxos de mensagens e atribuí-los a um contato ou ticket para execução automática.",
      aboutFollowUpSelect: "Selecione um template ativo para iniciar. Você pode interromper a qualquer momento.",
      understood: "Entendi",
      noAgent: "Sem atendente",
    },
    fileModalExtra: {
      nameTooShort: "nome muito curto",
    },
    promptModalExtra: {
      sectorRequired: "Setor é obrigatório",
      text: "Texto",
    },
    queueModalExtra: {
      none: "Nenhuma",
    },
    queueModalExtra2: {
      clickSaveToRegister: "Clique em salvar para registrar as alterações",
      saturday: "Sábado",
      sunday: "Domingo",
      minutes: "minutos",
      selectRotationType: "Selecione o tipo de rodízio",
    },
    scheduleModalExtra: {
      contactPlaceholder: "Digite para pesquisar o contato",
      fromQuickReply: "A partir da resposta rápida",
      messageStatus: "Status da mensagem",
      noQuickMessages: "Nenhuma resposta rápida encontrada",
      quickMessageSearch: "Buscar resposta rápida...",
      reminder: "Lembrete",
      reminderDate: "Data do lembrete",
      reminderDescription: "Descrição do lembrete",
      reminderNote: "Observação do lembrete",
      sendError: "Erro ao salvar agendamento",
    },
    tagModalExtra: {
      clickToAttach: "Clique para anexar arquivo (Imagem, PDF, Áudio, Vídeo)",
      fileTooLarge: "O arquivo '{{name}}' é muito grande. Tamanho máximo permitido: 10MB.",
      maxSize: "Tamanho máximo: 10MB por arquivo",
      unsupportedType: "Tipo de arquivo {{type}} não é suportado",
    },
    ticketActionExtra: {
      disableBot: "Desabilitar bot",
      enableBot: "Habilitar bot",
      linkToWallet: "Vincular à carteira",
      ratingRequired: "Avaliação obrigatória",
      sendTemplate: "Enviar template",
      sendTemplateBtn: "Enviar",
      sendTemplateExpired: "⚠️ Janela de 24h expirada — envie um template para reabrir a conversa",
      botActive: "Bot ativo (Clique para pausar)",
      botPaused: "Bot pausado (Clique para ativar)",
      templateSent: "Template enviado com sucesso!",
      ticketFinished: "Ticket finalizado",
      tokenError: "Erro de token",
    },
    ticketListExtra: {
      contactPhoto: "Foto do contato",
      createNewTicket: "Criar novo ticket",
      spyChatbot: "Espiar chatbot",
      ticketFinished: "Ticket finalizado",
    },
    reportsExtra: {
      statusDistribution: "Distribuição por Status",
      ticketsByQueue: "Tickets por Fila",
      ticketsByUser: "Tickets por Usuário",
      noQueue: "Sem fila",
      noUser: "Sem usuário",
      noDataForChart: "Sem dados para exibir",
    },
    flowDefaultPage: {
      title: "Fluxo padrão",
      welcomeFlow: "Fluxo de boas vindas",
      welcomeFlowDesc: "Este fluxo é disparado apenas para novos contatos, pessoas que você não possui em sua lista de contatos e que mandaram uma mensagem",
      defaultResponseFlow: "Fluxo de resposta padrão",
      defaultResponseFlowDesc: "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento já estiver fechado.",
      defaultResponseFlowDescLong: "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento já estiver fechado e passado 6 horas do seu fechamento.",
      linkedFlow: "Fluxo vinculado",
      linkedFlowDesc: "Fluxo executado nesta conexão para novos contatos e para mensagens fora de palavra-chave. Funciona de forma independente de qualquer integração externa.",
      disabled: "Desabilitado",
      chooseFlow: "Escolha um fluxo",
      disconnect: "Desconectar",
      save: "Salvar",
      deleteConfirm: "Tem certeza que deseja deletar este fluxo? Todas as integrações relacionados serão perdidos.",
    },
    flowBuilderAIGenerate: {
      button: "Gerar com IA",
      title: "Gerar Fluxo com IA",
      help: "Descreva o que o fluxo deve fazer. A IA criará todos os nós e conexões automaticamente, prontos para vincular a uma conexão.",
      category: "Categoria",
      namePlaceholder: "Nome do fluxo (opcional)",
      description: "Descrição do fluxo",
      examplesLabel: "Exemplos rápidos (clique para usar)",
      keyNotice: "A IA usa a chave configurada em Configurações > IA da empresa. O fluxo gerado nasce pausado, pronto para edição e vinculação a conexões.",
      generate: "Gerar Fluxo",
      generating: "Gerando...",
      cancel: "Cancelar",
      success: "Fluxo gerado com sucesso!",
      descriptionTooShort: "Descreva o fluxo com um pouco mais de detalhe.",
      categories: {
        customerService: "Atendimento ao Cliente",
        sales: "Vendas / Pré-venda",
        support: "Suporte Técnico",
        leadQualification: "Qualificação de Leads",
        scheduling: "Agendamento",
        nps: "Pesquisa de Satisfação (NPS)",
        welcome: "Boas-vindas / Menu Inicial",
        billing: "Cobrança / Financeiro",
        other: "Outro"
      },
      examples: {
        example1: "Menu inicial com opções: Falar com Vendas, Suporte Técnico, Financeiro. Cada opção transfere para a fila correspondente.",
        example2: "Qualificação de lead: pergunte nome, empresa e orçamento, depois transfira para Vendas.",
        example3: "Pesquisa NPS pós-atendimento: peça nota de 0 a 10 e agradeça.",
        example4: "Agendamento: pergunte nome, data preferida e horário, depois transfira para a fila."
      }
    },
    flowBuilderPageExtra: {
      title: "Fluxos de Conversa",
      newFlow: "Novo Fluxo",
      importZip: "Importar (.zip)",
      noFlowFound: "Nenhum fluxo encontrado",
      noFlowCreated: "Nenhum fluxo criado ainda",
      tryOtherSearch: "Tente usar outros termos de pesquisa",
      createFirstFlowDesc: "Crie seu primeiro fluxo de conversa para automatizar atendimentos",
      createFirstFlow: "Criar Primeiro Fluxo",
    },
    floupPage: {
      title: "Follow UP - Templates de Fluxo",
      filterActive: "Ativo",
      filterError: "Com erros",
      filterPaused: "Pausado",
      filterAll: "Todos",
      subtitle: "Gerencie seus templates de Follow Up",
      newTemplate: "Novo Template",
      editTemplate: "Editar Template",
      basicInfo: "Informações Básicas",
      basicInfoDesc: "Configure o nome e tipo do seu Follow Up. O tipo define o template inicial das mensagens.",
      templateName: "Nome do Template",
      templateType: "Tipo do Template",
      description: "Descrição",
      client: "Cliente",
      lead: "Lead",
      customized: "Personalizado",
      triggerCondition: "Condição para Acionamento",
      triggerConditionDesc: "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
      condition: "Condição",
      systemQueue: "Fila do sistema",
      systemTag: "Tag do sistema",
      firstClientInteraction: "Primeira interação do cliente",
      firstAttendantInteraction: "Primeira interação do atendente",
      queue: "Fila",
      selectQueue: "Selecionar fila",
      tag: "Tag",
      selectTag: "Selecionar tag",
      conditionDescription: "Descrição da condição",
      conditionPlaceholder: "Ex: Cliente enviou primeira mensagem",
      flowSteps: "Passos do Fluxo",
      stepsDesc: "Configure as etapas do fluxo de Follow Up. Use as setas para reordenar.",
      addStep: "Adicionar Passo",
      removeStep: "Remover Passo",
      step: "Passo",
      emptyMessage: "Mensagem vazia",
      message: "Mensagem",
      variablesHint: "Variáveis: {{nome}}, {{protocolo}}, {fila}",
      interval: "Intervalo",
      unit: "Unidade",
      minutesLabel: "Minutos",
      hoursLabel: "Horas",
      daysLabel: "Dias",
      weeksLabel: "Semanas",
      monthsLabel: "Meses",
      attachment: "Anexo/Mídia",
      pasteUrl: "Cole a URL...",
      choose: "Escolher",
      uploadError: "Erro no upload.",
      conversationPreview: "Preview da Conversa",
      addStepsForPreview: "Adicione etapas para ver o preview",
      afterLabel: "Após",
      fileLabel: "Arquivo",
      flowStopControls: "Controles de Parada do Fluxo",
      stopControlsDesc: "Configure quando o Follow Up deve parar automaticamente.",
      stopAnyMessage: "1. Caso o Contato responder qualquer mensagem",
      stopKeyword: "2. Caso o Contato responder uma Palavra chave",
      keyword: "Palavra chave",
      keywordPlaceholder: "Ex: PARAR, CANCELAR, SAIR",
      stopTicketClosed: "3. Caso o Ticket for Fechado",
      noFlowsYet: "Nenhum Follow UP criado ainda",
      active: "Ativo",
      inactive: "Inativo",
      stepsCount: "etapas",
      queueLabel: "Fila",
      tagLabel: "Tag",
      interactionLabel: "Interação",
      edit: "Editar",
      duplicate: "Duplicar",
      delete: "Deletar",
      cancel: "Cancelar",
      previous: "Anterior",
      next: "Próximo",
      saveTemplate: "Salvar Template",
      confirmDeleteTitle: "Confirmar Exclusão",
      confirmDeleteMessage: "Tem certeza que deseja deletar o Follow UP",
      confirmDeleteWarning: "Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.",
    },
    floupSelector: {
      stopSuccess: "Follow UP interrompido para o contato com sucesso",
      stopError: "Erro ao interromper o Follow UP",
      active: "Ativo",
      newTemplate: "Novo Template",
      editTemplate: "Editar Template",
      basicInfo: "Informações Básicas",
      templateName: "Nome do Template",
      templateType: "Tipo do Template",
      description: "Descrição",
      triggerCondition: "Condição para Acionamento",
      triggerConditionDesc: "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
      condition: "Condição",
      systemQueue: "Fila do sistema",
      systemTag: "Tag do sistema",
      firstClientInteraction: "Primeira interação do cliente",
      firstAttendantInteraction: "Primeira interação do atendente",
      queue: "Fila",
      selectQueue: "Selecionar fila",
      tag: "Tag",
      selectTag: "Selecionar tag",
      conditionDescription: "Descrição da condição",
      conditionPlaceholder: "Ex: Cliente enviou primeira mensagem",
      flowStopControls: "Controles de Parada do Fluxo",
      stopAnyMessage: "1. Caso o Contato responder qualquer mensagem",
      stopKeyword: "2. Caso o Contato responder uma Palavra chave",
      keyword: "Palavra chave",
      keywordPlaceholder: "Ex: PARAR, CANCELAR, SAIR",
      stopTicketClosed: "3. Caso o Ticket for Fechado",
      flowSteps: "Passos do Fluxo",
      addStep: "Adicionar Passo",
      cancel: "Cancelar",
      saveTemplate: "Salvar Template",
      confirmDeleteTitle: "Confirmar Exclusão",
      confirmDeleteMessage: "Tem certeza que deseja deletar o Follow UP",
      confirmDeleteWarning: "Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.",
      delete: "Deletar",
      duplicate: "Duplicar",
      edit: "Editar",
      steps: "passos",
      active: "Ativo",
      inactive: "Inativo",
      customized: "Personalizado",
      client: "Cliente",
      lead: "Lead",
      basicInfoDesc: "Configure o nome e tipo do seu Follow Up. O tipo define o template inicial das mensagens.",
      stepsDesc: "Configure as etapas do fluxo de Follow Up. Use as setas para reordenar.",
      stopControlsDesc: "Configure quando o Follow Up deve parar automaticamente.",
      subtitle: "Gerencie seus templates de Follow Up",
      noFlowsYet: "Nenhum Follow UP criado ainda",
      step: "Passo",
      emptyMessage: "Mensagem vazia",
      message: "Mensagem",
      variablesHint: "Variáveis: {" + "{nome}}, {" + "{protocolo}}, {" + "{fila}}",
      interval: "Intervalo",
      unit: "Unidade",
      minutesLabel: "Minutos",
      hoursLabel: "Horas",
      daysLabel: "Dias",
      weeksLabel: "Semanas",
      monthsLabel: "Meses",
      attachment: "Anexo/Mídia",
      pasteUrl: "Cole a URL...",
      choose: "Escolher",
      uploadError: "Erro no upload.",
      removeStep: "Remover Passo",
      conversationPreview: "Preview da Conversa",
      addStepsForPreview: "Adicione etapas para ver o preview",
      afterLabel: "Após",
      fileLabel: "Arquivo",
      previous: "Anterior",
      next: "Próximo",
      queueLabel: "Fila",
      tagLabel: "Tag",
      interactionLabel: "Interação",
      stepsCount: "etapas",
    },
    templateManagerPageExtra: {
      createNewTemplate: "Criar Novo Template",
      templateNameLabel: "Nome do Template",
    },
    templateManagerForm: {
      rejected: "foi REJEITADO pela Meta",
      syncComplete: "Sincronização concluída",
      statusChanged: "com mudança de status",
      syncNoChanges: "Templates sincronizados - nenhuma mudança de status",
      tokenExpired: "⚠️ Token da API Oficial expirado ou inválido! Atualize o token de acesso da Meta na configuração da conexão.",
      nameBodyRequired: "Nome e corpo da mensagem são obrigatórios",
      nameValidation: "O nome do template deve conter apenas letras minúsculas, números e underscores (_)",
      sentForApproval: "Template enviado para aprovação da Meta!",
      deleteSuccess: "Template excluído com sucesso!",
      confirmDeleteMessage: "Esta ação irá excluir o template na Meta e localmente. Deseja continuar?",
      templateDetails: "Detalhes do Template",
      name: "Nome",
      language: "Idioma",
      status: "Status",
      category: "Categoria",
      components: "Componentes",
      close: "Fechar",
      nameHelper: "Apenas letras minúsculas, números e _",
      headerOptional: "Cabeçalho (opcional)",
      headerHelper: "Texto exibido no topo do template",
      messageBody: "Corpo da Mensagem",
      messageBodyHelper: "Use ｛｛1｝｝, ｛｛2｝｝, etc. para variáveis. Ex: Olá ｛｛1｝｝, seu pedido ｛｛2｝｝ está pronto!",
      footerOptional: "Rodapé (opcional)",
      footerHelper: "Texto pequeno no final do template",
      buttonsOptional: "Botões (opcional - máx 3)",
      quickReply: "Resposta Rápida",
      phone: "Telefone",
      text: "Texto",
      preview: "Pré-visualização",
      button: "Botão",
      cancel: "Cancelar",
    },
    whatsappModalRel: {
      form: {
        resolveAndTriggerIntegration: "Resolver e Disparar Integração",
        reportFilename: "Relatorio_Ticket_",
        elementNotFoundForExport: "Elemento não encontrado para exportação",
      },
    },
    announcementsPopover: {
      title: "Informativos",
      dontShowAgain: "Não exibir novamente",
      dismiss: "Não exibir",
      dismissAll: "Dispensar todos",
      close: "Fechar",
      backToList: "Voltar para lista",
      dismissedToast: "Este informativo não será mais exibido. Ele reaparecerá apenas quando houver novidades.",
      priority: {
        high: "Alta",
        medium: "Média",
        low: "Baixa",
      },
      priorityLabel: "Prioridade",
    },
    ticketsManagerExtra: {
      viewAll: "Todos",
      ascending: "Crescente",
      descending: "Decrescente",
      searchOnMessages: "Marque para pesquisar também nos conteúdos das mensagens (mais lento)",
    },
    announcementsPage: {
      noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      priorityHigh: "Alta",
      priorityMedium: "Média",
      priorityLow: "Baixa",
    },
    pairingCodeModalExtra: {
      phoneRequired: "Informe o número de telefone.",
      phoneTooShort: "Número muito curto. Inclua código do país + DDD.",
      phoneTooLong: "Número muito longo.",
      phoneBrazil: "Para números brasileiros, use 55 + DDD + número.",
      connectedSuccess: "✅ WhatsApp conectado com sucesso!",
      pairingFailed: "⚠️ Pareamento falhou. Tente novamente.",
      instructionText: "Informe o número do WhatsApp com",
      instructionHighlight: "código do país + DDD",
      exampleNumber: "5511999998888",
      digitsHelper: "dígitos — código do país + DDD + número",
      whatsappInstructions: "No seu WhatsApp, vá em:",
      whatsappSteps: "Configurações → Dispositivos Vinculados → Vincular um dispositivo",
      tapLink: "Toque em",
      linkWithPhone: "Vincular com número de telefone",
      enterCodeExact: "e insira o código exatamente como exibido (sem espaços):",
      stepCodeGenerated: "Código gerado",
      stepWaitingPairing: "Aguardando pareamento",
      stepSyncing: "Sincronizando",
      stepConnected: "Conectado",
    },
    newTicketOficialModal: {
      title: "Nova Conversa - API Oficial",
      selectQueue: "Selecione uma fila",
      selectOfficialConnection: "Selecione uma Conexão Oficial",
      selectQueuePlaceholder: "Selecione uma fila",
      selectConnectionPlaceholder: "Selecione uma Conexão Oficial",
      officialApiLabel: "API Oficial",
      createAndSendTemplate: "Criar e Enviar Template",
      templateSentSuccess: "Template enviado com sucesso!",
      selectQueueError: "Selecione uma fila",
      selectConnectionError: "Selecione uma conexão oficial",
    },
    officialApiCountdown: {
      noWindow: "Sem janela",
      noWindowTooltip: "Nenhuma mensagem do cliente recebida. A janela de 24h da API Oficial só abre após o cliente responder. Envie um template para iniciar.",
      expired: "Janela expirada",
      expiredTooltip: "A janela de 24h da API Oficial expirou. Para enviar novas mensagens livres, o cliente precisa responder ou você deve enviar um template aprovado.",
      activeTooltip: "Janela de 24h da API Oficial. Expira em {{date}}.",
      minutesLeft: "{{m}}m restantes",
      hoursLeft: "{{h}}h {{m}}m restantes",
    },
    interactiveMessageModalExtra: {
      sendInteractiveMessage: "Enviar Mensagem Interativa",
      modelsCount: "Modelos ({{count}})",
      saveCurrentConfig: "Salve a configuração atual como um modelo reutilizável para o tipo",
      saveButton: "Salvar",
      templateLoaded: "Template \"{{name}}\" carregado",
      buttonsInfo: "ℹ️ Envie até 3 botões clicáveis. O cliente pode tocar em um botão para responder rapidamente.",
      messageText: "Texto da mensagem *",
      footer: "Rodapé (opcional)",
      buttonsMax: "Botões (máx. 3)",
      add: "Adicionar",
      optionPlaceholder: "Opção {{n}}",
      listInfo: "ℹ️ Envie uma lista com até 10 opções. O cliente abre um menu para selecionar.",
      buttonText: "Texto do botão",
      sectionTitle: "Título da seção",
      titleLabel: "Título",
      descriptionLabel: "Descrição",
      addOption: "Adicionar opção",
      offerInfo: "🏷️ Envie uma oferta com título, preço e descrição.",
      offerTitle: "Título da oferta",
      offerBody: "Descrição / Corpo da mensagem *",
      offerPrice: "Preço (ex: 99,90)",
      offerDetails: "Detalhes adicionais",
      pixInfo: "💰 Envie dados PIX formatados para o cliente.",
      pixKey: "Chave PIX *",
      pixKeyPlaceholder: "CPF, CNPJ, e-mail, telefone ou chave aleatória",
      pixBeneficiary: "Nome do beneficiário",
      pixCity: "Cidade",
      pixAmount: "Valor",
      pixCopyPasteLabel: "Código PIX copia e cola (botão copiar)",
      pixCopyPasteHelper: "Preencha para enviar um botão nativo 'Copiar código PIX' (recomendado).",
      pixButtonTextLabel: "Texto do botão copiar",
      pixQrCodeLabel: "Enviar QR Code (imagem) junto com o botão",
      pixDocInfo: "📄 Documento (PDF) como anexo + botão \"Copiar chave Pix\" no mesmo balão.",
      pixTotalLabel: "Total exibido (opcional)",
      pixTotalHelper: "Aparece como 'Total' no corpo da mensagem.",
      pixDocUrlLabel: "URL do PDF (boleto/fatura)",
      pixDocUrlHelper: "Link público do PDF que será anexado ao cartão PIX.",
      pixDocNameLabel: "Nome do arquivo (opcional)",
      urlInfo: "🔗 Envie um link clicável com texto personalizado.",
      linkText: "Texto do link",
      linkPlaceholder: "Clique aqui",
      urlLabel: "URL *",
      callInfo: "📞 Envie uma mensagem com número para ligação.",
      callButtonText: "Texto do botão",
      callPlaceholder: "Ligar agora",
      callPhoneLabel: "Número de telefone *",
      callContactSelect: "Escolher da agenda de contatos",
      callContactPlaceholder: "Pesquisar contato...",
      callContactNoOptions: "Nenhum contato encontrado",
      callContactLoading: "Buscando...",
      callPhoneHelper: "Selecione um contato acima ou digite manualmente",
      locationInfo: "📍 Envie uma localização para o cliente.",
      locationMessageText: "Texto da mensagem",
      locationName: "Nome do local",
      locationAddress: "Endereço",
      latitudeLabel: "Latitude *",
      longitudeLabel: "Longitude *",
      carouselInfo: "🎠 Envie múltiplos cards como carrossel.",
      cardLabel: "Card {{n}}",
      cardTitle: "Título",
      cardDescription: "Descrição",
      cardButtonText: "Texto do botão",
      addCard: "Adicionar card",
      catalogInfo: "🛍️ Envie produtos do catálogo como cards.",
      productLabel: "Produto {{n}}",
      productName: "Nome do produto",
      productDescription: "Descrição / Preço",
      addProduct: "Adicionar produto",
      cardImageAdd: "Anexar imagem",
      cardImageChange: "Trocar imagem",
      cardImageInvalid: "Selecione um arquivo de imagem.",
      cardImageUploadError: "Erro ao enviar a imagem.",
      pollInfo: "📊 Crie uma enquete para o cliente votar.",
      pollOfficialNote: "(Será enviada como texto formatado na API Oficial)",
      pollQuestion: "Pergunta da enquete *",
      pollOptionsLabel: "Opções (mín. 2, máx. 12)",
      billingInfo: "🧾 Envie uma cobrança com detalhes do pagamento e botão \"Revisar e pagar\".",
      billingNumber: "Nº da cobrança",
      billingDescription: "Descrição da cobrança *",
      billingQuantity: "Quantidade",
      billingTotalAmount: "Valor total *",
      billingCustomMessage: "Mensagem personalizada",
      billingAttachPdf: "📄 Anexar PDF / Boleto (opcional)",
      billingSelectPdf: "Selecionar PDF",
      billingPaymentButton: "Botão de pagamento",
      billingButtonText: "Texto do botão",
      billingPaymentUrl: "URL de pagamento (opcional)",
      billingPaymentUrlHelper: "Se preenchido, o botão será um link clicável (CTA URL)",
      billingNumberPreview: "Nº DA COBRANÇA",
      billingQuantityPreview: "Quantidade",
      billingTotal: "Total",
      billingDefaultBody: "Corpo da mensagem...",
      billingDefaultDescription: "Descrição da cobrança...",
      billingDefaultButton: "Revisar e pagar",
    },
    whatsAppModalExtra: {
      saturday: "Sábado",
      sunday: "Domingo",
      saveSchedulesHint: "Clique em salvar para registar as alterações",
    },
    tagsKanbanContainer: {
      label: "Etapa Kanban",
      selectStep: "Selecione uma etapa",
      selectKanbanStep: "Selecione uma Etapa Kanban",
      none: "Nenhuma",
      loadingSteps: "Carregando etapas...",
    },
    pendingTicketOverlay: {
      blockedTitle: "Conversa Bloqueada",
      blockedSubtitle: "Este ticket está aguardando aceite. Aceite a conversa para visualizar e responder às mensagens do cliente.",
      statusWaiting: "Status: Aguardando",
      contact: "Contato",
      ticketId: "Ticket #{{id}}",
      accepting: "Aceitando...",
      acceptConversation: "Aceitar Conversa",
      warningText: "🚫 Você não pode visualizar as mensagens antes de aceitar o ticket",
    },
    documentModalExtra: {
      viewDocument: "Visualizar Documento",
      open: "Abrir",
      download: "Download",
      emailOutlook: "E-mail Outlook",
      keynotePresentation: "Apresentação Keynote",
      numbersSpreadsheet: "Planilha Numbers",
      pagesDocument: "Documento Pages",
      executable: "Executável",
      retFile: "Arquivo RET",
      document: "Documento",
    },
    statusFilterExtra: {
      groups: "Grupos",
    },
    callReport: {
      title: "Relatório de Chamadas",
      subtitle: "Histórico completo de ligações realizadas e recebidas",
      exportCsv: "Exportar CSV",
      totalCalls: "Total de Chamadas",
      made: "Realizadas",
      answered: "Atendidas",
      received: "Recebidas",
      errorsRejected: "Erros / Rejeitadas",
      callsByHour: "Chamadas por Hora",
      callsByDay: "Chamadas por Dia",
      callStatus: "Status das Chamadas",
      average: "Média",
      dateStart: "Data Início",
      dateEnd: "Data Fim",
      provider: "Conexão",
      attendant: "Atendente",
      status: "Status",
      all: "Todos",
      dateTime: "Data/Hora",
      phone: "Telefone",
      contact: "Contato",
      connection: "Conexão",
      duration: "Duração",
      recording: "Gravação",
      downloadRecording: "Baixar gravação",
      noRecords: "Nenhum registro encontrado",
      showing: "Mostrando",
      of: "de",
      completed: "Concluída",
      rejected: "Rejeitada",
      notAnswered: "Não Atendida",
      pending: "Pendente",
      system: "Sistema",
      sun: "Dom",
      mon: "Seg",
      tue: "Ter",
      wed: "Qua",
      thu: "Qui",
      fri: "Sex",
      sat: "Sáb",
    },
    hardcoded: {
      flowSavedSuccess: "Fluxo salvo com sucesso",
      flowSaveError: "Erro ao salvar o fluxo",
      flowDeletedSuccess: "Fluxo excluído com sucesso",
      flowDefaultsUpdated: "Fluxos padrões atualizados",
      mediaError: "Erro ao processar mídia",
      noDataFound: "Nenhum dado encontrado",
      selectFollowUp: "Selecione um Follow UP",
      chooseTemplate: "Escolher template...",
      noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      noPermissionShort: "Esta empresa não possui permissão para acessar essa página!",
      loadError: "Erro ao carregar dados de envio",
      generatingExcel: "Gerando relatório Excel, aguarde...",
      loadingData: "Carregando dados... {{count}} registros encontrados",
      noDataToExport: "Nenhum dado encontrado para exportar",
      excelReportHeader: "Relatório de Campanha",
      excelCampaignLabel: "Campanha: {{name}}",
      excelGeneratedAt: "Data de Geração: {{date}}",
      excelColId: "ID",
      excelColRecipient: "Destinatário",
      excelColMessage: "Mensagem",
      excelColSentAt: "Enviado em",
      excelColDeliveredAt: "Entregue em",
      excelColStatus: "Status",
      excelDelivered: "Entregue",
      excelPending: "Pendente",
      excelSheetName: "Relatório de Campanha",
      excelSuccess: "Relatório Excel gerado com sucesso! {{count}} registros exportados.",
      excelError: "Erro ao gerar relatório Excel",
      settingsSaved: "Configurações salvas",
      campaignDeleted: "Campanha deletada com sucesso",
      enterToken: "Informe o token de autenticação",
      requestSuccess: "✅ Requisição enviada com sucesso",
      requestLoaded: "Requisição carregada — clique Enviar para repetir",
      historyCleared: "Histórico limpo",
      copied: "Copiado!",
      invalidJson: "JSON inválido",
      chatCreated: "Chat criado com sucesso!",
      chatsGenerated: "Chats gerados com sucesso!",
      confirmBackfill: "Tem certeza que deseja gerar chats para todos os usuários existentes? Isso pode demorar e criar muitos chats.",
      walletNotFound: "Carteira não encontrada",
      maxButtonsReached: "Máximo de 3 botões permitidos",
      queueAcceptance: {
        kept: "Fila mantida",
        inherited: "Fila herdada da conexão"
      },
      schedulesUpdated: "Horários atualizados com sucesso.",
      pushDeactivateError: "Erro ao desativar notificações push",
      metaUpdated: "{{field}} atualizado!",
      clickSaveToRegister: "Clique em salvar para registar as alterações",
      contactsImported: "Contatos do WhatsApp importados com sucesso!",
      couldNotLoadRecords: "Não foi possível carregar a lista de registros",
      selectPeriod: "Por favor, selecione o período",
      fillAllFields: "Preencha todos os campos com valores numéricos válidos.",
      slaLimitsOrder: "Os limites devem ser crescentes: Verde < Amarelo < Vermelho.",
      slaUpdated: "Configurações de SLA atualizadas com sucesso!",
      slaError: "Erro ao salvar configurações de SLA.",
      slaTitle: "Configurações de SLA do Kanban",
      slaTimeLimitsAndColors: "Limites de Tempo e Cores",
      slaDescription: "Defina os limites de tempo (em minutos) e as cores de cada nível de alerta do SLA no Kanban.",
      slaOnTimeLabel: "🟢 No prazo — até (min)",
      slaWarningLabel: "🟡 Atenção — até (min)",
      slaLateLabel: "🔴 Atrasado — acima de (min)",
      slaOnTimeHelper: "Tempo máximo para o status verde",
      slaWarningHelper: "Tempo máximo para o status amarelo",
      slaLateHelper: "Acima deste valor exibe pulsação",
      slaOnTimePreview: "No prazo — até {{m}}min",
      slaWarningPreview: "Atenção — até {{m}}min",
      slaLatePreview: "Atrasado — acima de {{m}}min",
      slaSaveBtn: "Salvar Configurações de SLA",
      slaSaving: "Salvando...",
      slaClose: "Fechar",
      slaSelectColor: "Selecionar cor",
      cancelRequested: "Cancelamento solicitado. Aguarde a finalização do chat atual...",
      importReadyToDisconnect: "Importação concluída! Desconectando esta conexão automaticamente...",
      importErrorGeneric: "A importação de mensagens falhou. Tente novamente.",
      importBestTimeTip: "Para trazer o máximo de mensagens, clique em \"Importar mensagens anteriores\" logo após conectar (escanear o QR Code). Assim que você conecta, o próprio WhatsApp envia automaticamente um lote grande de histórico recente — se você importar nesse momento, esse lote também é aproveitado; se esperar, só é possível estender aos poucos as conversas já conhecidas.",
      nativeImportAutoSyncNote: "Esta é a sincronização automática em segundo plano desta conexão — ela não usa o período escolhido no botão \"Importar mensagens anteriores\". A importação do período que você pediu está rodando separadamente (o total acima não reflete o filtro de data).",
      parameterizeFilter: "Parametrize o filtro",
      intervalValue: "Valor do Intervalo",
      sendHowManyTimes: "Enviar quantas vezes",
      sendNormallyNonBusiness: "Enviar normalmente em dias não úteis",
      sendBusinessDayBefore: "Enviar um dia útil antes",
      sendBusinessDayAfter: "Enviar um dia útil depois",
      showUser: "Mostrar Usuário",
      users: "Usuários",
      createTicket: "Criar Ticket",
      filterByTags: "Filtro por Tags",
      unknown: "Desconhecido",
      accessTicket: "Acessar Ticket",
      downloadFile: "Baixar arquivo",
      clickToDownload: "📎 Clique para baixar",
      select: "Selecionar",
      options: "Opções",
      reviewAndPay: "Revisar e pagar",
      followUpInfo: "Informações sobre Follow UP",
      salesReport: "Relatório de Vendas",
      startDate: "Data Inicial",
      endDate: "Data Final",
      agent: "Atendente",
      all: "Todos",
      generating: "Gerando...",
      generateReport: "Gerar Relatório",
      totalSales: "Total de Vendas",
      totalSalesValue: "Valor Total de Vendas",
      nonSales: "Não Vendas",
      avgTicketsPerAgent: "Média de Tickets por Atendente",
      nonSaleReasons: "Motivos de Não Venda",
      closedTickets: "Tickets Finalizados",
      saleValue: "Valor da Venda",
      nonSaleReason: "Motivo da Não Venda",
      closingReason: "Motivo da Finalização",
      closingReasonFilter: "Motivo da Finalização",
      nonSaleReasonFilter: "Motivo da Não Venda",
      agentPerformance: "Desempenho por Atendente",
      totalTickets: "Total de Tickets",
      avgTickets: "Média de Tickets",
      date: "Data",
      allowCrossQueueTicket: "Permitir abrir ticket em qualquer setor/conexão",
      refresh: "Atualizar",
      openNewTab: "Abrir em nova aba",
      whatsappConnection: "Conexão WhatsApp",
      tagUsed: "Tag Utilizada",
      notSpecified: "Não especificado",
      downloadSampleSheet: "Baixar Planilha Exemplo",
      saveFlow: "Salvar Fluxo",
      intervals: "Intervalos",
      // WavoipCall
      connected: "Conectado",
      connecting: "Conectando...",
      unknownNumber: "Número desconhecido",
      incomingCall: "Chamada recebida",
      readyForCalls: "Pronto para chamadas",
      connectingToServer: "Conectando ao servidor...",
      minimize: "Minimizar",
      backspace: "Apagar",
      unmute: "Desmutar",
      mute: "Mutar",
      endCall: "Encerrar",
      answerCall: "Atender",
      rejectCall: "Rejeitar",
      makeCall: "Ligar",
      typeNumberToCall: "Digite um número para ligar",
      calling: "Chamando...",
      inCall: "Em chamada",
      numberTooShort: "Número muito curto",
      numberTooLong: "Número muito longo",
      callError: "Erro ao realizar chamada",
      recordAudio: "Gravar Áudio",
      recording: "Gravando...",
      audioRecorded: "Áudio gravado",
      confirmOrDelete: "Clique em ✓ para confirmar ou 🗑️ para excluir",
      // FloupDashboard
      dashboardSubtitle: "Acompanhe o progresso dos seus fluxos de follow up",
      totalContacts: "Total Contatos",
      active: "Ativos",
      paused: "Pausados",
      withErrors: "Com Erros",
      steps: "Etapas",
      completionRate: "Taxa Conclusão",
      responseRate: "Taxa Resposta",
      contactDistribution: "Distribuição de contatos por etapa",
      searchContact: "Buscar contato...",
      allChannels: "Todos canais",
      allFilter: "Todos",
      withErrorsFilter: "Com Erros",
      pausedFilter: "Pausados",
      noContact: "Nenhum contato",
      noStepFound: "Nenhuma etapa encontrada",
      noHistoryFound: "Nenhum histórico encontrado",
      lastSendError: "Erro no último envio",
      step: "Etapa",
      resume: "Retomar",
      pause: "Pausar",
      history: "Histórico",
      timelineFollowUp: "Timeline de Follow Up",
      created: "Criado",
      sent: "Enviado",
      next: "Próximo",
      inactive: "Inativo",
      awaitingExecution: "Aguardando execução",
      awaitingExecutionShort: "Aguardando",
      // CampaignReport
      deliveryStatus: "Status de Entrega",
      delivered: "Entregues",
      waiting: "Aguardando",
      failures: "Falhas",
      messagesSent: "Mensagens Enviadas",
      uniqueRecipients: "Destinatários Únicos",
      messagesDelivered: "Mensagens Entregues",
      messageDetails: "Detalhes das Mensagens",
      exportExcel: "Exportar Excel",
      rowsPerPage: "Linhas por página:",
      chipDelivered: "Entregue",
      chipPending: "Pendente",
      chipFailed: "Falha",
      chipUnknown: "Desconhecido",
      loading: "Carregando...",
      noMessagesFound: "Nenhuma mensagem encontrada",
      notScheduled: "Não agendado",
      notCompleted: "Não concluído",
      // TemplateManager
      approved: "Aprovado",
      pending: "Pendente",
      rejected: "Rejeitado",
      // CampaignContactSelector
      noContactInList: "Nenhum contato nesta lista ainda.",
      importViaExcelOrWhatsapp: "Importe via Excel ou do WhatsApp usando os botões acima.",
      loadingTags: "Carregando tags...",
      noTagAvailable: "Nenhuma tag disponível.",
      selectAllShown: "Selecionar todos ({{count}} exibidos)",
      noContactFound: "Nenhum contato encontrado.",
      trySearchOther: "Tente buscar por outro nome ou número.",
      clickNewListToStart: "Clique em \"Nova Lista\" para começar.",
      filterByTag: "Filtrar por tag:",
      clearTags: "Limpar ({{count}})",
      addingToList: "Adicionando à lista:",
      addToList: "Adicionar {{count}} à lista",
      listCreatedImport: "Lista \"{{name}}\" criada! Agora importe os contatos (opcional).",
      dragExcelHere: "Arraste o Excel aqui ou clique para selecionar",
      acceptedFormats: "Formatos aceitos: .xls, .xlsx",
      downloadTemplate: "📥 Baixar planilha modelo (.xlsx)",
      skipImport: "Pular importação",
      nameListHint: "Dê um nome para identificar esta lista de contatos.",
      characters: "caracteres",
      listNameMinLength: "O nome deve ter pelo menos 2 caracteres.",
      listCreatedSuccess: "Lista \"{{name}}\" criada com sucesso!",
      contactsAddedToList: "{{count}} contato(s) adicionado(s) à lista \"{{name}}\"!",
      listSelectedForCampaign: "Lista \"{{name}}\" selecionada para a campanha!",
      backToCampaign: "Voltar para a Campanha →",
      excelModel: "Modelo Excel",
      importExcel: "Importar Excel",
      loadMore: "Carregar mais",
      contactLists: "Listas de Contatos",
      contactListsSubtitle: "Crie listas, importe contatos e selecione a lista que será usada nesta campanha.",
      simpleList: "Lista Simples",
      newListExcel: "Nova Lista + Excel",
      selectedListLabel: "Lista selecionada: {{name}}",
      selectedListDesc: "{{count}} contatos — esta lista será usada na campanha",
      remove: "Remover",
      deleteListConfirm: "Excluir a lista \"{{name}}\"?",
      // MessageUploadMedias
      addCaption: "Adicione uma legenda (opcional)",
      previewNotAvailable: "Visualização não disponível",
      // QueueFilter
      departments: "Departamentos",
      // MessageModal
      name: "Nome",
      // TagsContainer
      noTagFound: "Nenhuma tag encontrada. Digite para criar uma nova.",
      // Contacts import modal
      selectWhatsappConnection: "Selecione a conexão WhatsApp de onde deseja importar os contatos:",
      noWhatsappConnectionFound: "Nenhuma conexão WhatsApp conectada encontrada.",
      cancel: "Cancelar",
      import: "Importar",
      imageNotAvailable: "Imagem não disponível",
    },
    todoList: {
      title: "Lista de Tarefas",
      counter: "{{pending}} pendente(s) de {{total}} tarefa(s)",
      newTask: "Nova tarefa",
      editTask: "Editar tarefa",
      add: "Adicionar",
      save: "Salvar",
      cancel: "Cancelar",
      priority: "Prioridade",
      category: "Categoria",
      status: "Status",
      dueDate: "Vencimento",
      assignTo: "Atribuir a",
      nobody: "Ninguém",
      notes: "Observações",
      notesLabel: "Notas",
      search: "Buscar...",
      allTabs: "Todas",
      pendingTabs: "Pendentes",
      doneTabs: "Concluídas",
      allPriorities: "Todas",
      allUsers: "Todos",
      sortBy: "Ordenar",
      sortCreatedAt: "Data de criação",
      sortPriority: "Prioridade",
      sortDueDate: "Vencimento",
      sortManual: "Manual (arrastar)",
      user: "Usuário",
      priorities: { high: "Alta", medium: "Média", low: "Baixa" },
      statuses: { pending: "Pendente", in_progress: "Em Andamento", done: "Concluída" },
      categories: { general: "Geral", work: "Trabalho", personal: "Pessoal", urgent: "Urgente", study: "Estudo" },
      emptyNoTasks: "Nenhuma tarefa criada ainda",
      emptyFiltered: "Nenhuma tarefa encontrada",
      emptyAddFirst: "Adicione sua primeira tarefa acima!",
      emptyAdjustFilters: "Tente ajustar os filtros",
      dueSoonAlert: "tarefa(s) vence(m) em breve:",
      overdue: "Atrasada!",
      subtasks: "Subtarefas",
      newSubtask: "Nova subtarefa...",
      createdBy: "Criada por",
      assignedTo: "Atribuída a",
      deleteTitle: "Confirmar exclusão",
      deleteMessage: "Deseja realmente excluir esta tarefa?",
      deleteConfirm: "Excluir",
      toasts: {
        loadError: "Erro ao carregar tarefas",
        saveError: "Erro ao salvar tarefa",
        statusError: "Erro ao atualizar status",
        deleteError: "Erro ao excluir tarefa",
        subtaskError: "Erro ao atualizar subtarefas",
      },
    },
    accountSwitch: {
      title: "Suas Contas",
      subtitle: "Selecione uma conta para trocar automaticamente",
      addAccount: "Adicionar conta",
      savePassword: "Salvar Senha",
      saveCurrentPassword: "Salvar Senha da Conta Atual",
      email: "Email",
      password: "Senha",
      cancel: "Cancelar",
      save: "Salvar",
      admin: "Admin",
      agent: "Atendente",
      saved: "Salva",
      noPassword: "Sem senha",
      active: "ATIVA",
      passwordHelper: "A senha é salva localmente para troca rápida de conta",
      saveWarning: "Salve sua senha para habilitar troca rápida",
      label: "Nome para identificação (opcional)",
      labelHelper: "Ex: Administrativo, Comercial - apenas para organizar",
      editLabel: "Editar nome da conta",
      toasts: {
        accountAdded: "Conta validada e adicionada!",
        invalidCredentials: "Credenciais inválidas. Verifique email e senha.",
        passwordSaved: "Senha salva com sucesso!",
        cannotRemoveActive: "Não é possível remover a conta ativa.",
        accountRemoved: "Conta removida.",
        noCredentials: "Credenciais não salvas. Salve a senha primeiro.",
        connectedAs: "Conectado como {{name}}",
        labelUpdated: "Nome atualizado!",
        saveFailed: "Não foi possível salvar. Armazenamento local pode estar cheio.",
      },



    },
    templateManagerExtraV2: {
      deleteTemplateConfirm: "Excluir template \"{{name}}\"?",
      headerTypeTitle: "Cabeçalho:",
      headerTypeNone: "Nenhum",
      headerTypeText: "Texto",
      headerTypeImage: "Imagem",
      headerTypeVideo: "Vídeo",
      headerTypeDocument: "Documento",
      mediaUrlImageLabel: "URL pública da imagem (sample para aprovação)",
      mediaUrlVideoLabel: "URL pública do vídeo (sample para aprovação)",
      mediaUrlDocumentLabel: "URL pública do documento (sample para aprovação)",
      mediaUrlHelper: "A Meta exige um exemplo. Cole uma URL HTTPS pública ou clique em 'Enviar arquivo' para hospedar agora. No envio, é possível trocar a mídia por uma anexada na campanha/conversa.",
      uploading: "Enviando...",
      uploadFile: "Enviar arquivo",
      uploadSuccess: "Arquivo enviado e URL preenchida.",
      uploadNoUrl: "Upload concluído, mas a URL não foi retornada.",
      fileNameLabel: "Nome do arquivo (opcional)",
      preview: "Pré-visualização",
      imageLoadError: "Não foi possível carregar a imagem desta URL.",
      documentFallback: "documento",
      openDocument: "Abrir documento",
      bodyRequiredTitle: "Corpo da mensagem *",
      insertVariable: "+ Inserir variável",
      varExamplesTitle: "Valores de exemplo (obrigatório para aprovação)",
      varExamplesDesc: "A Meta usa estes valores apenas para validar o template. Eles não aparecem no envio real.",
      varExampleLabel: "Exemplo para {{var}}",
      link: "Link",
      previewImage: "Imagem",
      previewVideo: "Vídeo",
      previewDocumentAttached: "Documento anexado",
      previewDocument: "Documento",
      seeAllOptions: "Ver todas as opções",
      previewVarsNote: "Os valores de exemplo são usados apenas para esta prévia.",
    },
    campaignModalExtraV2: {
      sectionHeader: "Cabeçalho",
      sectionBody: "Corpo",
      sectionFooter: "Rodapé",
      sectionButtons: "Botões",
      buttonFallback: "Botão",
      templateMediaAuto: "📎 Mídia automática do template ({{format}}): {{name}}",
      templateMediaSample: "📎 Mídia automática do template ({{format}}): exemplo aprovado pela Meta",
      templateMediaMissing: "⚠️ Template exige header {{format}}. Anexe um arquivo abaixo ou salve a mídia no template.",
      templateMediaAttached: "anexada",
      templateVarsTitle: "Variáveis do template",
      templateVarsDesc: "Preencha os valores que substituirão os placeholders {{...}} no envio.",
      varValuePlaceholder: "Valor para {{key}}",
      varAppearsIn: "Aparece em: {{sections}}",
      varSection: "Seção: {{section}}",
      messagePreviewTitle: "Prévia da mensagem",
      messagePreviewDesc: "Visualização com as variáveis substituídas. Tokens não preenchidos aparecem como {{...}}.",
      scheduleTimezoneHelper: "Fuso: {{tz}} ({{offset}})",
    },
    closeTicketModal: {
      title: "Fechar chamado",
      subtitle: "Você tem certeza que deseja fechar o chamado?",
      subject: "Assunto do chamado",
      selectPlaceholder: "Selecione",
      summary: "Resumo do atendimento",
      summaryPlaceholder: "Descreva o resumo do atendimento",
      cancel: "Cancelar",
      confirm: "Fechar chamado",
      addSubject: "Cadastrar novo assunto",
      newSubjectPlaceholder: "Nome do novo assunto",
      save: "Salvar",
      subjectAdded: "Assunto cadastrado com sucesso",
      requestRating: "Solicitar avaliação",
      ratingOn: "O cliente receberá a pesquisa de avaliação",
      ratingOff: "O atendimento será fechado sem avaliação",
      confirmWithoutRating: "Fechar sem avaliação",
      sendFarewell: "Enviar mensagem de despedida",
      farewellOn: "O cliente receberá a mensagem de despedida",
      farewellOff: "O atendimento será fechado sem mensagem de despedida",
    },
    ticketInlineLog: {
      create: "Conversa criada por {{user}}",
      open: "Conversa aberta por {{user}}",
      access: "{{user}} entrou na conversa",
      transfered: "Conversa transferida por {{user}}",
      receivedTransfer: "Conversa recebida por {{user}} na fila {{queue}}",
      pending: "Conversa movida para pendente (aguardando atendente)",
      closed: "Conversa resolvida por {{user}}",
      reopen: "Conversa reaberta por {{user}}",
      queue: "Conversa enviada para a fila {{queue}}",
      redirect: "Conversa redirecionada para a fila {{queue}}",
      chatBot: "Atendimento pelo chatbot",
      clientClosed: "Conversa encerrada pelo cliente",
    },
    ticketReport: {
      menuItem: "Relatório do atendimento",
      title: "Relatório do atendimento",
      filename: "relatorio-atendimento",
      contact: "Contato",
      ticketId: "Atendimento",
      subject: "Assunto do chamado",
      summary: "Resumo do atendimento",
      timing: "Tempo de atendimento",
      totalDuration: "Duração total",
      startedAt: "Início",
      closedAt: "Encerramento",
      connection: "Conexão",
      agents: "Atendentes",
      queues: "Filas percorridas",
      timeline: "Histórico do atendimento",
      notInformed: "Não informado",
      exportPDF: "Exportar PDF",
      close: "Fechar",
      duration: {
        days: "d",
        hours: "h",
        minutes: "min",
        seconds: "s",
      },
    },
    ticketsAdvanced: {
      ticket: "Ticket",
      services: "Atendimentos",
    },
    productSalesReport: {
      title: "Vendas de Produtos",
    },
    closingReport: {
      title: "Relatório de fechamento",
      filename: "relatorio-fechamento",
      startDate: "Data inicial",
      endDate: "Data final",
      subject: "Assunto do fechamento",
      allSubjects: "Todos os assuntos",
      filter: "Filtrar",
      exportExcel: "Exportar Excel",
      exportPDF: "Exportar PDF",
      total: "Total",
      clearFilters: "Limpar filtros",
      summary: {
        total: "Total de atendimentos",
        closed: "Fechados",
        pending: "Pendentes",
        open: "Em aberto",
        avgDuration: "Tempo médio",
      },
      noData: "Nenhum atendimento encontrado para os filtros selecionados",
      columns: {
        protocol: "Protocolo",
        contact: "Contato",
        agent: "Atendente",
        queue: "Fila",
        status: "Status",
        subject: "Assunto",
        summary: "Resumo",
        openDate: "Data de abertura",
        closeDate: "Data de fechamento",
        duration: "Duração",
      },
      statusLabels: {
        FECHADO: "Fechado",
        ABERTO: "Em aberto",
        PENDENTE: "Pendente",
        GRUPO: "Grupo",
        OPEN: "Em aberto",
        CLOSED: "Fechado",
        PENDING: "Pendente",
      },
    },
  },


};

export { messages };

// Appended by Lovable: WhatsApp Health
if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  messages["pt"].translations.whatsappHealth = {
    title: "Saúde dos Números (API Oficial)",
    updatedAt: "Atualizado em",
    refresh: "Atualizar",
    empty: "Nenhum número WhatsApp Oficial configurado.",
    unknown: "Desconhecido",
    verifiedName: "Nome verificado",
    messagingLimit: "Limite de mensagens (24h)",
    platform: "Plataforma",
    codeVerification: "Verificação do código",
    nameStatus: "Status do nome",
    accountReview: "Revisão da conta",
    businessVerification: "Verificação do negócio",
    wabaName: "Nome da WABA",
    phoneNumberId: "Phone Number ID",
    throughput: "Throughput"
  };
}

// Appended by Lovable: i18n for new screens
if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  messages["pt"].translations.webhookUnified = {
      "title": "Webhook Unificado Meta",
      "subtitle": "Um único webhook para todos os seus números oficiais",
      "description": "A Meta permite apenas uma URL de webhook por App. Esta ferramenta recebe os eventos de todos os números e roteia internamente pelo phone_number_id.",
      "openMeta": "Abrir Meta",
      "loadError": "Não foi possível carregar as informações do webhook. Verifique se a API Oficial está configurada e se há ao menos uma conexão oficial cadastrada.",
      "oneUrl": "uma URL"
  };
  messages["pt"].translations.templateManager = {
      "title": "Gerenciamento de Templates",
      "health": "Saúde",
      "webhookMeta": "Webhook Meta",
      "name": "Nome",
      "category": "Categoria",
      "marketing": "Marketing",
      "utility": "Utilidade",
      "authentication": "Autenticação"
  };
  Object.assign(messages["pt"].translations.whatsappHealth = messages["pt"].translations.whatsappHealth || {}, {
      "searchPlaceholder": "Buscar número, WABA, nome...",
      "downloadPdf": "Baixar PDF",
      "history": "Histórico",
      "templates": "Templates",
      "templatesTooltip": "Gerenciar templates de mensagem da Meta",
      "reloadTooltip": "Recarregar",
      "historyTooltip": "Relatórios diários gerados automaticamente às 09:00",
      "statConnected": "Números conectados",
      "statHigh": "Qualidade alta",
      "statMedium": "Qualidade média",
      "statAttention": "Atenção / erros",
      "summaryTitle": "Mensagens via API Oficial",
      "summarySub": "Tempo real · últimas 24h",
      "sent": "Enviadas",
      "delivered": "Entregues",
      "availableMeta": "Disponíveis pela Meta",
      "of": "de",
      "usage24h": "Uso da janela 24h",
      "limit24h": "Limite (24h)",
      "shipments24h": "ENVIOS · 24H",
      "sentLow": "enviadas",
      "deliveredLow": "entregues",
      "available": "Disponível",
      "emptyAll": "Nenhum número oficial encontrado.",
      "emptyFiltered": "Nenhum resultado para a busca.",
      "unlimited": "Ilimitado"
  });
  messages["pt"].translations.campaignWizard = {
      "stepsLabel": "ETAPAS",
      "configuration": "Configuração",
      "campaignTab": "Campanha",
      "campaignTabSub": "Mensagens, agendamento e ticket",
      "contactsTab": "Listas de Contatos",
      "contactsTabSub": "Selecionar destinatários",
      "settingsTab": "Configurações",
      "settingsTabSub": "Intervalos e anti-ban",
      "preview": "PREVIEW",
      "back": "← Voltar",
      "continue": "Continuar →",
      "close": "Fechar",
      "save": "Salvar",
      "step1": "Identificação",
      "step2": "Distribuição",
      "step3": "Agendamento",
      "step4": "Ticket",
      "step5": "Mensagem",
      "step6": "Contatos",
      "identificationTitle": "IDENTIFICAÇÃO DA CAMPANHA",
      "distributionTitle": "DISTRIBUIÇÃO DOS DISPAROS",
      "scheduleTitle": "AGENDAMENTO",
      "ticketTitle": "TICKET",
      "messageTitle": "MENSAGEM & PRÉ-VISUALIZAÇÃO",
      "contactsTitle": "LISTA DE CONTATOS",
      "splitByConnection": "Dividir disparos em blocos por conexão",
      "connectionsOrder": "Conexões (em ordem de bloco)",
      "connectionsHelp": "A ordem da seleção define qual conexão atende cada bloco.",
      "contactsPerBlock": "Contatos por bloco",
      "sequentialBlocks": "Sequencial entre blocos",
      "recurrenceTitle": "Configuração de Recorrência",
      "enableRecurrence": "Habilitar recorrência",
      "intervalsTitle": "Intervalos de Disparo",
      "intervalsSubtitle": "Configure os intervalos de tempo entre disparos para evitar bloqueios.",
      "randomInterval": "Intervalo de disparo aleatório",
      "biggerIntervalAfter": "Intervalo maior depois de",
      "biggestInterval": "Intervalo de envio maior",
      "antiBan": "Anti-Ban",
      "antiBanSub": "Humaniza o disparo para reduzir risco de bloqueio",
      "variation": "Variação aleatória (jitter)",
      "extraPauseEvery": "Pausa extra a cada N msgs",
      "extraPauseDuration": "Duração da pausa extra",
      "guardFill": "Preencha os campos de {step} para liberar as próximas etapas.",
      "previewLabel": "Preview",
      "messageOficialNote": "Para API Oficial, utilize o template selecionado ao lado. O campo de mensagem e anexo de mídia não estão disponíveis.",
      "followUpNote": "Follow-up disponível apenas para canais Baileys. Em campanhas via API Oficial, somente o template é enviado.",
      "campaignMessage": "Mensagem da Campanha",
      "msgPreviewSection": "MENSAGEM & PRÉ-VISUALIZAÇÃO",
      "subtitle": "Configure seus disparos em massa com inteligência",
      "previewClient": "Cliente",
      "previewOnline": "online",
      "previewToday": "Hoje",
      "previewMsg1Placeholder": "Digite a mensagem 1 para visualizar aqui…",
      "previewTemplatePlaceholder": "Selecione um template para visualizar aqui…"
  };
}

// Appended by Lovable: missing login + template summary keys
if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  messages["pt"].translations.login = messages["pt"].translations.login || {};
  messages["pt"].translations.login.form = Object.assign(messages["pt"].translations.login.form || {}, {
    emailPlaceholder: "Digite seu e-mail",
    passwordPlaceholder: "Digite sua senha"
  });
  messages["pt"].translations.login.noAccount = "Não tem uma conta?";
  messages["pt"].translations.login.secureNote = "Seus dados estão protegidos com criptografia de ponta a ponta.";

  messages["pt"].translations.templateManagerPage = messages["pt"].translations.templateManagerPage || {};
  messages["pt"].translations.templateManagerPage.summary = {
    total: "Total",
    approved: "Aprovados",
    pending: "Pendentes",
    rejected: "Rejeitados"
  };
}

// Appended by Lovable: Instagram/Facebook/FlowBuilder new modals
if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  const T = messages["pt"].translations;
  T.flowBuilderInstagramTriggerModal = {
    title: "Gatilho: Comentário no Instagram",
    account: "Conta Instagram",
    selectPost: "Selecione o post/reel (vazio = qualquer)",
    searchPlaceholder: "Buscar por legenda...",
    emptyHint: "Deixe vazio para disparar em qualquer post",
    noAccounts: "Nenhuma conta Instagram conectada",
    loading: "Carregando...",
    noResults: "Nenhum post encontrado",
    pasteIdManually: "Colar ID manualmente",
    chooseFromList: "Escolher da lista",
    mediaId: "ID da mídia (post/reel)",
    mediaIdPlaceholder: "Ex.: 17900000000000000",
    keyword: "Palavra-chave",
    add: "Adicionar",
    matchAny: "Disparar se contiver QUALQUER palavra",
    matchAll: "Disparar somente se contiver TODAS as palavras",
    hint: "Sem palavras-chave = dispara em qualquer comentário.",
    cancel: "Cancelar",
    save: "Salvar",
    noCaption: "sem legenda"
  };
  T.flowBuilderInstagramReplyModal = {
    title: "Responder comentário publicamente",
    hint: "Uma das variações será escolhida aleatoriamente para evitar repetição.",
    variation: "Variação",
    addVariation: "Adicionar variação",
    cancel: "Cancelar",
    save: "Salvar"
  };
  T.flowBuilderInstagramRewardModal = {
    title: "Enviar recompensa (arquivo/PDF)",
    selectFile: "Selecionar arquivo",
    uploading: "Enviando...",
    file: "Arquivo:",
    caption: "Legenda (opcional)",
    hint: "O arquivo será anexado a uma DM para o autor do comentário.",
    cancel: "Cancelar",
    save: "Salvar"
  };
  T.flowBuilderInstagramDmModal = {
    title: "Enviar DM (mensagem privada)",
    message: "Mensagem",
    hint: "Use ${nome} para variáveis. A DM é enviada ao autor do comentário.",
    cancel: "Cancelar",
    save: "Salvar"
  };
  T.facebookPostPreview = {
    fbPost: "Publicação do Facebook",
    yourComment: "Seu comentário:",
    viewPost: "Ver Publicação"
  };
  T.flowBuilderTestModal = {
    title: "Testar fluxo (simulação)",
    hintIntro: "Esta é uma simulação visual — nada é enviado de verdade. Use para conferir se a ordem dos nós está correta.",
    igDetected: "(Fluxo do Instagram detectado.)",
    genericDetected: "(Fluxo genérico detectado.)",
    commentLabel: "Comentário simulado",
    messageLabel: "Mensagem simulada",
    defaultComment: "Quero o PDF!",
    defaultMessage: "Olá",
    commentSimulated: "Simulando comentário recebido: \"{{text}}\"",
    messageSimulated: "Simulando mensagem recebida: \"{{text}}\"",
    simulatedUser: "Usuário simulado:",
    follows: "Segue a conta",
    notFollows: "Não segue",
    clickToToggle: "clique para alternar",
    clickStart: "Clique em Iniciar simulação para ver o passo a passo.",
    simulating: "Simulando...",
    start: "Iniciar simulação",
    clear: "Limpar",
    close: "Fechar",
    loopDetected: "Loop detectado — simulação interrompida.",
    end: "Fim do fluxo. ✅ ({{n}} passo(s) executado(s))",
    maxSteps: "Limite de passos atingido (100) — simulação interrompida.",
    noNodes: "Nenhum nó encontrado no fluxo.",
    nextNotFound: "Próximo nó (id={{id}}) não encontrado no fluxo.",
    step: {
      startTitle: "Início do fluxo", startDetail: "O fluxo foi iniciado.",
      igTriggerTitle: "Gatilho do Instagram", igTriggerDetail: "Aguardando comentário no post",
      keyword: "Palavra-chave", anyKeyword: "qualquer",
      igReplyTitle: "Responder comentário", igReplyDetail: "Responderia publicamente",
      igLikeTitle: "Curtir comentário", igLikeDetail: "O bot curtiria o comentário.",
      igFollowerTitle: "Verificar seguidor",
      igFollowerYes: "✓ Usuário SEGUE a conta — saída verde.",
      igFollowerNo: "✗ Usuário NÃO segue — saída vermelha.",
      igDmTitle: "Enviar DM", igDmDetail: "DM enviada",
      igRewardTitle: "Entregar recompensa", igRewardDetail: "Enviaria o arquivo",
      noText: "sem texto", emptyMsg: "(mensagem vazia)",
      messageTitle: "Mensagem",
      imageTitle: "Imagem", imageEmpty: "(imagem)",
      audioTitle: "Áudio", audioEmpty: "(áudio)",
      videoTitle: "Vídeo", videoEmpty: "(vídeo)",
      singleBlockTitle: "Bloco único", singleBlockDetail: "Conteúdo agrupado.",
      menuTitle: "Menu", menuDetail: "Menu com {{n}} opção(ões).",
      interactiveTitle: "Menu interativo", interactiveDetail: "Menu interativo", buttons: "botões",
      inputTitle: "Entrada", inputDetail: "Aguardaria entrada do usuário", variable: "variável",
      intervalTitle: "Intervalo", intervalDetail: "Aguardaria {{sec}}s.",
      randomTitle: "Randomizador", randomDetail: "Escolheria um caminho aleatório.",
      conditionTitle: "Condição", conditionDetail: "Compararia",
      ticketTitle: "Ticket", ticketDetail: "Criaria/atualizaria ticket.",
      tagTitle: "Tag", tagDetail: "Adicionaria tag",
      removeTagTitle: "Remover tag", removeTagDetail: "Removeria tag",
      switchFlowTitle: "Trocar de fluxo", switchFlowDetail: "Iria para o fluxo",
      attendantTitle: "Atendente", attendantDetail: "Transferiria para atendimento humano.",
      httpTitle: "Requisição HTTP", noUrl: "(sem URL)",
      variableTitle: "Variável", variableDetail: "Definiria",
      aiTitle: "Agente IA", aiDetail: "Responderia usando o agente de IA configurado.",
      typebotTitle: "Typebot", typebotDetail: "Integração com Typebot.",
      n8nTitle: "n8n", n8nDetail: "Integração com n8n.",
      asaasTitle: "Boleto Asaas", asaasDetail: "Geraria um boleto via Asaas.",
      genericTitle: "Nó", genericDetail: "Executaria este passo."
    }
  };
}

if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  messages["pt"].translations.login = messages["pt"].translations.login || {};
  messages["pt"].translations.login.or = "ou";
  messages["pt"].translations.login.buttons = messages["pt"].translations.login.buttons || {};
  messages["pt"].translations.login.buttons.google = "Continuar com Google";
  messages["pt"].translations.signup = messages["pt"].translations.signup || {};
  messages["pt"].translations.signup.buttons = messages["pt"].translations.signup.buttons || {};
  messages["pt"].translations.signup.buttons.google = "Cadastrar com Google";
  messages["pt"].translations.settings = messages["pt"].translations.settings || {};
  messages["pt"].translations.settings.settings = messages["pt"].translations.settings.settings || {};
  messages["pt"].translations.settings.settings.options = messages["pt"].translations.settings.settings.options || {};
  messages["pt"].translations.settings.settings.options.googleLogin = "Login com Google";
}

// Appended by Lovable: IVR / URA
if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  messages["pt"].translations.ivr = {
    menu: "URA / Filas",
    title: "Fluxos de URA",
    help: "Crie menus de atendimento por DTMF. As opções podem rotear para filas, atendentes ou ramais. O fallback é acionado em timeout ou erro de digitação.",
    new: "Novo fluxo",
    newTitle: "Novo fluxo de URA",
    editTitle: "Editar fluxo de URA",
    empty: "Nenhum fluxo cadastrado",
    disabled: "Desabilitado",
    save: "Salvar",
    cancel: "Cancelar",
    saved: "Fluxo salvo",
    confirmDelete: "Excluir este fluxo?",
    errors: { nameRequired: "Informe um nome", summaryTitle: "Corrija os erros abaixo antes de salvar:", digitRequired: "Tecla obrigatória", digitInvalid: "Use apenas 0-9, * ou #", digitDuplicate: "Tecla duplicada", targetRequired: "Destino obrigatório", extensionRequired: "Informe o ramal/número", submenuRequired: "Selecione a URA destino", submenuSelf: "Submenu não pode apontar para si mesmo", submenuMissing: "URA destino não existe", fallbackRequired: "Defina a ação de fallback", followMeNeedsUser: "Siga-me só funciona com destino Atendente", submenuCycle: "Encadeamento de URAs forma um ciclo", submenuTooDeep: "Encadeamento excede o limite de 5 níveis" },
    list: { options: "Opções", status: "Status" },
    fields: {
      name: "Nome",
      did: "DID (número entrante)",
      didHelp: "Opcional. Se vazio, vale para o fluxo padrão",
      isDefault: "Padrão",
      enabled: "Ativo",
      greetingText: "Texto de saudação (TTS)",
      greetingAudioUrl: "URL do áudio da saudação",
      timeout: "Timeout (s)",
      maxRetries: "Tentativas",
    },
    options: {
      title: "Opções DTMF",
      add: "Adicionar opção",
      digit: "Tecla",
      label: "Descrição",
      action: "Ação",
      target: "Destino",
      empty: "Nenhuma opção. Adicione teclas (1, 2, 3...).",
    },
    action: {
      queue: "Fila",
      user: "Atendente",
      extension: "Ramal externo", submenu: "Submenu (outra URA)",
      voicemail: "Caixa postal",
      hangup: "Encerrar",
    },
    target: { queue: "Fila", user: "Atendente", extension: "Ramal/Número", submenu: "URA destino" },
    fallback: {
      title: "Fallback (timeout / opção inválida)",
      useFollowMe: "Usar Siga-me do atendente quando indisponível",
    }, preview: { title: "Pré-visualização do fluxo", help: "Como a URA vai se comportar a cada tecla discada, incluindo submenus encadeados." },
  };
}

if (typeof messages !== "undefined" && messages["pt"] && messages["pt"].translations) {
  messages["pt"].translations.settings = messages["pt"].translations.settings || {};
  messages["pt"].translations.settings.nav = Object.assign(messages["pt"].translations.settings.nav || {}, {
    optionsDesc: "Configurações gerais",
    schedulesDesc: "Horários de atendimento",
    finalizacaoDesc: "Finalização do atendimento",
    companiesDesc: "Gerenciar empresas",
    plansDesc: "Planos e preços",
    helpsDesc: "Ajuda e suporte",
    googleCalendarDesc: "Integração de agenda",
  });
  messages["pt"].translations.transferTicketModalCustom = Object.assign(messages["pt"].translations.transferTicketModalCustom || {}, {
    connection: "Conexão",
  });
  messages["pt"].translations.templateMetaModal = Object.assign(messages["pt"].translations.templateMetaModal || {}, {
    empty: "Nenhum template encontrado",
  });
  messages["pt"].translations.whatsappHealth = Object.assign(messages["pt"].translations.whatsappHealth || {}, {
    reportsDialog: {
      title: "Relatórios diários (gerados às 09:00)",
      empty: "Nenhum relatório gerado ainda. Será gerado automaticamente amanhã às 09:00.",
      download: "Baixar",
      close: "Fechar",
    },
  });
  messages["pt"].translations.connections = Object.assign(messages["pt"].translations.connections || {}, {
    noResults: "Nenhuma conexão encontrada.",
    facebook: Object.assign(
      (messages["pt"].translations.connections || {}).facebook || {},
      { success: "Conexão do Facebook criada com sucesso!" }
    ),
    toasts: Object.assign(
      (messages["pt"].translations.connections || {}).toasts || {},
      {
        deleted: "Conexão excluída com sucesso!",
        webhookCopied: "Webhook copiado!",
        webhookNotReady: "O webhook ainda não foi gerado para esta conexão. Salve a conexão e tente de novo.",
      }
    ),
  });
  messages["pt"].translations.officialCall = Object.assign(messages["pt"].translations.officialCall || {}, {
    permissionTitle: "Pedir permissão para ligar",
    permissionBody: "A Meta só permite ligação feita pela empresa depois que o contato autoriza — e receber uma ligação dele não vale como autorização. Podemos mandar o pedido agora: ele recebe uma mensagem com os botões de permitir ou recusar. Autorizando, a ligação passa a funcionar por um período curto.",
    permissionLater: "Agora não",
    permissionAsk: "Enviar pedido",
    toasts: Object.assign(
      (messages["pt"].translations.officialCall || {}).toasts || {},
      {
        permissionSent: "Pedido de permissão enviado. Assim que o contato autorizar, é só ligar.",
        permissionFailed: "Não foi possível enviar o pedido de permissão.",
      }
    ),
  });
}

// === i18n: telas de Agendamento + Google Agenda ===
//
// As chaves destas duas telas ficam aqui, num merge explícito, e não
// inseridas no meio do objeto acima. Motivo concreto: estes arquivos têm
// indentação irregular, e ao inserir por texto os blocos caíram FORA de
// `translations` no arquivo turco — sem erro nenhum, apenas sem tradução.
// O merge abaixo escreve no lugar certo por referência, não por posição.
//
// O spread preserva o que já existir: se alguma chave for traduzida à mão
// mais acima, ela continua valendo.
const _t = messages.pt.translations;
Object.assign(_t, {
  scheduleGoogle: {
    ...(_t.scheduleGoogle || {}),
    ...{
  "title": "Integração Google Agenda & Meet",
  "connectedAs": "Conectado:",
  "connectAccount": "Conectar conta",
  "notConnectedHint": "Nenhuma conta do Google conectada. Conecte uma conta para sincronizar este agendamento na agenda e gerar link do Meet.",
  "syncCalendar": "Sincronizar no Google Agenda",
  "generateMeet": "Gerar Link do Google Meet",
  "eventTitle": "Título da Reunião / Assunto",
  "eventTitlePlaceholder": "Ex.: Reunião com o cliente",
  "duration": "Duração",
  "minutes": "minutos",
  "hour": "hora",
  "hours": "horas",
  "copyLink": "Copiar Link",
  "copied": "Copiado!",
  "openMeet": "Abrir Meet"
}
  },
  schedulesHeader: {
    ...(_t.schedulesHeader || {}),
    ...{
  "title": "Agendamento de Mensagens",
  "subtitle": "Programe e visualize disparos automáticos e lembretes em calendário interativo",
  "programmed": "Disparos Programados",
  "schedulesWord": "agendamentos",
  "cardTotal": "Total agendados",
  "cardTotalHint": "Disparos registrados no sistema",
  "cardToday": "Agendados para hoje",
  "cardTodayHint": "Envios programados para o dia",
  "cardWeek": "Próximos 7 dias",
  "cardWeekHint": "Previsão da semana",
  "cardPending": "Pendentes de envio",
  "cardPendingHint": "Aguardando horário de disparo",
  "googleCalendar": "Google Agenda",
  "newSchedule": "Novo Agendamento"
}
  },
  googleCalendar: {
    ...(_t.googleCalendar || {}),
    ...{
  "title": "Integração Google Agenda & Google Meet",
  "step1": "1. Credenciais da API do Google (OAuth 2.0)",
  "step1Sub": "Configure seu Client ID e Client Secret gerados no Google Cloud Console",
  "clientId": "Google Client ID",
  "clientSecret": "Google Client Secret",
  "redirectUri": "URI de Redirecionamento Autorizada (Cole no Google Cloud)",
  "jsOrigin": "Origem JavaScript Autorizada (Cole no Google Cloud)",
  "saveCredentials": "Salvar Credenciais da API",
  "credentialsSaved": "Credenciais salvas.",
  "credentialsFail": "Não foi possível salvar as credenciais.",
  "copied": "Copiado!",
  "howToTitle": "Ver Passo a Passo: Como gerar o Client ID e Client Secret no Google Cloud (2 Minutos)",
  "how1": "Acesse console.cloud.google.com e crie (ou escolha) um projeto.",
  "how2": "Em APIs e serviços → Biblioteca, ative a Google Calendar API.",
  "how3": "Em Tela de permissão OAuth, configure como Externo e publique.",
  "how4": "Em Credenciais → Criar credenciais → ID do cliente OAuth, escolha Aplicativo da Web.",
  "how5": "Cole os dois valores acima nos campos de origens e URIs de redirecionamento autorizados.",
  "how6": "Copie o Client ID e o Client Secret gerados e cole aqui em cima.",
  "step2": "2. Conexão da Conta Google",
  "step2Sub": "Conecte a conta que gerenciará as reuniões e o Meet",
  "connectionStatus": "STATUS DA CONEXÃO",
  "connectedAccount": "CONTA CONECTADA",
  "connected": "Conectado",
  "connectedAs": "Conectado",
  "disconnect": "Desconectar",
  "disconnectAccount": "Desconectar Conta",
  "openCalendar": "Abrir Google Agenda",
  "connect": "Conectar Google Agenda",
  "notConnected": "Nenhuma conta Google conectada para esta empresa.",
  "confirmDisconnect": "Desconectar a conta do Google desta empresa?",
  "defaultCalendar": "Agenda padrão",
  "primary": "primary (padrão)",
  "main": "principal",
  "defaultDuration": "Duração Padrão das Reuniões",
  "timezone": "Fuso horário",
  "timezoneHelp": "Ex.: America/Sao_Paulo",
  "save": "Salvar configurações",
  "saving": "Salvando...",
  "subtitle": "Conecte uma conta Google para criar eventos e reuniões a partir dos agendamentos.",
  "prefsTitle": "Preferências do Google Meet & Agendamentos",
  "prefsSubtitle": "Defina como os eventos e reuniões serão criados",
  "autoMeet": "Gerar Google Meet Automaticamente",
  "autoMeetHelp": "Cria um link de videoconferência exclusivo em cada agendamento",
  "syncEvents": "Sincronizar Eventos no Google Agenda",
  "syncEventsHelp": "Insere os agendamentos marcados no seu calendário do Google",
  "sendInvite": "Enviar Convite por E-mail ao Cliente",
  "sendInviteHelp": "O Google enviará convite automático se o contato possuir e-mail cadastrado",
  "errors": {
    "credentialsMissing": "O Google Agenda ainda não foi liberado nesta plataforma. Peça ao administrador para cadastrar o Client ID e o Client Secret do Google.",
    "redirectMissing": "Não foi possível identificar o endereço do servidor para o retorno do Google. Avise o administrador."
  },
  "toast": {
    "connected": "Google Agenda conectado!",
    "connectFail": "Falha ao conectar: ",
    "unknownError": "erro desconhecido",
    "authUrlError": "Não foi possível iniciar a conexão com o Google.",
    "disconnected": "Conta desconectada.",
    "disconnectError": "Não foi possível desconectar.",
    "saved": "Configurações salvas.",
    "saveError": "Não foi possível salvar."
  }
}
  },
});
